webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var cloud = __webpack_require__(5);
	var Header = __webpack_require__(38);
	var Nav = __webpack_require__(41);
	var Footer = __webpack_require__(58);
	var validator = __webpack_require__(52);
	__webpack_require__(62);
	__webpack_require__(63);
	__webpack_require__(64);
	__webpack_require__(65);
	__webpack_require__(66);
	__webpack_require__(67);
	var locale = __webpack_require__(18);
	var dialog = __webpack_require__(11);
	var Content = __webpack_require__(68);
	var qrcode = __webpack_require__(82);
	
	var Captcha = __webpack_require__(83);
	
	/**
	 * 判断是否为IE9以下浏览器
	 * flag为false时，浏览器为为IE9或IE10
	 */
	var flag = function () {
	  var bua = navigator.userAgent;
	  var reg = new RegExp("MSIE ([5,6,7,8][/.0-9]{0,})");
	  return !reg.exec(bua);
	}();
	
	
	var validateEmail = function (email) {
	  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	  return re.test(email);
	};
	
	$(function () {
	  $('body').show();
	  if (!flag) {//浏览器为为IE9以下时做如下操作
	    $("<div id='tip_top' class='tip_top'></div>")
	      .appendTo("body")
	      .css({
	        "height": (document.documentElement.clientHeight / 2),
	        "width": document.documentElement.clientWidth,
	        "top": -(document.documentElement.clientHeight / 2)
	      }).animate({top: "0px"}, 300, function () {
	      $("<div id='tip_content' class='tip_content'></div>").html("<div class='text_div_1'><image class='inhand_logo' src='./resources/images/Logo-InHand.png' />" +
	        "<p class='text_title'>浏览器不受支持</p>" +
	        "<p class='text_content'>使用当前浏览器，无法获得最佳体验，建议使用最新的" +
	        "<a class='browser_link' href='http://www.firefox.com.cn'>Firefox</a>或" +
	        "<a class='browser_link' href='http://www.google.cn/intl/zh-CN/chrome/browser/'>Chrome</a>浏览器</p></div>" +
	        "<div class='text_div_2'>" +
	        "<p class='text_title'>Browser Tip</p>" +
	        "<p class='text_content'>Suggest to select the latest version of " +
	        "<a class='browser_link' href='http://www.mozilla.org/en-US/firefox/new/'>Firefox</a> or " +
	        "<a class='browser_link' href='https://www.google.com/intl/en/chrome/browser/'>Chrome</a> browser</p></div>"
	      ).appendTo("body").css({
	        "top": ((document.documentElement.clientHeight / 2) - 125) + "px",
	        "left": ((document.documentElement.clientWidth / 2) - 225) + "px"
	      });
	      $("<div class='ignore_button'></div>").appendTo($("#tip_content")).text("Skip").mouseover(function () {
	        $(this).css({
	          "cursor": "pointer",
	          "font-weight": "bold"
	        })
	          .mousedown(function () {
	            $(this).css({
	              "border-right": "2px solid #dddddd",
	              "border-bottom": "2px solid #dddddd"
	            })
	          })
	          .mouseout(function () {
	            $(this).css({
	              "border-right": "2px solid #7E807C",
	              "border-bottom": "2px solid #7E807C",
	              "font-weight": "normal"
	            })
	          })
	      }).click(function () {
	        $("#tip_bottom").animate({top: (document.documentElement.clientHeight) + "px"}, 300, function () {
	          $(this).remove()
	        });
	        $("#tip_top").animate({top: -(document.documentElement.clientHeight / 2) + "px"}, 300, function () {
	          $(this).remove()
	        });
	        $("#tip_content").fadeOut(300, function () {
	          $(this).remove()
	        });
	      })
	    });
	    $("<div id='tip_bottom' class='tip_bottom'></div>").appendTo("body").css({
	      "height": (document.documentElement.clientHeight / 2),
	      "width": document.documentElement.clientWidth,
	      "top": document.documentElement.clientHeight
	    }).animate({top: (document.documentElement.clientHeight / 2) + "px"}, 300)
	  }
	
	  new Index();
	});
	
	var Index = Class.create(cloud.Component, {
	  loginType: 'password',
	  initialize: function ($super, options) {
	//            $super(options);
	    var self = this;
	    this.header = null;
	    this.navigate = null;
	    this.footer = null;
	    this._render();
	    $("#home-input-user").focus();
	  },
	
	  _render: function () {
	    var self = this;
	    $('#content').html(Content);
	    this._renderHeader();
	    this._renderNav();
	    this._renderFooter();
	    this._effects();
	    this._events();
	    this._validator();
	    this._locale();
	    this._setAboutUsLink();
	    this._renderQRcode();
	    this._emailAutoComplete();
	    this._getMobileCode();
	
	    this.loginCaptcha = new Captcha({selector: $(".login-captcha")});
	
	    $("#home-input-pwd-password").focus(
	      function () {
	        if ($(this).attr("type") == "text") {
	          $(this)[0].type = "password";
	        }
	      }
	    );
	    $("#download-dt-client").attr("href", __webpack_require__(85));
	    $('#switch-to-code').click(function () {
	      self.loginType = 'phone';
	      $('.password', '#login-form').hide();
	      $('.phone', '#login-form').show();
	    });
	    $('#switch-to-password').click(function () {
	      self.loginType = 'password';
	      $('.password', '#login-form').show();
	      $('.phone', '#login-form').hide();
	    });
	
	    $('#send-sms').click(function () {
	      var phone = $(".mobile-code").val() + $('#home-input-phone').val().trim();
	      return self.sendCodeHandler.call(self, phone, $(this));
	    });
	    $('#register-send-sms').click(function () {
	      var phone = $('#register-input-user').val().trim();
	      return self.sendCodeHandler.call(self, phone, $(this));
	    });
	
	    $('a.content-link-login', '.home-content-login-title').click(self.showLoginForm.bind(this));
	    $('a.content-link-register', '.home-content-login-title').click(self.showRegisterForm.bind(this));
	
	    $('#home-link-terms').click(self.showTerms);
	
	    $('.phone', '#register-form').hide();
	    $('.captcha', '#register-form').show();
	
	  },
	
	  _getMobileCode: function () {
	    var mobileCode, autoLi;
	    mobileCode = $('#js-select-country');
	    autoLi = mobileCode.find('li');
	    $('.mobile-box').click(
	      function (e) {
	        var e = e || event;
	        e.stopPropagation();
	        if ($(".mobile-trigon").attr("name") == "trigon-up") {
	          $(".mobile-trigon").removeClass("mobile-trigon-up").addClass("mobile-trigon-dowm").attr("name", "trigon-down");
	          mobileCode.hide();
	        } else {
	          $(".mobile-trigon").removeClass("mobile-trigon-dowm").addClass("mobile-trigon-up").attr("name", "trigon-up");
	          mobileCode.show();
	        }
	      }
	    )
	
	    $(document).click(function () {
	      mobileCode.hide();
	      $(".mobile-trigon").removeClass("mobile-trigon-up").addClass("mobile-trigon-dowm").attr("name", "trigon-down");
	    });
	
	    autoLi.mouseover(function () {
	      $(this).siblings().filter('.hover').removeClass('hover');
	      $(this).addClass('hover');
	    }).mouseout(function () {
	      $(this).removeClass('hover');
	    }).mousedown(function () {
	      $(".mobile-code").val($(this).find(".li-code").html());
	      mobileCode.hide();
	      $(".mobile-trigon").removeClass("mobile-trigon-up").addClass("mobile-trigon-dowm").attr("name", "trigon-down");
	    });
	  },
	
	  sendCodeHandler: function (phone, btn) {
	    var self = this;
	    var sendCodeFailedHandler = function (data) {
	      btn.removeAttr("disabled");
	      self.loginErrorHandler.call(self, data);
	    };
	
	    if (btn.attr("disabled") != "disabled") {
	      btn.attr('disabled', 'disabled');
	      self.validateAccount(phone).done(function (phone) {
	        $.ajax({
	          url: "/api/sms/code",
	          data: {phone: phone}
	        }).done(function (data) {
	          if (data.result) {
	            var seconds = 90;
	            btn.text(seconds + ' ' + locale.get('full_seconds')).attr('disabled', 'disabled');
	            var id = setInterval(function () {
	              seconds--;
	              if (seconds > 0) {
	                btn.text(seconds + ' ' + locale.get('full_seconds'));
	              } else {
	                clearInterval(id);
	                btn.removeAttr("disabled");
	                btn.text(locale.get('send_sms_code'));
	              }
	            }, 1000);
	          } else {
	            sendCodeFailedHandler(data);
	          }
	
	        }).fail(sendCodeFailedHandler);
	      }).fail(sendCodeFailedHandler);
	    }
	    return false;
	  },
	
	  showLoginForm: function (e) {
	    var lang = localStorage.getItem("language");
	    if (lang == 'en') {
	      $(".login-title-slide-bar").css({"margin": "0 .3em", "width": "3.5em"});
	    } else {
	      $(".login-title-slide-bar").css("width", "2.4em");
	    }
	    $('#login-form').show();
	    $('#register-form').hide();
	
	    $(e.target).addClass('active');
	    $('a.content-link-register', '.home-content-login-title').removeClass("active");
	    $('.login-title-slide-bar').removeClass('right');
	
	  },
	
	  showRegisterForm: function (e) {
	    var lang = localStorage.getItem("language");
	    if (lang == 'en') {
	      $(".login-title-slide-bar").css({"margin": "0 .2em", "width": "3.7em"});
	    } else {
	      $(".login-title-slide-bar").css("width", "2.4em");
	    }
	    $('#login-form').hide();
	    $('#register-form').show();
	
	    if (!this.registerCaptcha) {
	      this.registerCaptcha = new Captcha({
	        selector: $('.register-captcha')
	      });
	    }
	
	    $(e.target).addClass('active');
	    $('a.content-link-login', '.home-content-login-title').removeClass("active");
	    $('.login-title-slide-bar').addClass('right');
	
	  },
	  /*邮箱自动补全功能*/
	  _emailAutoComplete: function () {
	    $('#home-input-user').completer({
	      source: [
	        "inhand.com.cn",
	        "qq.com",
	        "126.com",
	        "163.com",
	        "sina.com",
	        "sohu.com",
	        "gmail.com",
	        "icloud.com",
	        "outlook.com",
	        "googlemail.com",
	        "yahoo.com",
	        "hotmail.com",
	        "live.com",
	        "msn.com",
	        "verizon.net",
	        "facebook.com",
	        "me.com",
	        "mac.com",
	        "139.com",
	        "189.com",
	        "wo.com.cn"
	      ],
	      separator: '@'
	    });
	  },
	  _renderQRcode: function () { //使用插件生成二维码的方法
	    var qr = qrcode.qrcode(6, 'M');
	
	    var host = window.location.host;
	
	    qr.addData("http://" + host + "/DeviceNetwork/downloads/Alarm.apk");
	    qr.make();
	    var imgTag = qr.createImgTag(6);
	    $(".alarm-app-qrcode").append(imgTag);
	  },
	  _locale: function () {
	    locale.render();
	  },
	  _setAboutUsLink: function () {
	    var lang = localStorage.getItem("language");
	    if (lang == 'en') {
	      $("#home-nav-aboutus").children("a").attr("href", "http://www.inhandnetworks.com/");
	    } else if (lang == 'zh_CN') {
	      $("#home-nav-aboutus").children("a").attr("href", "http://www.inhand.com.cn/");
	    } else {
	      $("#home-nav-aboutus").children("a").attr("href", "http://www.inhandnetworks.com/");
	    }
	  },
	  _renderHeader: function () {
	    this.header = new Header({
	      selector: "#common-header"
	    });
	  },
	
	  _renderNav: function () {
	    this.nav = new Nav({
	      selector: "#common-nav",
	      windowElement: "#home-content",
	      current: 0
	    });
	  },
	
	  _renderFooter: function () {
	    this.footer = new Footer({
	      selector: "#common-footer",
	      contentElement: "#home-content"
	    });
	
	  },
	
	  showTerms: function () {
	    var self = this;
	    __webpack_require__.e/* nsure */(2, function () {/* WEBPACK VAR INJECTION */(function($) {
	      var Window = __webpack_require__(45);
	      var marked = __webpack_require__(86);
	      marked.setOptions({
	        gfm: true
	      });
	      var language = locale.current() == 1 ? 'en' : 'zh_CN';
	      var md = __webpack_require__(87)("./" + language + '.md');
	      __webpack_require__(90);
	
	      self.termWindow = new Window({
	        container: $('#home-content'),
	        id: "term-window",
	        title: locale.get('service_terms'),
	        top: "center",
	        left: "center",
	        height: 400,
	        width: 600,
	        mask: true,
	        drag: true,
	        content: $('<div>').addClass("markdown-body").css({
	          "font-size": '14px',
	          "padding": "10px 20px"
	        }).html(marked(md))
	      });
	      self.termWindow.show();
	    
	/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(1)))});
	  },
	
	  _validator: function () {
	    validator.render("#login-form", {
	      promptPosition: "topLeft",
	      scroll: false,
	      binded: false
	    });
	    var self = this;
	    validator.render("#register-form", {
	      promptPosition: "topLeft",
	      scroll: false,
	      binded: false,
	      onValidationComplete: function (data, status) {
	        if (status) {
	          self.submitRegister.call(self);
	        }
	      }
	    });
	  },
	  submitRegister: function () {
	    var username = $('#register-input-user').val();
	    var org = $('#register-input-org-name').val();
	    var password = cloud.util.md5($('#register-input-pwd-password').val());
	    validator.hide('#register-input-user');
	    var type = this.accountType(username);
	    var self = this;
	
	    this.validateAccount(username).done(function (username) {
	      var data = {
	        username: username,
	        name: org,
	        password: password
	      };
	      data[type] = username;
	      if (type == "phone") {
	        data.code = $('#register-input-sms-code').val();
	      } else {
	        data.picId = self.registerCaptcha.pictureId;
	        data.varificationCode = $("#register-input-ver-custom").val();
	      }
	
	      cloud.Ajax.request({
	        url: "api2/organizations?language=" + locale.current(),
	        type: "POST",
	        data: data,
	        error: function (data) {
	          if (data.error_code == 20007) {
	            if (data.error.indexOf(username) > -1) {
	              dialog.render({lang: "account_already_exsits"});
	            } else {
	              dialog.render({lang: "organization_already_exists"});
	            }
	          } else {
	            dialog.render({lang: data.error_code});
	          }
	          self.registerCaptcha.refresh();
	        },
	        success: function (data) {
	          Model.user({
	            method: "login",
	            data: {
	              username: username,
	              password: password,
	              password_type: 2
	            },
	            param: {
	              language: locale.current()
	            },
	            error: self.loginErrorHandler.bind(self)
	          });
	        }
	      });
	    }).fail(function () {
	      dialog.render({lang: 'invalid_email_or_phone_number'});
	    });
	
	  },
	
	
	  _showPasswordInput: function (focus) {
	    $("#home-input-pwd-text").hide();
	    $("#home-input-pwd-password").show();
	    if (focus) {
	      $("#home-input-pwd-password").focus();
	    }
	  },
	
	  _showVercodeInput: function (focus) {
	    $("#home-input-ver-default").hide();
	    $("#home-input-ver-custom").show();
	    if (focus) {
	      $("#home-input-ver-custom").focus();
	    }
	  },
	
	  _events: function () {
	    var self = this;
	    // 在输入框中给出提示
	    $("#home-input-pwd-text").focus(function () {
	      self._showPasswordInput(true);
	    });
	
	    $("#home-input-ver-default").focus(function () {
	      self._showVercodeInput(true);
	    });
	  },
	
	  _effects: function () {
	    var self = this;
	    $("#home-login-forget").bind("click", function () {
	      __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(49)]; (function (Forgetpass) {
	        var forgetpass = new Forgetpass({
	          windowElement: "#home-content"
	        });
	      }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
	    });
	    /* 登录按钮点击事件 */
	    $("#home-input-submit").bind("click", function () {
	      self._showPasswordInput();
	      self._showVercodeInput();
	      var $body = $("body");
	      if (validator.result("#login-form") && $body.find(".inhand-dialog").length == 0 && $body.find(".ui-window-content").length == 0) {
	        self._login();
	      }
	      return false;
	    });
	  },
	
	  loginErrorHandler: function (error) {
	    this.loginCaptcha.refresh();
	    var result = false;
	    if (error.error_code == 21304) {
	      var remainingTime = error.error.substring(error.error.indexOf("(") + 1, error.error.indexOf(")"));
	      dialog.render({
	        content: [{lang: 21304}, {html: "<span id='remaining-time'></span>"}, {lang: "seconds"}],
	        close: function () {
	          if (t) {
	            clearInterval(t)
	          }
	        }
	      });
	      var $remaining = $("#remaining-time");
	      $remaining.text(" " + remainingTime + " ");
	      function time() {
	        s = $remaining.text();
	        s = parseInt(s);
	        if (s <= 0) {
	          clearInterval(t);
	          dialog.close();
	          return;
	        }
	        $remaining.text(" " + (s - 1) + " ");
	      }
	
	      t = setInterval(function () {
	        time();
	      }, 1000);
	    } else if (error.error_code == 21306) {
	      dialog.render({
	        lang: error.error_code, buttons: [{
	          lang: "ok", click: function () {
	            dialog.close();
	            $("#home-input-ver-custom").focus();
	          }
	        }]
	      });
	    } else if (error.error_code == 20002) {
	      dialog.render({
	        lang: error.error_code, buttons: [{
	          lang: "ok", click: function () {
	            dialog.close();
	            $("#home-input-user").focus();
	          }
	        }]
	      });
	    } else if (error.error_code == 21302) {
	      if (result) {
	        dialog.render({
	          lang: error.error_code,
	          container: "#home-content-bottom-div-top",
	          buttons: [{
	            lang: "ok", click: function () {
	              dialog.close();
	              $("#home-input-user").focus();
	            }
	          }]
	        });
	      } else {
	        dialog.render({
	          lang: error.error_code,
	          buttons: [{
	            lang: "ok",
	            click: function () {
	              dialog.close();
	              $("#home-input-user").focus();
	            }
	          }]
	        });
	      }
	    } else if (error.error_code == 10017) {
	      dialog.render({lang: 'please_input_valid_phone'});
	    } else {
	      if (result) {
	        dialog.render({lang: error.error_code, container: "#home-content-bottom-div-top"});
	      } else {
	        dialog.render({lang: error.error_code});
	      }
	    }
	  },
	
	  accountType: function (email) {
	    return validateEmail(email) ? "email" : "phone";
	  },
	
	  validateAccount: function (username) {
	    var def = $.Deferred();
	    if (username == "admin") {
	      def.resolve(username);
	    } else if (username.indexOf('@') != -1) {
	      if (validateEmail(username)) {
	        def.resolve(username);
	      } else {
	        def.reject();
	      }
	    } else {
	      $.ajax({
	        url: "/api/phone/validate",
	        data: {
	          phone: username
	        }
	      }).done(function (data) {
	        if (data.result) {
	          username = data.result;
	          def.resolve(data.result);
	        } else {
	          def.reject(data);
	        }
	      }).fail(function () {
	        def.reject();
	      });
	    }
	    return def;
	  },
	
	  _login: function () {
	    var self = this;
	    var username;
	    var password;
	    var passwordType;
	
	    if (self.loginType == 'password') {
	      username = $("#home-input-user").val();
	      password = $("#home-input-pwd-password").val();
	      passwordType = 3;
	    } else {
	      username = $(".mobile-code").val() + $("#home-input-phone").val();
	      password = $('#home-input-sms-code').val().trim();
	      passwordType = 4;
	    }
	
	    var pictureId = self.loginCaptcha.pictureId;
	    var code = $("#home-input-ver-custom").val();
	    self.validateAccount(username)
	      .done(function (username) {
	        Model.user({
	          method: "login",
	          data: {
	            username: username,
	            password: password,
	            pictureId: pictureId,
	            password_type: passwordType,
	            code: code
	          },
	          param: {
	            language: locale.current()
	          },
	          error: self.loginErrorHandler.bind(self)
	        });
	      })
	      .fail(self.loginErrorHandler.bind(self));
	
	  }
	});
	
	module.exports = {};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {/**
	 * @author PANJC
	 *
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	  var cloud = __webpack_require__(5);
	  var html = __webpack_require__(39);
	  var css = __webpack_require__(40);
	  __webpack_require__(9);
	  languages = config["locale"]["languages"];
	  var Header = Class.create(cloud.Component, {
	    initialize: function ($super, options) {
	      $super(options);
	      this.oldValue = null;
	      this.language = null;
	      this.browserLang = null;
	      this.userLang = null;
	      this.localLang = null;
	      this.storageLang = null;
	      this.langArr = languages;
	      this.lang = null;
	      this._render();
	      this.gotoTop();
	    },
	
	    /*返回顶部处理函数*/
	    gotoTop: function () {
	      //为窗口的scroll事件绑定处理函数
	      $(window).scroll(function () {
	        //获取窗口的滚动条的垂直位置
	        var s = $(window).scrollTop();
	        //当窗口的滚动条的垂直位置大于300px时，让返回顶部元素渐现，否则渐隐
	        if (s > 300) {
	          $("#returnTop").fadeIn(100);
	        } else {
	          $("#returnTop").fadeOut(200);
	        }
	      });
	      $("#returnTop").click(
	        function () {
	          $('html,body').animate({scrollTop: 0}, 1000);
	        }
	      );
	
	
	    },
	
	    _setBrowserLang: function () {
	      var browser = navigator.language || navigator.browserLanguage;
	      var browserLang = browser.toLowerCase().substring(0, 2);
	      var langArr = this.langArr;
	      var arrCurrent;
	      for (var num = 0; num < langArr.length; num++) {
	        arrCurrent = langArr[num].toLowerCase().substring(0, 2);
	        if (browserLang == arrCurrent) {
	          this.browserLang = langArr[num];
	          return;
	        }
	      }
	    },
	
	    _setUserLang: function (opt) {
	      var langArr = this.langArr;
	      for (var num = 0; num < langArr.length; num++) {
	        if (langArr[num].toLowerCase().indexOf(opt.toLowerCase()) > -1) {
	          this.userLang = langArr[num];
	          return;
	        }
	      }
	    },
	
	    _setStorageLang: function (opt) {
	      this.storageLang = opt;
	    },
	
	    _setLocalLang: function () {
	      if (this.storageLang && this.userLang) {
	        this.localLang = this.userLang;
	      } else if (this.storageLang && !this.userLang) {
	        this.localLang = this.storageLang;
	      } else if (!this.storageLang && this.userLang) {
	        this.localLang = this.userLang;
	      } else {
	        this.localLang = this.browserLang;
	      }
	      this._setStorage(this.localLang);
	    },
	
	    _setLang: function () {
	      if (!this.browserLang) {
	        this._setBrowserLang();
	      }
	      if (!this.storageLang) {
	        this._setStorageLang(localStorage.getItem("language"));
	      }
	      if (this.lang) {
	        this._setUserLang(this.lang);
	      }
	      this._setLocalLang();
	    },
	
	    _setStorage: function (lang) {
	      this._setStorageLang(lang);
	      localStorage.setItem("language", lang);
	    },
	
	    _render: function () {
	      var screenWidth = document.body.clientWidth;
	      if (screenWidth <= 1400) {
	        $("#home-content-top").css("height", "400px")
	      } else if (screenWidth > 1400 && screenWidth <= 1700) {
	        $("#home-content-top").css("height", "490px")
	      } else {
	        $("#home-content-top").css("height", "600px")
	      }
	      var self = this;
	      if (sessionStorage.getItem("accessToken")) {
	        location.href = "../applications";
	      }
	      this._renderHtml();
	      var host = window.location.host;
	      if (host == "g.inhandnetworks.com") {
	        $("#home-nav-develop").css("display", "none")
	      }
	      this._setLang();
	      var flag = 0;
	      $("#select-language").bind("click", function () {
	        if(flag == 0){
	          $(".dropdown-menu").css("display","block");
	          flag = 1;
	        }else{
	          $(".dropdown-menu").css("display","none");
	          flag = 0;
	        }
	      });
	      var lang = localStorage.getItem("language");
	      if (self.storageLang == 'en') {
	        $("#device-touch .home-intro-bottom .panel").css("height","178px");
	        $("#device-sense .home-intro-bottom .row:first .panel").css("height","190px");
	        $("#device-sense .home-intro-bottom .row:last .panel").css("height","215px");
	        $("#device-manager .home-intro-bottom .row:first .panel").css("height","210px");
	        $("#device-manager .home-intro-bottom .row:last .panel").css("height","260px");
	        $(".alarm-app").css("font-size", "17px");
	        $(".login-title-slide-bar").css({"margin": "0 .3em", "width": "3.5em"});
	        $(".home-content-top-box").css({
	          "background": "url('./../www/resources/images/banner-en.png') no-repeat ",
	          "background-size": "cover"
	        });
	      }else{
	        $("#device-touch .home-intro-bottom .panel").css("height","145px");
	        $("#device-sense .home-intro-bottom .row:first .panel").css("height","145px");
	        $("#device-sense .home-intro-bottom .row:last .panel").css("height","190px");
	        $("#device-manager .home-intro-bottom .row:first .panel").css("height","145px");
	        $("#device-manager .home-intro-bottom .row:last .panel").css("height","176px");
	        $(".alarm-app").css("font-size", "20px");
	        $(".login-title-slide-bar").css({"margin": "0 .8em", "width": "2.4em"});
	        $(".home-content-top-box").css({
	          "background": "url('./../www/resources/images/banner-zh.png') no-repeat ",
	          "background-size": "cover"
	        });
	        $(".the-long").removeClass("the-longest");
	      }
	      $("#lang-en").bind("click", function () {
	        locale.set({lang: "en"});
	        self._setAboutUsLink('en');  // set about us url
	        validator.render(validator.element, validator.paramObj);
	        self._promptCurrentLang();
	        self._changeLanguageEvent();
	        $(".dropdown-menu").css("display","none");
	        flag = 0;
	        $("#device-touch .home-intro-bottom .panel").css("height","178px");
	        $("#device-sense .home-intro-bottom .row:first .panel").css("height","190px");
	        $("#device-sense .home-intro-bottom .row:last .panel").css("height","215px");
	        $("#device-manager .home-intro-bottom .row:first .panel").css("height","210px");
	        $("#device-manager .home-intro-bottom .row:last .panel").css("height","260px");
	        $(".fax").css("display","none");
	        $(".alarm-app").css("font-size", "17px");
	        $(".login-title-slide-bar").css({"margin": "0 .3em", "width": "3.5em"});
	        $(".home-content-top-box").css({
	          "background": "url('./../www/resources/images/banner-en.png') no-repeat ",
	          "background-size": "cover"
	        });
	        $(".the-long").addClass("the-longest");
	      });
	      $("#lang-zh").bind("click", function () {
	        locale.set({lang: "zh_CN"});
	        self._setAboutUsLink('zh_CN');
	        validator.render(validator.element, validator.paramObj);
	        self._promptCurrentLang();
	        self._changeLanguageEvent();
	        $(".dropdown-menu").css("display","none");
	        $(".fax").css("display","block");
	        flag = 0;
	        $("#device-touch .home-intro-bottom .panel").css("height","145px");
	        $("#device-sense .home-intro-bottom .row:first .panel").css("height","145px");
	        $("#device-sense .home-intro-bottom .row:last .panel").css("height","190px");
	        $("#device-manager .home-intro-bottom .row:first .panel").css("height","145px");
	        $("#device-manager .home-intro-bottom .row:last .panel").css("height","176px");
	        $(".alarm-app").css("font-size", "20px");
	        $(".login-title-slide-bar").css({"margin": "0 .8em", "width": "2.4em"});
	        $(".home-content-top-box").css({
	          "background": "url('./../www/resources/images/banner-zh.png') no-repeat ",
	          "background-size": "cover"
	        });
	        $(".the-long").removeClass("the-longest");
	      });
	      this._promptCurrentLang();
	      this._event();
	    },
	
	    _renderHtml: function () {
	      this.element.html(html);
	    },
	    _setAboutUsLink: function (lang) {
	      if (lang == 'en') {
	        $("#home-nav-aboutus").children("a").attr("href", "http://www.inhandnetworks.com/");
	      } else if (lang == 'zh_CN') {
	        $("#home-nav-aboutus").children("a").attr("href", "http://www.inhand.com.cn/");
	      }
	    },
	    _promptCurrentLang: function () {
	      var lang = localStorage.getItem("language");
	      if (lang == "en") {
	        $("#lang-zh").css("color", "#555");
	        $("#lang-en").css("color", "#83a82f");
	      } else if (lang == "zh_CN") {
	        $("#lang-zh").css("color", "#83a82f");
	        $("#lang-en").css("color", "#555");
	      }
	    },
	
	    _changeLanguageEvent: function () {
	      if ($("#change-language").length > 0) {
	        $("#change-language").trigger("click");
	      }
	    },
	
	    _event: function () {
	      var self = this;
	      var $search = $("#search");
	      var oldValue, newValue;
	      $search.bind("focus", function () {
	        if (!self.language) {
	          self.language = localStorage.getItem("language");
	        }
	        if (!self.oldValue) {
	          self.oldValue = $search.val();
	        } else {
	          if (self.language != localStorage.getItem("language")) {
	            self.oldValue = $search.val();
	            self.language = localStorage.getItem("language");
	          }
	        }
	        if (self.oldValue == $search.val()) {
	          $search.val("");
	        }
	      });
	      $search.bind("focusout", function () {
	        newValue = $search.val();
	        if (!newValue) {
	          $search.val(self.oldValue);
	        }
	      });
	    }
	
	  });
	
	  return Header;
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	module.exports = "<div class=home-header-box id=home-header-box> <div class=\"home-header row\" id=home-header> <div class=\"home-header-corp col-xs-7\"> <a href=./ > <div class=home-header-corp-ul-text lang=text:welcome_to_inhand></div> </a> </div> <div class=\"home-header-tool col-xs-5\" style=\"\"> <div id=home-nav-box class=home-nav-box> <div id=home-nav class=home-nav> <div class=home-header-tool-lang> <div class=btn-group> <button type=button class=\"btn btn-default dropdown-toggle\" data-toggle=dropdown id=select-language> <span id=language lang=languages></span> <span class=caret></span> </button> <ul class=dropdown-menu role=menu id=dropdown-menu> <li><a href=javascript:void(0) id=lang-zh>中文</a></li> <li><a href=javascript:void(0) id=lang-en>English</a></li> </ul> </div> </div> <ul> <li id=home-nav-index><a href=./index.html lang=text:home></a></li> <li id=home-nav-devforum style=display:none><a href=javascript:void(0) lang=text:forum></a></li> <li id=home-nav-aboutus><a href=http://www.inhand.com.cn target=_blank lang=text:inhand></a></li> <li id=home-nav-develop><a href=http://developers.inhand.com.cn/ target=_blank lang=text:developers></a></li> </ul> </div> </div> </div> <div class=clearfix></div> </div> </div> ";

/***/ }),
/* 40 */
13,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {/**
	 * @author PANJC
	 *
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	  var cloud = __webpack_require__(5);
	  var css = __webpack_require__(42);
	  var html = __webpack_require__(43);
	  var Nav = Class.create(cloud.Component, {
	    initialize: function ($super, options) {
	      $super(options);
	      this.pageNum = options.current;
	      this.page = {
	        0: "#home-nav-index",
	        1: "#home-nav-login",
	        2: "#home-nav-reg",
	        3: "#home-nav-devforum",
	        4: "#home-nav-aboutus"
	      };
	      this.windowElement = options.windowElement;
	      this._render();
	    },
	
	    _render: function () {
	      this._renderHtml();
	      this._effects();
	    },
	
	    _renderHtml: function () {
	      this.element.html(html);
	    },
	
	    _effects: function () {
	      var $this = this;
	      $($this.page[$this.pageNum]).addClass("home-nav-a-current");
	      $($this.page[1]).bind("click", function () {
	        __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(44)]; (function (Login) {
	          var login = new Login({
	            windowElement: $this.windowElement
	          });
	        }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
	      });
	    }
	
	  });
	
	  return Nav;
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 42 */
13,
/* 43 */
/***/ (function(module, exports) {

	module.exports = "";

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {/**
	 * Copyright (c) 2007-2014, InHand Networks All Rights Reserved..
	 * Example
	 * validator.render("#formId",{promptPosition:"centerRight",scroll: false}) render validator
	 * varlidator.result() get validator result,true if the form validates, false if it failed
	 * varlidator.result("#id") specified element,get validator result,true if the form validates, false if it failed
	 * varlidator.hide("#form") specified element,hide prompt
	 * varlidator.hide() hide prompt
	 * varlidator.hideAll() hide all prompts
	 * @author PANJC
	 * @filename validator
	 * @filetype {object}
	 * @filedescription "验证表单组件"
	 * @filereturn {object} validator "验证组件对象"
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	  __webpack_require__(5);
	  __webpack_require__(53);
	  __webpack_require__(54);
	
	  $.validationEngine.defaults.autoPositionUpdate = true;
	  validator = {
	    storageLang: null,
	    langPacks: {},
	    element: null,
	    elements: [],
	    validation: null,
	
	    /**
	     * Render validator
	     * @author PANJC
	     * @name render
	     * @type {method}
	     * @description "渲染组件"
	     * @param {String} element "渲染的dom元素"
	     * @param {Object} paramObj "配置参数"
	     * @return
	     */
	    render: function (element, paramObj) {
	      this._cacheElements(element, paramObj);
	      this._cacheStorageLang();
	      this.hideAll();
	      this._destroy();
	      this._render();
	    },
	
	    /**
	     * Store storage lang
	     * @author PANJC
	     * @name _cacheStorageLang
	     * @type {method}
	     * @description "设置语言"
	     * @private
	     * @return
	     */
	    _cacheStorageLang: function () {
	      var lang = this._returnStorageLang();
	      if (!this.storageLang) {
	        this.storageLang = lang ? lang : "zh_CN";
	      } else {
	        if (this.storageLang != lang) {
	          this.storageLang = lang ? lang : "zh_CN";
	        }
	      }
	    },
	
	    /**
	     * Store elements
	     * @author PANJC
	     * @name _cacheElements
	     * @type {method}
	     * @description "缓存dom结构和配置项"
	     * @param {String} element
	     * @param {Object} paramObj
	     * @private
	     * @return
	     */
	    _cacheElements: function (element, paramObj) {
	      var self = this;
	      this.element = element;
	      var elements = this.elements;
	      var defaultObj = {
	        showOneMessage: true,
	        focusFirstField: true,
	        maxErrorsPerField: 1,
	        binded: false,
	        autoHidePrompt: true,
	        autoHideDelay: 30000,
	        customFunctions: {
	          /* called by funcCall[functionName]
	           * @param {jqObject} field
	           * @param {Array[String]} rules
	           * @param {int} i rules index
	           * @param {Map}  user options
	           */
	          cloudInput: function (field, rules, i, options) {
	            var nohtml = new RegExp("(<[^>]+>)|(&gt|&lt|&amp|&quot|&nbsp)");
	            if (nohtml.test(field.val())) {
	              //add rules at validationengine.lang
	              return options.allrules.nohtml.alertText;
	            }
	//						if(field.val()==="test"){
	//							return "no test";
	//						}
	            return true;
	          }
	        }
	      };
	      paramObj = $.extend(paramObj, defaultObj);
	      if (elements.length > 0) {
	        var count = 0;
	        $.each(elements, function (index, obj) {
	          if (element == obj.element) {
	            //if element is same,reset paramObj
	            var currentParamObj = obj.paramObj;
	            var newParamObj = $.extend(currentParamObj, paramObj);
	            self.elements[index]["paramObj"] = newParamObj;
	            count++;
	          }
	        });
	        if (count === 0) {
	          this.elements.push({element: element, paramObj: paramObj});
	        }
	      } else {
	        this.elements.push({element: element, paramObj: paramObj});
	      }
	    },
	
	    /**
	     * Return the validation result
	     * @author PANJC
	     * @name result
	     * @type {method}
	     * @description "显示验证结果信息"
	     * @param {String} element "dom元素"
	     * @return {boolean} "验证结果:true,false"
	     */
	    result: function (element) {
	      if (this.validation) {
	        if (element) {
	          return $(element).validationEngine('validate');
	        } else {
	          return $(this.element).validationEngine('validate');
	        }
	      }
	    },
	
	    /**
	     * Row prompt
	     * @author PANJC
	     * @name prompt
	     * @type {method}
	     * @description "验证结果提示信息"
	     * @param {String} element "dom元素"
	     * @param {Object} obj "配置对象"
	     * @return
	     */
	    prompt: function (element, obj) {
	      $(element).validationEngine("showPrompt", obj.text, "load", obj.promptPosition ? obj.promptPosition : "topLeft", true);
	    },
	
	    /**
	     * Hide prompt
	     * @author PANJC
	     * @name hide
	     * @type {method}
	     * @description "隐藏提示"
	     * @param {String} element "dom元素"
	     * @return
	     */
	    hide: function (element) {
	      if (element) {
	        $(element).validationEngine('hide');
	      } else {
	        $(this.element).validationEngine('hide');
	      }
	    },
	
	    /**
	     * Hide all prompt
	     * @author PANJC
	     * @name hideAll
	     * @type {method}
	     * @description "隐藏所有提示"
	     * @param {String} element "dom元素"
	     * @return
	     */
	    hideAll: function (element) {
	      if (element) {
	        $(element).validationEngine('hideAll');
	      } else {
	        var elements = this.elements;
	        if (this.validation) {
	          $.each(elements, function (index, obj) {
	            $(obj.element).validationEngine('hideAll');
	          });
	        }
	      }
	    },
	
	    /**
	     * detach prompt
	     * @author PANJC
	     * @name _destroy
	     * @type {method}
	     * @description "摧毁提示框"
	     * @private
	     * @return
	     */
	    _destroy: function () {
	      var elements = this.elements;
	      if (this.validation) {
	        this.validation = null;
	        $.each(elements, function (index, obj) {
	          $(obj.element).validationEngine('detach');
	        });
	      }
	    },
	
	    /**
	     * Render validatior
	     * @author PANJC
	     * @name _render
	     * @type {method}
	     * @description "渲染表单验证结果"
	     * @private
	     * @return
	     */
	    _render: function () {
	      var storageLang = this.storageLang;
	      var hasPack = function () {
	        var langPacks = self.langPacks;
	        for (var attr in langPacks) {
	          if (attr == storageLang) {
	            return true;
	          }
	        }
	      };
	      if (hasPack()) {
	        this._renderForm();
	      } else {
	        this._loadPack();
	      }
	    },
	
	    /**
	     * Return storage lang
	     * @author PANJC
	     * @name _returnStorageLang
	     * @type {method}
	     * @description "国际化"
	     * @private
	     * @return {String}
	     */
	    _returnStorageLang: function () {
	      return cloud.storage.localStorage("language");
	    },
	
	    /**
	     * Render form
	     * @author PANJC
	     * @name _renderForm
	     * @type {method}
	     * @description "渲染表单验证结果"
	     * @private
	     * @return
	     */
	    _renderForm: function () {
	      var self = this;
	      var elements = this.elements;
	      self._returnAllRules();
	      $.each(elements, function (index, obj) {
	        self.validation = $(obj.element).validationEngine('attach', obj.paramObj);
	      });
	    },
	
	    /**
	     * Load pack
	     * @author PANJC
	     * @name _loadPack
	     * @type {method}
	     * @description "加载语言包"
	     * @private
	     * @return
	     */
	    _loadPack: function () {
	      var self = this;
	      // var url = require.toUrl("cloud/resources/language/") + self.storageLang + "/validationengine.lang.js";
	      var data = __webpack_require__(55)("./" + self.storageLang + "/validationengine.lang.js");
	      // $.getScript(url, function (data) {
	        self._cacheLangPacks();
	        self._renderForm();
	      // });
	    },
	
	    /**
	     * Return all rules
	     * @author PANJC
	     * @name _returnAllRules
	     * @type {method}
	     * @description "设置所有验证规则"
	     * @private
	     * @return {Object/Json}
	     */
	    _returnAllRules: function () {
	      var self = this;
	      var returnAllRules = function () {
	        $.validationEngineLanguage.allRules = self.langPacks[self.storageLang];
	      };
	      return returnAllRules();
	    },
	
	    /**
	     * Store lang pack
	     * @author PANJC
	     * @name _cacheLangPacks
	     * @type {method}
	     * @description "缓存语言包"
	     * @private
	     * @return
	     */
	    _cacheLangPacks: function () {
	      var self = this;
	      var lang = $.validationEngineLanguage;
	      var langName, langObj;
	      for (var attr in lang) {
	        langName = attr;
	        langObj = lang[attr];
	      }
	      self.langPacks[langName] = langObj;
	    }
	
	  };
	
	  return validator;
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*
	 * Inline Form Validation Engine 2.6.2, jQuery plugin
	 *
	 * Copyright(c) 2010, Cedric Dugas
	 * http://www.position-absolute.com
	 *
	 * 2.0 Rewrite by Olivier Refalo
	 * http://www.crionics.com
	 *
	 * Form validation engine allowing custom regex rules to be added.
	 * Licensed under the MIT License
	 */
	 (function($) {
	
		"use strict";
	
		var methods = {
	
			/**
			* Kind of the constructor, called before any action
			* @param {Map} user options
			*/
			init: function(options) {
				var form = this;
				if (!form.data('jqv') || form.data('jqv') == null ) {
					options = methods._saveOptions(form, options);
					// bind all formError elements to close on click
					$(document).on("click", ".formError", function() {
						$(this).fadeOut(150, function() {
							// remove prompt once invisible
							$(this).parent('.formErrorOuter').remove();
							$(this).remove();
						});
					});
				}
				return this;
			 },
			/**
			* Attachs jQuery.validationEngine to form.submit and field.blur events
			* Takes an optional params: a list of options
			* ie. jQuery("#formID1").validationEngine('attach', {promptPosition : "centerRight"});
			*/
			attach: function(userOptions) {
	
				var form = this;
				var options;
	
				if(userOptions)
					options = methods._saveOptions(form, userOptions);
				else
					options = form.data('jqv');
	
				options.validateAttribute = (form.find("[data-validation-engine*=validate]").length) ? "data-validation-engine" : "class";
				if (options.binded) {
	
					// delegate fields
					form.on(options.validationEventTrigger, "["+options.validateAttribute+"*=validate]:not([type=checkbox]):not([type=radio]):not(.datepicker)", methods._onFieldEvent);
					form.on("click", "["+options.validateAttribute+"*=validate][type=checkbox],["+options.validateAttribute+"*=validate][type=radio]", methods._onFieldEvent);
					form.on(options.validationEventTrigger,"["+options.validateAttribute+"*=validate][class*=datepicker]", {"delay": 300}, methods._onFieldEvent);
				}
				if (options.autoPositionUpdate) {
					$(window).bind("resize", {
						"noAnimation": true,
						"formElem": form
					}, methods.updatePromptsPosition);
				}
				form.on("click","a[data-validation-engine-skip], a[class*='validate-skip'], button[data-validation-engine-skip], button[class*='validate-skip'], input[data-validation-engine-skip], input[class*='validate-skip']", methods._submitButtonClick);
				form.removeData('jqv_submitButton');
	
				// bind form.submit
				form.on("submit", methods._onSubmitEvent);
				return this;
			},
			/**
			* Unregisters any bindings that may point to jQuery.validaitonEngine
			*/
			detach: function() {
	
				var form = this;
				var options = form.data('jqv');
	
				// unbind fields
				form.find("["+options.validateAttribute+"*=validate]").not("[type=checkbox]").off(options.validationEventTrigger, methods._onFieldEvent);
				form.find("["+options.validateAttribute+"*=validate][type=checkbox],[class*=validate][type=radio]").off("click", methods._onFieldEvent);
	
				// unbind form.submit
				form.off("submit", methods.onAjaxFormComplete);
	
				// unbind form.submit
				form.off("submit", methods.onAjaxFormComplete);
				form.removeData('jqv');
	            
				form.off("click", "a[data-validation-engine-skip], a[class*='validate-skip'], button[data-validation-engine-skip], button[class*='validate-skip'], input[data-validation-engine-skip], input[class*='validate-skip']", methods._submitButtonClick);
				form.removeData('jqv_submitButton');
	
				if (options.autoPositionUpdate)
					$(window).unbind("resize", methods.updatePromptsPosition);
	
				return this;
			},
			/**
			* Validates either a form or a list of fields, shows prompts accordingly.
			* Note: There is no ajax form validation with this method, only field ajax validation are evaluated
			*
			* @return true if the form validates, false if it fails
			*/
			validate: function() {
				var element = $(this);
				var valid = null;
	
				if (element.is("form") || element.hasClass("validationEngineContainer")) {
					if (element.hasClass('validating')) {
						// form is already validating.
						// Should abort old validation and start new one. I don't know how to implement it.
						return false;
					} else {				
						element.addClass('validating');
						var options = element.data('jqv');
						var valid = methods._validateFields(this);
	
						// If the form doesn't validate, clear the 'validating' class before the user has a chance to submit again
						setTimeout(function(){
							element.removeClass('validating');
						}, 100);
						if (valid && options.onSuccess) {
							options.onSuccess();
						} else if (!valid && options.onFailure) {
							options.onFailure();
						}
					}
				} else if (element.is('form') || element.hasClass('validationEngineContainer')) {
					element.removeClass('validating');
				} else {
					// field validation
					var form = element.closest('form, .validationEngineContainer'),
						options = (form.data('jqv')) ? form.data('jqv') : $.validationEngine.defaults,
						valid = methods._validateField(element, options);
	
					if (valid && options.onFieldSuccess)
						options.onFieldSuccess();
					else if (options.onFieldFailure && options.InvalidFields.length > 0) {
						options.onFieldFailure();
					}
				}
				if(options.onValidationComplete) {
					// !! ensures that an undefined return is interpreted as return false but allows a onValidationComplete() to possibly return true and have form continue processing
					return !!options.onValidationComplete(form, valid);
				}
				return valid;
			},
			/**
			*  Redraw prompts position, useful when you change the DOM state when validating
			*/
			updatePromptsPosition: function(event) {
	
				if (event && this == window) {
					var form = event.data.formElem;
					var noAnimation = event.data.noAnimation;
				}
				else
					var form = $(this.closest('form, .validationEngineContainer'));
	
				var options = form.data('jqv');
				// No option, take default one
				form.find('['+options.validateAttribute+'*=validate]').not(":disabled").each(function(){
					var field = $(this);
					if (options.prettySelect && field.is(":hidden"))
					  field = form.find("#" + options.usePrefix + field.attr('id') + options.useSuffix);
					var prompt = methods._getPrompt(field);
					var promptText = $(prompt).find(".formErrorContent").html();
	
					if(prompt)
						methods._updatePrompt(field, $(prompt), promptText, undefined, false, options, noAnimation);
				});
				return this;
			},
			/**
			* Displays a prompt on a element.
			* Note that the element needs an id!
			*
			* @param {String} promptText html text to display type
			* @param {String} type the type of bubble: 'pass' (green), 'load' (black) anything else (red)
			* @param {String} possible values topLeft, topRight, bottomLeft, centerRight, bottomRight
			*/
			showPrompt: function(promptText, type, promptPosition, showArrow) {
				var form = this.closest('form, .validationEngineContainer');
				var options = form.data('jqv');
				// No option, take default one
				if(!options)
					options = methods._saveOptions(this, options);
				if(promptPosition)
					options.promptPosition=promptPosition;
				options.showArrow = showArrow==true;
	
				methods._showPrompt(this, promptText, type, false, options);
				return this;
			},
			/**
			* Closes form error prompts, CAN be invidual
			*/
			hide: function() {
				 var form = $(this).closest('form, .validationEngineContainer');
				 var options = form.data('jqv');
				 var fadeDuration = (options && options.fadeDuration) ? options.fadeDuration : 0.3;
				 var closingtag;
				 
				 if($(this).is("form") || $(this).hasClass("validationEngineContainer")) {
					 closingtag = "parentForm"+methods._getClassName($(this).attr("id"));
				 } else {
					 closingtag = methods._getClassName($(this).attr("id")) +"formError";
				 }
				 $('.'+closingtag).fadeTo(fadeDuration, 0.3, function() {
					 $(this).parent('.formErrorOuter').remove();
					 $(this).remove();
				 });
				 return this;
			 },
			 /**
			 * Closes all error prompts on the page
			 */
			 hideAll: function() {
	
				 var form = this;
				 var options = form.data('jqv');
				 var duration = options ? options.fadeDuration:300;
				 $('.formError').fadeTo(duration, 300, function() {
					 $(this).parent('.formErrorOuter').remove();
					 $(this).remove();
				 });
				 return this;
			 },
			/**
			* Typically called when user exists a field using tab or a mouse click, triggers a field
			* validation
			*/
			_onFieldEvent: function(event) {
				var field = $(this);
				var form = field.closest('form, .validationEngineContainer');
				var options = form.data('jqv');
				options.eventTrigger = "field";
				// validate the current field
				window.setTimeout(function() {
					methods._validateField(field, options);
					if (options.InvalidFields.length == 0 && options.onFieldSuccess) {
						options.onFieldSuccess();
					} else if (options.InvalidFields.length > 0 && options.onFieldFailure) {
						options.onFieldFailure();
					}
				}, (event.data) ? event.data.delay : 0);
	
			},
			/**
			* Called when the form is submited, shows prompts accordingly
			*
			* @param {jqObject}
			*            form
			* @return false if form submission needs to be cancelled
			*/
			_onSubmitEvent: function() {
				var form = $(this);
				var options = form.data('jqv');
				
				//check if it is trigger from skipped button
				if (form.data("jqv_submitButton")){
					var submitButton = $("#" + form.data("jqv_submitButton"));
					if (submitButton){
						if (submitButton.length > 0){
							if (submitButton.hasClass("validate-skip") || submitButton.attr("data-validation-engine-skip") == "true")
								return true;
						}
					}
				}
	
				options.eventTrigger = "submit";
	
				// validate each field 
				// (- skip field ajax validation, not necessary IF we will perform an ajax form validation)
				var r=methods._validateFields(form);
	
				if (r && options.ajaxFormValidation) {
					methods._validateFormWithAjax(form, options);
					// cancel form auto-submission - process with async call onAjaxFormComplete
					return false;
				}
	
				if(options.onValidationComplete) {
					// !! ensures that an undefined return is interpreted as return false but allows a onValidationComplete() to possibly return true and have form continue processing
					return !!options.onValidationComplete(form, r);
				}
				return r;
			},
			/**
			* Return true if the ajax field validations passed so far
			* @param {Object} options
			* @return true, is all ajax validation passed so far (remember ajax is async)
			*/
			_checkAjaxStatus: function(options) {
				var status = true;
				$.each(options.ajaxValidCache, function(key, value) {
					if (!value) {
						status = false;
						// break the each
						return false;
					}
				});
				return status;
			},
			
			/**
			* Return true if the ajax field is validated
			* @param {String} fieldid
			* @param {Object} options
			* @return true, if validation passed, false if false or doesn't exist
			*/
			_checkAjaxFieldStatus: function(fieldid, options) {
				return options.ajaxValidCache[fieldid] == true;
			},
			/**
			* Validates form fields, shows prompts accordingly
			*
			* @param {jqObject}
			*            form
			* @param {skipAjaxFieldValidation}
			*            boolean - when set to true, ajax field validation is skipped, typically used when the submit button is clicked
			*
			* @return true if form is valid, false if not, undefined if ajax form validation is done
			*/
			_validateFields: function(form) {
				var options = form.data('jqv');
	
				// this variable is set to true if an error is found
				var errorFound = false;
	
				// Trigger hook, start validation
				form.trigger("jqv.form.validating");
				// first, evaluate status of non ajax fields
				var first_err=null;
				form.find('['+options.validateAttribute+'*=validate]').not(":disabled").each( function() {
					var field = $(this);
					var names = [];
					if ($.inArray(field.attr('name'), names) < 0) {
						errorFound |= methods._validateField(field, options);
						if (errorFound && first_err==null)
							if (field.is(":hidden") && options.prettySelect)
											 first_err = field = form.find("#" + options.usePrefix + methods._jqSelector(field.attr('id')) + options.useSuffix);
										else
											 first_err=field;
						if (options.doNotShowAllErrosOnSubmit)
							return false;
						names.push(field.attr('name'));
	
						//if option set, stop checking validation rules after one error is found
						if(options.showOneMessage == true && errorFound){
							return false;
						}
					}
				});
	
				// second, check to see if all ajax calls completed ok
				// errorFound |= !methods._checkAjaxStatus(options);
	
				// third, check status and scroll the container accordingly
				form.trigger("jqv.form.result", [errorFound]);
	
				if (errorFound) {
					if (options.scroll) {
						var destination=first_err.offset().top;
						var fixleft = first_err.offset().left;
	
						//prompt positioning adjustment support. Usage: positionType:Xshift,Yshift (for ex.: bottomLeft:+20 or bottomLeft:-20,+10)
						var positionType=options.promptPosition;
						if (typeof(positionType)=='string' && positionType.indexOf(":")!=-1)
							positionType=positionType.substring(0,positionType.indexOf(":"));
	
						if (positionType!="bottomRight" && positionType!="bottomLeft") {
							var prompt_err= methods._getPrompt(first_err);
							if (prompt_err) {
								destination=prompt_err.offset().top;
							}
						}
						
						// Offset the amount the page scrolls by an amount in px to accomodate fixed elements at top of page
						if (options.scrollOffset) {
							destination -= options.scrollOffset;
						}
	
						// get the position of the first error, there should be at least one, no need to check this
						//var destination = form.find(".formError:not('.greenPopup'):first").offset().top;
						if (options.isOverflown) {
							var overflowDIV = $(options.overflownDIV);
							if(!overflowDIV.length) return false;
							var scrollContainerScroll = overflowDIV.scrollTop();
							var scrollContainerPos = -parseInt(overflowDIV.offset().top);
	
							destination += scrollContainerScroll + scrollContainerPos - 5;
							var scrollContainer = $(options.overflownDIV + ":not(:animated)");
	
							scrollContainer.animate({ scrollTop: destination }, 1100, function(){
								if(options.focusFirstField) first_err.focus();
							});
	
						} else {
							$("html, body").animate({
								scrollTop: destination
							}, 1100, function(){
								if(options.focusFirstField) first_err.focus();
							});
							$("html, body").animate({scrollLeft: fixleft},1100)
						}
	
					} else if(options.focusFirstField)
						first_err.focus();
					return false;
				}
				return true;
			},
			/**
			* This method is called to perform an ajax form validation.
			* During this process all the (field, value) pairs are sent to the server which returns a list of invalid fields or true
			*
			* @param {jqObject} form
			* @param {Map} options
			*/
			_validateFormWithAjax: function(form, options) {
	
				var data = form.serialize();
										var type = (options.ajaxFormValidationMethod) ? options.ajaxFormValidationMethod : "GET";
				var url = (options.ajaxFormValidationURL) ? options.ajaxFormValidationURL : form.attr("action");
										var dataType = (options.dataType) ? options.dataType : "json";
				$.ajax({
					type: type,
					url: url,
					cache: false,
					dataType: dataType,
					data: data,
					form: form,
					methods: methods,
					options: options,
					beforeSend: function() {
						return options.onBeforeAjaxFormValidation(form, options);
					},
					error: function(data, transport) {
						methods._ajaxError(data, transport);
					},
					success: function(json) {
						if ((dataType == "json") && (json !== true)) {
							// getting to this case doesn't necessary means that the form is invalid
							// the server may return green or closing prompt actions
							// this flag helps figuring it out
							var errorInForm=false;
							for (var i = 0; i < json.length; i++) {
								var value = json[i];
	
								var errorFieldId = value[0];
								var errorField = $($("#" + errorFieldId)[0]);
	
								// make sure we found the element
								if (errorField.length == 1) {
	
									// promptText or selector
									var msg = value[2];
									// if the field is valid
									if (value[1] == true) {
	
										if (msg == ""  || !msg){
											// if for some reason, status==true and error="", just close the prompt
											methods._closePrompt(errorField);
										} else {
											// the field is valid, but we are displaying a green prompt
											if (options.allrules[msg]) {
												var txt = options.allrules[msg].alertTextOk;
												if (txt)
													msg = txt;
											}
											if (options.showPrompts) methods._showPrompt(errorField, msg, "pass", false, options, true);
										}
									} else {
										// the field is invalid, show the red error prompt
										errorInForm|=true;
										if (options.allrules[msg]) {
											var txt = options.allrules[msg].alertText;
											if (txt)
												msg = txt;
										}
										if(options.showPrompts) methods._showPrompt(errorField, msg, "", false, options, true);
									}
								}
							}
							options.onAjaxFormComplete(!errorInForm, form, json, options);
						} else
							options.onAjaxFormComplete(true, form, json, options);
	
					}
				});
	
			},
			/**
			* Validates field, shows prompts accordingly
			*
			* @param {jqObject}
			*            field
			* @param {Array[String]}
			*            field's validation rules
			* @param {Map}
			*            user options
			* @return false if field is valid (It is inversed for *fields*, it return false on validate and true on errors.)
			*/
			_validateField: function(field, options, skipAjaxValidation) {
				if (!field.attr("id")) {
					field.attr("id", "form-validation-field-" + $.validationEngine.fieldIdCounter);
					++$.validationEngine.fieldIdCounter;
				}
	
	           if (!options.validateNonVisibleFields && (field.is(":hidden") && !options.prettySelect || field.parent().is(":hidden")))
					return false;
	
				var rulesParsing = field.attr(options.validateAttribute);
				var getRules = /validate\[(.*)\]/.exec(rulesParsing);
	
				if (!getRules)
					return false;
				var str = getRules[1];
				var rules = str.split(/\[|,|\]/);
	
				// true if we ran the ajax validation, tells the logic to stop messing with prompts
				var isAjaxValidator = false;
				var fieldName = field.attr("name");
				var promptText = "";
				var promptType = "";
				var required = false;
				var limitErrors = false;
				options.isError = false;
				options.showArrow = true;
				
				// If the programmer wants to limit the amount of error messages per field,
				if (options.maxErrorsPerField > 0) {
					limitErrors = true;
				}
	
				var form = $(field.closest("form, .validationEngineContainer"));
				// Fix for adding spaces in the rules
				for (var i = 0; i < rules.length; i++) {
					rules[i] = rules[i].replace(" ", "");
					// Remove any parsing errors
					if (rules[i] === '') {
						delete rules[i];
					}
				}
	
				for (var i = 0, field_errors = 0; i < rules.length; i++) {
					
					// If we are limiting errors, and have hit the max, break
					if (limitErrors && field_errors >= options.maxErrorsPerField) {
						// If we haven't hit a required yet, check to see if there is one in the validation rules for this
						// field and that it's index is greater or equal to our current index
						if (!required) {
							var have_required = $.inArray('required', rules);
							required = (have_required != -1 &&  have_required >= i);
						}
						break;
					}
					
					
					var errorMsg = undefined;
					switch (rules[i]) {
	
						case "required":
							required = true;
							errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._required);
							break;
						case "custom":
							errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._custom);
							break;
						case "groupRequired":
							// Check is its the first of group, if not, reload validation with first field
							// AND continue normal validation on present field
							var classGroup = "["+options.validateAttribute+"*=" +rules[i + 1] +"]";
							var firstOfGroup = form.find(classGroup).eq(0);
							if(firstOfGroup[0] != field[0]){
	
								methods._validateField(firstOfGroup, options, skipAjaxValidation); 
								options.showArrow = true;
	
							}
							errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._groupRequired);
							if(errorMsg)  required = true;
							options.showArrow = false;
							break;
						case "ajax":
							// AJAX defaults to returning it's loading message
							errorMsg = methods._ajax(field, rules, i, options);
							if (errorMsg) {
								promptType = "load";
							}
							break;
						case "minSize":
							errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._minSize);
							break;
						case "maxSize":
							errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._maxSize);
							break;
						case "min":
							errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._min);
							break;
						case "max":
							errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._max);
							break;
						case "past":
							errorMsg = methods._getErrorMessage(form, field,rules[i], rules, i, options, methods._past);
							break;
						case "future":
							errorMsg = methods._getErrorMessage(form, field,rules[i], rules, i, options, methods._future);
							break;
						case "dateRange":
							var classGroup = "["+options.validateAttribute+"*=" + rules[i + 1] + "]";
							options.firstOfGroup = form.find(classGroup).eq(0);
							options.secondOfGroup = form.find(classGroup).eq(1);
	
							//if one entry out of the pair has value then proceed to run through validation
							if (options.firstOfGroup[0].value || options.secondOfGroup[0].value) {
								errorMsg = methods._getErrorMessage(form, field,rules[i], rules, i, options, methods._dateRange);
							}
							if (errorMsg) required = true;
							options.showArrow = false;
							break;
	
						case "dateTimeRange":
							var classGroup = "["+options.validateAttribute+"*=" + rules[i + 1] + "]";
							options.firstOfGroup = form.find(classGroup).eq(0);
							options.secondOfGroup = form.find(classGroup).eq(1);
	
							//if one entry out of the pair has value then proceed to run through validation
							if (options.firstOfGroup[0].value || options.secondOfGroup[0].value) {
								errorMsg = methods._getErrorMessage(form, field,rules[i], rules, i, options, methods._dateTimeRange);
							}
							if (errorMsg) required = true;
							options.showArrow = false;
							break;
						case "maxCheckbox":
							field = $(form.find("input[name='" + fieldName + "']"));
							errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._maxCheckbox);
							break;
						case "minCheckbox":
							field = $(form.find("input[name='" + fieldName + "']"));
							errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._minCheckbox);
							break;
						case "equals":
							errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._equals);
							break;
						case "funcCall":
							errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._funcCall);
							break;
						case "creditCard":
							errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._creditCard);
							break;
						case "condRequired":
							errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._condRequired);
							if (errorMsg !== undefined) {
								required = true;
							}
							break;
	
						default:
					}
					
					var end_validation = false;
					
					// If we were passed back an message object, check what the status was to determine what to do
					if (typeof errorMsg == "object") {
						switch (errorMsg.status) {
							case "_break":
								end_validation = true;
								break;
							// If we have an error message, set errorMsg to the error message
							case "_error":
								errorMsg = errorMsg.message;
								break;
							// If we want to throw an error, but not show a prompt, return early with true
							case "_error_no_prompt":
								return true;
								break;
							// Anything else we continue on
							default:
								break;
						}
					}
					
					// If it has been specified that validation should end now, break
					if (end_validation) {
						break;
					}
					
					// If we have a string, that means that we have an error, so add it to the error message.
					if (typeof errorMsg == 'string') {
						promptText += errorMsg + "<br/>";
						options.isError = true;
						field_errors++;
					}	
				}
				// If the rules required is not added, an empty field is not validated
				if(!required && !(field.val()) && field.val().length < 1) options.isError = false;
	
				// Hack for radio/checkbox group button, the validation go into the
				// first radio/checkbox of the group
				var fieldType = field.prop("type");
				var positionType=field.data("promptPosition") || options.promptPosition;
	
				if ((fieldType == "radio" || fieldType == "checkbox") && form.find("input[name='" + fieldName + "']").size() > 1) {
					if(positionType === 'inline') {
						field = $(form.find("input[name='" + fieldName + "'][type!=hidden]:last"));
					} else {
					field = $(form.find("input[name='" + fieldName + "'][type!=hidden]:first"));
					}
					options.showArrow = false;
				}
	
				if(field.is(":hidden") && options.prettySelect) {
					field = form.find("#" + options.usePrefix + methods._jqSelector(field.attr('id')) + options.useSuffix);
				}
	
				if (options.isError && options.showPrompts){
					methods._showPrompt(field, promptText, promptType, false, options);
				}else{
					if (!isAjaxValidator) methods._closePrompt(field);
				}
	
				if (!isAjaxValidator) {
					field.trigger("jqv.field.result", [field, options.isError, promptText]);
				}
	
				/* Record error */
				var errindex = $.inArray(field[0], options.InvalidFields);
				if (errindex == -1) {
					if (options.isError)
					options.InvalidFields.push(field[0]);
				} else if (!options.isError) {
					options.InvalidFields.splice(errindex, 1);
				}
					
				methods._handleStatusCssClasses(field, options);
		
				/* run callback function for each field */
				if (options.isError && options.onFieldFailure)
					options.onFieldFailure(field);
	
				if (!options.isError && options.onFieldSuccess)
					options.onFieldSuccess(field);
	
				return options.isError;
			},
			/**
			* Handling css classes of fields indicating result of validation 
			*
			* @param {jqObject}
			*            field
			* @param {Array[String]}
			*            field's validation rules            
			* @private
			*/
			_handleStatusCssClasses: function(field, options) {
				/* remove all classes */
				if(options.addSuccessCssClassToField)
					field.removeClass(options.addSuccessCssClassToField);
				
				if(options.addFailureCssClassToField)
					field.removeClass(options.addFailureCssClassToField);
				
				/* Add classes */
				if (options.addSuccessCssClassToField && !options.isError)
					field.addClass(options.addSuccessCssClassToField);
				
				if (options.addFailureCssClassToField && options.isError)
					field.addClass(options.addFailureCssClassToField);		
			},
			
			 /********************
			  * _getErrorMessage
			  *
			  * @param form
			  * @param field
			  * @param rule
			  * @param rules
			  * @param i
			  * @param options
			  * @param originalValidationMethod
			  * @return {*}
			  * @private
			  */
			 _getErrorMessage:function (form, field, rule, rules, i, options, originalValidationMethod) {
				 // If we are using the custon validation type, build the index for the rule.
				 // Otherwise if we are doing a function call, make the call and return the object
				 // that is passed back.
		 		 var rule_index = jQuery.inArray(rule, rules);
				 if (rule === "custom" || rule === "funcCall") {
					 var custom_validation_type = rules[rule_index + 1];
					 rule = rule + "[" + custom_validation_type + "]";
					 // Delete the rule from the rules array so that it doesn't try to call the
				    // same rule over again
				    delete(rules[rule_index]);
				 }
				 // Change the rule to the composite rule, if it was different from the original
				 var alteredRule = rule;
	
	
				 var element_classes = (field.attr("data-validation-engine")) ? field.attr("data-validation-engine") : field.attr("class");
				 var element_classes_array = element_classes.split(" ");
	
				 // Call the original validation method. If we are dealing with dates or checkboxes, also pass the form
				 var errorMsg;
				 if (rule == "future" || rule == "past"  || rule == "maxCheckbox" || rule == "minCheckbox") {
					 errorMsg = originalValidationMethod(form, field, rules, i, options);
				 } else {
					 errorMsg = originalValidationMethod(field, rules, i, options);
				 }
	
				 // If the original validation method returned an error and we have a custom error message,
				 // return the custom message instead. Otherwise return the original error message.
				 if (errorMsg != undefined) {
					 var custom_message = methods._getCustomErrorMessage($(field), element_classes_array, alteredRule, options);
					 if (custom_message) errorMsg = custom_message;
				 }
				 return errorMsg;
	
			 },
			 _getCustomErrorMessage:function (field, classes, rule, options) {
				var custom_message = false;
				var validityProp = /^custom\[.*\]$/.test(rule) ? methods._validityProp["custom"] : methods._validityProp[rule];
				 // If there is a validityProp for this rule, check to see if the field has an attribute for it
				if (validityProp != undefined) {
					custom_message = field.attr("data-errormessage-"+validityProp);
					// If there was an error message for it, return the message
					if (custom_message != undefined) 
						return custom_message;
				}
				custom_message = field.attr("data-errormessage");
				 // If there is an inline custom error message, return it
				if (custom_message != undefined) 
					return custom_message;
				var id = '#' + field.attr("id");
				// If we have custom messages for the element's id, get the message for the rule from the id.
				// Otherwise, if we have custom messages for the element's classes, use the first class message we find instead.
				if (typeof options.custom_error_messages[id] != "undefined" &&
					typeof options.custom_error_messages[id][rule] != "undefined" ) {
							  custom_message = options.custom_error_messages[id][rule]['message'];
				} else if (classes.length > 0) {
					for (var i = 0; i < classes.length && classes.length > 0; i++) {
						 var element_class = "." + classes[i];
						if (typeof options.custom_error_messages[element_class] != "undefined" &&
							typeof options.custom_error_messages[element_class][rule] != "undefined") {
								custom_message = options.custom_error_messages[element_class][rule]['message'];
								break;
						}
					}
				}
				if (!custom_message &&
					typeof options.custom_error_messages[rule] != "undefined" &&
					typeof options.custom_error_messages[rule]['message'] != "undefined"){
						 custom_message = options.custom_error_messages[rule]['message'];
				 }
				 return custom_message;
			 },
			 _validityProp: {
				 "required": "value-missing",
				 "custom": "custom-error",
				 "groupRequired": "value-missing",
				 "ajax": "custom-error",
				 "minSize": "range-underflow",
				 "maxSize": "range-overflow",
				 "min": "range-underflow",
				 "max": "range-overflow",
				 "past": "type-mismatch",
				 "future": "type-mismatch",
				 "dateRange": "type-mismatch",
				 "dateTimeRange": "type-mismatch",
				 "maxCheckbox": "range-overflow",
				 "minCheckbox": "range-underflow",
				 "equals": "pattern-mismatch",
				 "funcCall": "custom-error",
				 "creditCard": "pattern-mismatch",
				 "condRequired": "value-missing"
			 },
			/**
			* Required validation
			*
			* @param {jqObject} field
			* @param {Array[String]} rules
			* @param {int} i rules index
			* @param {Map}
			*            user options
			* @param {bool} condRequired flag when method is used for internal purpose in condRequired check
			* @return an error string if validation failed
			*/
			_required: function(field, rules, i, options, condRequired) {
				switch (field.prop("type")) {
					case "text":
					case "password":
					case "textarea":
					case "file":
					case "select-one":
					case "select-multiple":
					default:
						var field_val      = $.trim( field.val()                               );
						var dv_placeholder = $.trim( field.attr("data-validation-placeholder") );
						var placeholder    = $.trim( field.attr("placeholder")                 );
						if (
							   ( !field_val                                    )
							|| ( dv_placeholder && field_val == dv_placeholder )
							|| ( placeholder    && field_val == placeholder    )
						) {
							return options.allrules[rules[i]].alertText;
						}
						break;
					case "radio":
					case "checkbox":
						// new validation style to only check dependent field
						if (condRequired) {
							if (!field.attr('checked')) {
								return options.allrules[rules[i]].alertTextCheckboxMultiple;
							}
							break;
						}
						// old validation style
						var form = field.closest("form, .validationEngineContainer");
						var name = field.attr("name");
						if (form.find("input[name='" + name + "']:checked").size() == 0) {
							if (form.find("input[name='" + name + "']:visible").size() == 1)
								return options.allrules[rules[i]].alertTextCheckboxe;
							else
								return options.allrules[rules[i]].alertTextCheckboxMultiple;
						}
						break;
				}
			},
			/**
			* Validate that 1 from the group field is required
			*
			* @param {jqObject} field
			* @param {Array[String]} rules
			* @param {int} i rules index
			* @param {Map}
			*            user options
			* @return an error string if validation failed
			*/
			_groupRequired: function(field, rules, i, options) {
				var classGroup = "["+options.validateAttribute+"*=" +rules[i + 1] +"]";
				var isValid = false;
				// Check all fields from the group
				field.closest("form, .validationEngineContainer").find(classGroup).each(function(){
					if(!methods._required($(this), rules, i, options)){
						isValid = true;
						return false;
					}
				}); 
	
				if(!isValid) {
			  return options.allrules[rules[i]].alertText;
			}
			},
			/**
			* Validate rules
			*
			* @param {jqObject} field
			* @param {Array[String]} rules
			* @param {int} i rules index
			* @param {Map}
			*            user options
			* @return an error string if validation failed
			*/
			_custom: function(field, rules, i, options) {
				var customRule = rules[i + 1];
				var rule = options.allrules[customRule];
				var fn;
				if(!rule) {
					alert("jqv:custom rule not found - "+customRule);
					return;
				}
				
				if(rule["regex"]) {
					 var ex=rule.regex;
						if(!ex) {
							alert("jqv:custom regex not found - "+customRule);
							return;
						}
						var pattern = new RegExp(ex);
	
						if (!pattern.test(field.val())) return options.allrules[customRule].alertText;
						
				} else if(rule["func"]) {
					fn = rule["func"]; 
					 
					if (typeof(fn) !== "function") {
						alert("jqv:custom parameter 'function' is no function - "+customRule);
							return;
					}
					 
					if (!fn(field, rules, i, options))
						return options.allrules[customRule].alertText;
				} else {
					alert("jqv:custom type not allowed "+customRule);
						return;
				}
			},
			/**
			* Validate custom function outside of the engine scope
			*
			* @param {jqObject} field
			* @param {Array[String]} rules
			* @param {int} i rules index
			* @param {Map}
			*            user options
			* @return an error string if validation failed
			*/
			_funcCall: function(field, rules, i, options) {
				var functionName = rules[i + 1];
				var fn;
				if(functionName.indexOf('.') >-1)
				{
					var namespaces = functionName.split('.');
					var scope = window;
					while(namespaces.length)
					{
						scope = scope[namespaces.shift()];
					}
					fn = scope;
				}
				else
					fn = window[functionName] || options.customFunctions[functionName];
				if (typeof(fn) == 'function')
					return fn(field, rules, i, options);
	
			},
			/**
			* Field match
			*
			* @param {jqObject} field
			* @param {Array[String]} rules
			* @param {int} i rules index
			* @param {Map}
			*            user options
			* @return an error string if validation failed
			*/
			_equals: function(field, rules, i, options) {
				var equalsField = rules[i + 1];
	
				if (field.val() != $("#" + equalsField).val())
					return options.allrules.equals.alertText;
			},
			/**
			* Check the maximum size (in characters)
			*
			* @param {jqObject} field
			* @param {Array[String]} rules
			* @param {int} i rules index
			* @param {Map}
			*            user options
			* @return an error string if validation failed
			*/
			_maxSize: function(field, rules, i, options) {
				var max = rules[i + 1];
				var len = field.val().length;
	
				if (len > max) {
					var rule = options.allrules.maxSize;
					return rule.alertText + max + rule.alertText2;
				}
			},
			/**
			* Check the minimum size (in characters)
			*
			* @param {jqObject} field
			* @param {Array[String]} rules
			* @param {int} i rules index
			* @param {Map}
			*            user options
			* @return an error string if validation failed
			*/
			_minSize: function(field, rules, i, options) {
				var min = rules[i + 1];
				var len = field.val().length;
	
				if (len < min) {
					var rule = options.allrules.minSize;
					return rule.alertText + min + rule.alertText2;
				}
			},
			/**
			* Check number minimum value
			*
			* @param {jqObject} field
			* @param {Array[String]} rules
			* @param {int} i rules index
			* @param {Map}
			*            user options
			* @return an error string if validation failed
			*/
			_min: function(field, rules, i, options) {
				var min = parseFloat(rules[i + 1]);
				var len = parseFloat(field.val());
	
				if (len < min) {
					var rule = options.allrules.min;
					if (rule.alertText2) return rule.alertText + min + rule.alertText2;
					return rule.alertText + min;
				}
			},
			/**
			* Check number maximum value
			*
			* @param {jqObject} field
			* @param {Array[String]} rules
			* @param {int} i rules index
			* @param {Map}
			*            user options
			* @return an error string if validation failed
			*/
			_max: function(field, rules, i, options) {
				var max = parseFloat(rules[i + 1]);
				var len = parseFloat(field.val());
	
				if (len >max ) {
					var rule = options.allrules.max;
					if (rule.alertText2) return rule.alertText + max + rule.alertText2;
					//orefalo: to review, also do the translations
					return rule.alertText + max;
				}
			},
			/**
			* Checks date is in the past
			*
			* @param {jqObject} field
			* @param {Array[String]} rules
			* @param {int} i rules index
			* @param {Map}
			*            user options
			* @return an error string if validation failed
			*/
			_past: function(form, field, rules, i, options) {
	
				var p=rules[i + 1];
				var fieldAlt = $(form.find("input[name='" + p.replace(/^#+/, '') + "']"));
				var pdate;
	
				if (p.toLowerCase() == "now") {
					pdate = new Date();
				} else if (undefined != fieldAlt.val()) {
					if (fieldAlt.is(":disabled"))
						return;
					pdate = methods._parseDate(fieldAlt.val());
				} else {
					pdate = methods._parseDate(p);
				}
				var vdate = methods._parseDate(field.val());
	
				if (vdate > pdate ) {
					var rule = options.allrules.past;
					if (rule.alertText2) return rule.alertText + methods._dateToString(pdate) + rule.alertText2;
					return rule.alertText + methods._dateToString(pdate);
				}
			},
			/**
			* Checks date is in the future
			*
			* @param {jqObject} field
			* @param {Array[String]} rules
			* @param {int} i rules index
			* @param {Map}
			*            user options
			* @return an error string if validation failed
			*/
			_future: function(form, field, rules, i, options) {
	
				var p=rules[i + 1];
				var fieldAlt = $(form.find("input[name='" + p.replace(/^#+/, '') + "']"));
				var pdate;
	
				if (p.toLowerCase() == "now") {
					pdate = new Date();
				} else if (undefined != fieldAlt.val()) {
					if (fieldAlt.is(":disabled"))
						return;
					pdate = methods._parseDate(fieldAlt.val());
				} else {
					pdate = methods._parseDate(p);
				}
				var vdate = methods._parseDate(field.val());
	
				if (vdate < pdate ) {
					var rule = options.allrules.future;
					if (rule.alertText2)
						return rule.alertText + methods._dateToString(pdate) + rule.alertText2;
					return rule.alertText + methods._dateToString(pdate);
				}
			},
			/**
			* Checks if valid date
			*
			* @param {string} date string
			* @return a bool based on determination of valid date
			*/
			_isDate: function (value) {
				var dateRegEx = new RegExp(/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$|^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(?:(?:0?[1-9]|1[0-2])(\/|-)(?:0?[1-9]|1\d|2[0-8]))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(0?2(\/|-)29)(\/|-)(?:(?:0[48]00|[13579][26]00|[2468][048]00)|(?:\d\d)?(?:0[48]|[2468][048]|[13579][26]))$/);
				return dateRegEx.test(value);
			},
			/**
			* Checks if valid date time
			*
			* @param {string} date string
			* @return a bool based on determination of valid date time
			*/
			_isDateTime: function (value){
				var dateTimeRegEx = new RegExp(/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])\s+(1[012]|0?[1-9]){1}:(0?[1-5]|[0-6][0-9]){1}:(0?[0-6]|[0-6][0-9]){1}\s+(am|pm|AM|PM){1}$|^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^((1[012]|0?[1-9]){1}\/(0?[1-9]|[12][0-9]|3[01]){1}\/\d{2,4}\s+(1[012]|0?[1-9]){1}:(0?[1-5]|[0-6][0-9]){1}:(0?[0-6]|[0-6][0-9]){1}\s+(am|pm|AM|PM){1})$/);
				return dateTimeRegEx.test(value);
			},
			//Checks if the start date is before the end date
			//returns true if end is later than start
			_dateCompare: function (start, end) {
				return (new Date(start.toString()) < new Date(end.toString()));
			},
			/**
			* Checks date range
			*
			* @param {jqObject} first field name
			* @param {jqObject} second field name
			* @return an error string if validation failed
			*/
			_dateRange: function (field, rules, i, options) {
				//are not both populated
				if ((!options.firstOfGroup[0].value && options.secondOfGroup[0].value) || (options.firstOfGroup[0].value && !options.secondOfGroup[0].value)) {
					return options.allrules[rules[i]].alertText + options.allrules[rules[i]].alertText2;
				}
	
				//are not both dates
				if (!methods._isDate(options.firstOfGroup[0].value) || !methods._isDate(options.secondOfGroup[0].value)) {
					return options.allrules[rules[i]].alertText + options.allrules[rules[i]].alertText2;
				}
	
				//are both dates but range is off
				if (!methods._dateCompare(options.firstOfGroup[0].value, options.secondOfGroup[0].value)) {
					return options.allrules[rules[i]].alertText + options.allrules[rules[i]].alertText2;
				}
			},
			/**
			* Checks date time range
			*
			* @param {jqObject} first field name
			* @param {jqObject} second field name
			* @return an error string if validation failed
			*/
			_dateTimeRange: function (field, rules, i, options) {
				//are not both populated
				if ((!options.firstOfGroup[0].value && options.secondOfGroup[0].value) || (options.firstOfGroup[0].value && !options.secondOfGroup[0].value)) {
					return options.allrules[rules[i]].alertText + options.allrules[rules[i]].alertText2;
				}
				//are not both dates
				if (!methods._isDateTime(options.firstOfGroup[0].value) || !methods._isDateTime(options.secondOfGroup[0].value)) {
					return options.allrules[rules[i]].alertText + options.allrules[rules[i]].alertText2;
				}
				//are both dates but range is off
				if (!methods._dateCompare(options.firstOfGroup[0].value, options.secondOfGroup[0].value)) {
					return options.allrules[rules[i]].alertText + options.allrules[rules[i]].alertText2;
				}
			},
			/**
			* Max number of checkbox selected
			*
			* @param {jqObject} field
			* @param {Array[String]} rules
			* @param {int} i rules index
			* @param {Map}
			*            user options
			* @return an error string if validation failed
			*/
			_maxCheckbox: function(form, field, rules, i, options) {
	
				var nbCheck = rules[i + 1];
				var groupname = field.attr("name");
				var groupSize = form.find("input[name='" + groupname + "']:checked").size();
				if (groupSize > nbCheck) {
					options.showArrow = false;
					if (options.allrules.maxCheckbox.alertText2)
						 return options.allrules.maxCheckbox.alertText + " " + nbCheck + " " + options.allrules.maxCheckbox.alertText2;
					return options.allrules.maxCheckbox.alertText;
				}
			},
			/**
			* Min number of checkbox selected
			*
			* @param {jqObject} field
			* @param {Array[String]} rules
			* @param {int} i rules index
			* @param {Map}
			*            user options
			* @return an error string if validation failed
			*/
			_minCheckbox: function(form, field, rules, i, options) {
	
				var nbCheck = rules[i + 1];
				var groupname = field.attr("name");
				var groupSize = form.find("input[name='" + groupname + "']:checked").size();
				if (groupSize < nbCheck) {
					options.showArrow = false;
					return options.allrules.minCheckbox.alertText + " " + nbCheck + " " + options.allrules.minCheckbox.alertText2;
				}
			},
			/**
			* Checks that it is a valid credit card number according to the
			* Luhn checksum algorithm.
			*
			* @param {jqObject} field
			* @param {Array[String]} rules
			* @param {int} i rules index
			* @param {Map}
			*            user options
			* @return an error string if validation failed
			*/
			_creditCard: function(field, rules, i, options) {
				//spaces and dashes may be valid characters, but must be stripped to calculate the checksum.
				var valid = false, cardNumber = field.val().replace(/ +/g, '').replace(/-+/g, '');
	
				var numDigits = cardNumber.length;
				if (numDigits >= 14 && numDigits <= 16 && parseInt(cardNumber) > 0) {
	
					var sum = 0, i = numDigits - 1, pos = 1, digit, luhn = new String();
					do {
						digit = parseInt(cardNumber.charAt(i));
						luhn += (pos++ % 2 == 0) ? digit * 2 : digit;
					} while (--i >= 0)
	
					for (i = 0; i < luhn.length; i++) {
						sum += parseInt(luhn.charAt(i));
					}
					valid = sum % 10 == 0;
				}
				if (!valid) return options.allrules.creditCard.alertText;
			},
			/**
			* Ajax field validation
			*
			* @param {jqObject} field
			* @param {Array[String]} rules
			* @param {int} i rules index
			* @param {Map}
			*            user options
			* @return nothing! the ajax validator handles the prompts itself
			*/
			 _ajax: function(field, rules, i, options) {
	
				 var errorSelector = rules[i + 1];
				 var rule = options.allrules[errorSelector];
				 var extraData = rule.extraData;
				 var extraDataDynamic = rule.extraDataDynamic;
				 var data = {
					"fieldId" : field.attr("id"),
					"fieldValue" : field.val()
				 };
	
				 if (typeof extraData === "object") {
					$.extend(data, extraData);
				 } else if (typeof extraData === "string") {
					var tempData = extraData.split("&");
					for(var i = 0; i < tempData.length; i++) {
						var values = tempData[i].split("=");
						if (values[0] && values[0]) {
							data[values[0]] = values[1];
						}
					}
				 }
	
				 if (extraDataDynamic) {
					 var tmpData = [];
					 var domIds = String(extraDataDynamic).split(",");
					 for (var i = 0; i < domIds.length; i++) {
						 var id = domIds[i];
						 if ($(id).length) {
							 var inputValue = field.closest("form, .validationEngineContainer").find(id).val();
							 var keyValue = id.replace('#', '') + '=' + escape(inputValue);
							 data[id.replace('#', '')] = inputValue;
						 }
					 }
				 }
				 
				 // If a field change event triggered this we want to clear the cache for this ID
				 if (options.eventTrigger == "field") {
					delete(options.ajaxValidCache[field.attr("id")]);
				 }
	
				 // If there is an error or if the the field is already validated, do not re-execute AJAX
				 if (!options.isError && !methods._checkAjaxFieldStatus(field.attr("id"), options)) {
					 $.ajax({
						 type: options.ajaxFormValidationMethod,
						 url: rule.url,
						 cache: false,
						 dataType: "json",
						 data: data,
						 field: field,
						 rule: rule,
						 methods: methods,
						 options: options,
						 beforeSend: function() {},
						 error: function(data, transport) {
							 methods._ajaxError(data, transport);
						 },
						 success: function(json) {
	
							 // asynchronously called on success, data is the json answer from the server
							 var errorFieldId = json[0];
							 //var errorField = $($("#" + errorFieldId)[0]);
							 var errorField = $("#"+ errorFieldId).eq(0);
	
							 // make sure we found the element
							 if (errorField.length == 1) {
								 var status = json[1];
								 // read the optional msg from the server
								 var msg = json[2];
								 if (!status) {
									 // Houston we got a problem - display an red prompt
									 options.ajaxValidCache[errorFieldId] = false;
									 options.isError = true;
	
									 // resolve the msg prompt
									 if(msg) {
										 if (options.allrules[msg]) {
											 var txt = options.allrules[msg].alertText;
											 if (txt) {
												msg = txt;
								}
										 }
									 }
									 else
										msg = rule.alertText;
	
									 if (options.showPrompts) methods._showPrompt(errorField, msg, "", true, options);
								 } else {
									 options.ajaxValidCache[errorFieldId] = true;
	
									 // resolves the msg prompt
									 if(msg) {
										 if (options.allrules[msg]) {
											 var txt = options.allrules[msg].alertTextOk;
											 if (txt) {
												msg = txt;
								}
										 }
									 }
									 else
									 msg = rule.alertTextOk;
	
									 if (options.showPrompts) {
										 // see if we should display a green prompt
										 if (msg)
											methods._showPrompt(errorField, msg, "pass", true, options);
										 else
											methods._closePrompt(errorField);
									}
									
									 // If a submit form triggered this, we want to re-submit the form
									 if (options.eventTrigger == "submit")
										field.closest("form").submit();
								 }
							 }
							 errorField.trigger("jqv.field.result", [errorField, options.isError, msg]);
						 }
					 });
					 
					 return rule.alertTextLoad;
				 }
			 },
			/**
			* Common method to handle ajax errors
			*
			* @param {Object} data
			* @param {Object} transport
			*/
			_ajaxError: function(data, transport) {
				if(data.status == 0 && transport == null)
					alert("The page is not served from a server! ajax call failed");
				else if(typeof console != "undefined")
					console.log("Ajax error: " + data.status + " " + transport);
			},
			/**
			* date -> string
			*
			* @param {Object} date
			*/
			_dateToString: function(date) {
				return date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate();
			},
			/**
			* Parses an ISO date
			* @param {String} d
			*/
			_parseDate: function(d) {
	
				var dateParts = d.split("-");
				if(dateParts==d)
					dateParts = d.split("/");
				if(dateParts==d) {
					dateParts = d.split(".");
					return new Date(dateParts[2], (dateParts[1] - 1), dateParts[0]);
				}
				return new Date(dateParts[0], (dateParts[1] - 1) ,dateParts[2]);
			},
			/**
			* Builds or updates a prompt with the given information
			*
			* @param {jqObject} field
			* @param {String} promptText html text to display type
			* @param {String} type the type of bubble: 'pass' (green), 'load' (black) anything else (red)
			* @param {boolean} ajaxed - use to mark fields than being validated with ajax
			* @param {Map} options user options
			*/
			 _showPrompt: function(field, promptText, type, ajaxed, options, ajaxform) {
				 var prompt = methods._getPrompt(field);
				 // The ajax submit errors are not see has an error in the form,
				 // When the form errors are returned, the engine see 2 bubbles, but those are ebing closed by the engine at the same time
				 // Because no error was found befor submitting
				 if(ajaxform) prompt = false;
				 // Check that there is indded text
				 if($.trim(promptText)){ 
					 if (prompt)
						methods._updatePrompt(field, prompt, promptText, type, ajaxed, options);
					 else
						methods._buildPrompt(field, promptText, type, ajaxed, options);
				}
			 },
			/**
			* Builds and shades a prompt for the given field.
			*
			* @param {jqObject} field
			* @param {String} promptText html text to display type
			* @param {String} type the type of bubble: 'pass' (green), 'load' (black) anything else (red)
			* @param {boolean} ajaxed - use to mark fields than being validated with ajax
			* @param {Map} options user options
			*/
			_buildPrompt: function(field, promptText, type, ajaxed, options) {
	
				// create the prompt
				var prompt = $('<div>');
				prompt.addClass(methods._getClassName(field.attr("id")) + "formError");
				// add a class name to identify the parent form of the prompt
				prompt.addClass("parentForm"+methods._getClassName(field.closest('form, .validationEngineContainer').attr("id")));
				prompt.addClass("formError");
	
				switch (type) {
					case "pass":
						prompt.addClass("greenPopup");
						break;
					case "load":
						prompt.addClass("blackPopup");
						break;
					default:
						/* it has error  */
						//alert("unknown popup type:"+type);
				}
				if (ajaxed)
					prompt.addClass("ajaxed");
	
				// create the prompt content
				var promptContent = $('<div>').addClass("formErrorContent").html(promptText).appendTo(prompt);
	
				// determine position type
				var positionType=field.data("promptPosition") || options.promptPosition;
	
				// create the css arrow pointing at the field
				// note that there is no triangle on max-checkbox and radio
				if (options.showArrow) {
					var arrow = $('<div>').addClass("formErrorArrow");
	
					//prompt positioning adjustment support. Usage: positionType:Xshift,Yshift (for ex.: bottomLeft:+20 or bottomLeft:-20,+10)
					if (typeof(positionType)=='string') 
					{
						var pos=positionType.indexOf(":");
						if(pos!=-1)
							positionType=positionType.substring(0,pos);
					}
	
					switch (positionType) {
						case "bottomLeft":
						case "bottomRight":
							prompt.find(".formErrorContent").before(arrow);
							arrow.addClass("formErrorArrowBottom").html('<div class="line1"><!-- --></div><div class="line2"><!-- --></div><div class="line3"><!-- --></div><div class="line4"><!-- --></div><div class="line5"><!-- --></div><div class="line6"><!-- --></div><div class="line7"><!-- --></div><div class="line8"><!-- --></div><div class="line9"><!-- --></div><div class="line10"><!-- --></div>');
							break;
						case "topLeft":
						case "topRight":
							arrow.html('<div class="line10"><!-- --></div><div class="line9"><!-- --></div><div class="line8"><!-- --></div><div class="line7"><!-- --></div><div class="line6"><!-- --></div><div class="line5"><!-- --></div><div class="line4"><!-- --></div><div class="line3"><!-- --></div><div class="line2"><!-- --></div><div class="line1"><!-- --></div>');
							prompt.append(arrow);
							break;
					}
				}
				// Add custom prompt class
				if (options.addPromptClass)
					prompt.addClass(options.addPromptClass);
	
	            // Add custom prompt class defined in element
	            var requiredOverride = field.attr('data-required-class');
	            if(requiredOverride !== undefined) {
	                prompt.addClass(requiredOverride);
	            } else {
	                if(options.prettySelect) {
	                    if($('#' + field.attr('id')).next().is('select')) {
	                        var prettyOverrideClass = $('#' + field.attr('id').substr(options.usePrefix.length).substring(options.useSuffix.length)).attr('data-required-class');
	                        if(prettyOverrideClass !== undefined) {
	                            prompt.addClass(prettyOverrideClass);
	                        }
	                    }
	                }
	            }
	
				prompt.css({
					"opacity": 0
				});
				if(positionType === 'inline') {
					prompt.addClass("inline");
					if(typeof field.attr('data-prompt-target') !== 'undefined' && $('#'+field.attr('data-prompt-target')).length > 0) {
						prompt.appendTo($('#'+field.attr('data-prompt-target')));
					} else {
						field.after(prompt);
					}
				} else {
					field.before(prompt);				
				}
				
				var pos = methods._calculatePosition(field, prompt, options);
				prompt.css({
					'position': positionType === 'inline' ? 'relative' : 'absolute',
					"top": pos.callerTopPosition,
					"left": pos.callerleftPosition,
					"marginTop": pos.marginTopSize,
					"opacity": 0
				}).data("callerField", field);
				
	
				if (options.autoHidePrompt) {
					setTimeout(function(){
						prompt.animate({
							"opacity": 0
						},function(){
							prompt.closest('.formErrorOuter').remove();
							prompt.remove();
						});
					}, options.autoHideDelay);
				} 
				return prompt.animate({
					"opacity": 0.87
				});
			},
			/**
			* Updates the prompt text field - the field for which the prompt
			* @param {jqObject} field
			* @param {String} promptText html text to display type
			* @param {String} type the type of bubble: 'pass' (green), 'load' (black) anything else (red)
			* @param {boolean} ajaxed - use to mark fields than being validated with ajax
			* @param {Map} options user options
			*/
			_updatePrompt: function(field, prompt, promptText, type, ajaxed, options, noAnimation) {
	
				if (prompt) {
					if (typeof type !== "undefined") {
						if (type == "pass")
							prompt.addClass("greenPopup");
						else
							prompt.removeClass("greenPopup");
	
						if (type == "load")
							prompt.addClass("blackPopup");
						else
							prompt.removeClass("blackPopup");
					}
					if (ajaxed)
						prompt.addClass("ajaxed");
					else
						prompt.removeClass("ajaxed");
	
					prompt.find(".formErrorContent").html(promptText);
	
					var pos = methods._calculatePosition(field, prompt, options);
					var css = {"top": pos.callerTopPosition,
					"left": pos.callerleftPosition,
					"marginTop": pos.marginTopSize};
	
					if (noAnimation)
						prompt.css(css);
					else
						prompt.animate(css);
				}
			},
			/**
			* Closes the prompt associated with the given field
			*
			* @param {jqObject}
			*            field
			*/
			 _closePrompt: function(field) {
				 var prompt = methods._getPrompt(field);
				 if (prompt)
					 prompt.fadeTo("fast", 0, function() {
						 prompt.parent('.formErrorOuter').remove();
						 prompt.remove();
					 });
			 },
			 closePrompt: function(field) {
				 return methods._closePrompt(field);
			 },
			/**
			* Returns the error prompt matching the field if any
			*
			* @param {jqObject}
			*            field
			* @return undefined or the error prompt (jqObject)
			*/
			_getPrompt: function(field) {
					var formId = $(field).closest('form, .validationEngineContainer').attr('id');
				var className = methods._getClassName(field.attr("id")) + "formError";
					var match = $("." + methods._escapeExpression(className) + '.parentForm' + formId)[0];
				if (match)
				return $(match);
			},
			/**
			  * Returns the escapade classname
			  *
			  * @param {selector}
			  *            className
			  */
			  _escapeExpression: function (selector) {
				  return selector.replace(/([#;&,\.\+\*\~':"\!\^$\[\]\(\)=>\|])/g, "\\$1");
			  },
			/**
			 * returns true if we are in a RTLed document
			 *
			 * @param {jqObject} field
			 */
			isRTL: function(field)
			{
				var $document = $(document);
				var $body = $('body');
				var rtl =
					(field && field.hasClass('rtl')) ||
					(field && (field.attr('dir') || '').toLowerCase()==='rtl') ||
					$document.hasClass('rtl') ||
					($document.attr('dir') || '').toLowerCase()==='rtl' ||
					$body.hasClass('rtl') ||
					($body.attr('dir') || '').toLowerCase()==='rtl';
				return Boolean(rtl);
			},
			/**
			* Calculates prompt position
			*
			* @param {jqObject}
			*            field
			* @param {jqObject}
			*            the prompt
			* @param {Map}
			*            options
			* @return positions
			*/
			_calculatePosition: function (field, promptElmt, options) {
	
				var promptTopPosition, promptleftPosition, marginTopSize;
				var fieldWidth 	= field.width();
				var fieldLeft 	= field.position().left; 
				var fieldTop 	=  field.position().top;
				var fieldHeight 	=  field.height();	
				var promptHeight = promptElmt.height();
	
	
				// is the form contained in an overflown container?
				promptTopPosition = promptleftPosition = 0;
				// compensation for the arrow
				marginTopSize = -promptHeight;
			
	
				//prompt positioning adjustment support
				//now you can adjust prompt position
				//usage: positionType:Xshift,Yshift
				//for example:
				//   bottomLeft:+20 means bottomLeft position shifted by 20 pixels right horizontally
				//   topRight:20, -15 means topRight position shifted by 20 pixels to right and 15 pixels to top
				//You can use +pixels, - pixels. If no sign is provided than + is default.
				var positionType=field.data("promptPosition") || options.promptPosition;
				var shift1="";
				var shift2="";
				var shiftX=0;
				var shiftY=0;
				if (typeof(positionType)=='string') {
					//do we have any position adjustments ?
					if (positionType.indexOf(":")!=-1) {
						shift1=positionType.substring(positionType.indexOf(":")+1);
						positionType=positionType.substring(0,positionType.indexOf(":"));
	
						//if any advanced positioning will be needed (percents or something else) - parser should be added here
						//for now we use simple parseInt()
	
						//do we have second parameter?
						if (shift1.indexOf(",") !=-1) {
							shift2=shift1.substring(shift1.indexOf(",") +1);
							shift1=shift1.substring(0,shift1.indexOf(","));
							shiftY=parseInt(shift2);
							if (isNaN(shiftY)) shiftY=0;
						};
	
						shiftX=parseInt(shift1);
						if (isNaN(shift1)) shift1=0;
	
					};
				};
	
				
				switch (positionType) {
					default:
					case "topRight":
						promptleftPosition +=  fieldLeft + fieldWidth - 30;
						promptTopPosition +=  fieldTop;
						break;
	
					case "topLeft":
						promptTopPosition +=  fieldTop;
						promptleftPosition += fieldLeft; 
						break;
	
					case "centerRight":
						promptTopPosition = fieldTop+4;
						marginTopSize = 0;
						promptleftPosition= fieldLeft + field.outerWidth(true)+5;
						break;
					case "centerLeft":
						promptleftPosition = fieldLeft - (promptElmt.width() + 2);
						promptTopPosition = fieldTop+4;
						marginTopSize = 0;
						
						break;
	
					case "bottomLeft":
						promptTopPosition = fieldTop + field.height() + 5;
						marginTopSize = 0;
						promptleftPosition = fieldLeft;
						break;
					case "bottomRight":
						promptleftPosition = fieldLeft + fieldWidth - 30;
						promptTopPosition =  fieldTop +  field.height() + 5;
						marginTopSize = 0;
						break;
					case "inline":
						promptleftPosition = 0;
						promptTopPosition = 0;
						marginTopSize = 0;
				};
	
			
	
				//apply adjusments if any
				promptleftPosition += shiftX;
				promptTopPosition  += shiftY;
	
				return {
					"callerTopPosition": promptTopPosition + "px",
					"callerleftPosition": promptleftPosition + "px",
					"marginTopSize": marginTopSize + "px"
				};
			},
			/**
			* Saves the user options and variables in the form.data
			*
			* @param {jqObject}
			*            form - the form where the user option should be saved
			* @param {Map}
			*            options - the user options
			* @return the user options (extended from the defaults)
			*/
			 _saveOptions: function(form, options) {
	
				 // is there a language localisation ?
				 if ($.validationEngineLanguage)
				 var allRules = $.validationEngineLanguage.allRules;
				 else
				 $.error("jQuery.validationEngine rules are not loaded, plz add localization files to the page");
				 // --- Internals DO NOT TOUCH or OVERLOAD ---
				 // validation rules and i18
				 $.validationEngine.defaults.allrules = allRules;
	
				 var userOptions = $.extend(true,{},$.validationEngine.defaults,options);
	
				 form.data('jqv', userOptions);
				 return userOptions;
			 },
	
			 /**
			 * Removes forbidden characters from class name
			 * @param {String} className
			 */
			 _getClassName: function(className) {
				 if(className)
					 return className.replace(/:/g, "_").replace(/\./g, "_");
						  },
			/**
			 * Escape special character for jQuery selector
			 * http://totaldev.com/content/escaping-characters-get-valid-jquery-id
			 * @param {String} selector
			 */
			 _jqSelector: function(str){
				return str.replace(/([;&,\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g, '\\$1');
			},
			/**
			* Conditionally required field
			*
			* @param {jqObject} field
			* @param {Array[String]} rules
			* @param {int} i rules index
			* @param {Map}
			* user options
			* @return an error string if validation failed
			*/
			_condRequired: function(field, rules, i, options) {
				var idx, dependingField;
	
				for(idx = (i + 1); idx < rules.length; idx++) {
					dependingField = jQuery("#" + rules[idx]).first();
	
					/* Use _required for determining wether dependingField has a value.
					 * There is logic there for handling all field types, and default value; so we won't replicate that here
					 * Indicate this special use by setting the last parameter to true so we only validate the dependingField on chackboxes and radio buttons (#462)
					 */
					if (dependingField.length && methods._required(dependingField, ["required"], 0, options, true) == undefined) {
						/* We now know any of the depending fields has a value,
						 * so we can validate this field as per normal required code
						 */
						return methods._required(field, ["required"], 0, options);
					}
				}
			},
	
		    _submitButtonClick: function(event) {
		        var button = $(this);
		        var form = button.closest('form, .validationEngineContainer');
		        form.data("jqv_submitButton", button.attr("id"));
		    }
			  };
	
		 /**
		 * Plugin entry point.
		 * You may pass an action as a parameter or a list of options.
		 * if none, the init and attach methods are being called.
		 * Remember: if you pass options, the attached method is NOT called automatically
		 *
		 * @param {String}
		 *            method (optional) action
		 */
		 $.fn.validationEngine = function(method) {
	
			 var form = $(this);
			 if(!form[0]) return form;  // stop here if the form does not exist
	
			 if (typeof(method) == 'string' && method.charAt(0) != '_' && methods[method]) {
	
				 // make sure init is called once
				 if(method != "showPrompt" && method != "hide" && method != "hideAll")
				 methods.init.apply(form);
	
				 return methods[method].apply(form, Array.prototype.slice.call(arguments, 1));
			 } else if (typeof method == 'object' || !method) {
	
				 // default constructor with or without arguments
				 methods.init.apply(form, arguments);
				 return methods.attach.apply(form);
			 } else {
				 $.error('Method ' + method + ' does not exist in jQuery.validationEngine');
			 }
		};
	
	
	
		// LEAK GLOBAL OPTIONS
		$.validationEngine= {fieldIdCounter: 0,defaults:{
	
			// Name of the event triggering field validation
			validationEventTrigger: "blur",
			// Automatically scroll viewport to the first error
			scroll: true,
			// Focus on the first input
			focusFirstField:true,
			// Show prompts, set to false to disable prompts
			showPrompts: true,
	       // Should we attempt to validate non-visible input fields contained in the form? (Useful in cases of tabbed containers, e.g. jQuery-UI tabs)
	       validateNonVisibleFields: false,
			// Opening box position, possible locations are: topLeft,
			// topRight, bottomLeft, centerRight, bottomRight, inline
			// inline gets inserted after the validated field or into an element specified in data-prompt-target
			promptPosition: "topRight",
			bindMethod:"bind",
			// internal, automatically set to true when it parse a _ajax rule
			inlineAjax: false,
			// if set to true, the form data is sent asynchronously via ajax to the form.action url (get)
			ajaxFormValidation: false,
			// The url to send the submit ajax validation (default to action)
			ajaxFormValidationURL: false,
			// HTTP method used for ajax validation
			ajaxFormValidationMethod: 'get',
			// Ajax form validation callback method: boolean onComplete(form, status, errors, options)
			// retuns false if the form.submit event needs to be canceled.
			onAjaxFormComplete: $.noop,
			// called right before the ajax call, may return false to cancel
			onBeforeAjaxFormValidation: $.noop,
			// Stops form from submitting and execute function assiciated with it
			onValidationComplete: false,
	
			// Used when you have a form fields too close and the errors messages are on top of other disturbing viewing messages
			doNotShowAllErrosOnSubmit: false,
			// Object where you store custom messages to override the default error messages
			custom_error_messages:{},
			// true if you want to vind the input fields
			binded: true,
			// set to true, when the prompt arrow needs to be displayed
			showArrow: true,
			// did one of the validation fail ? kept global to stop further ajax validations
			isError: false,
			// Limit how many displayed errors a field can have
			maxErrorsPerField: false,
			
			// Caches field validation status, typically only bad status are created.
			// the array is used during ajax form validation to detect issues early and prevent an expensive submit
			ajaxValidCache: {},
			// Auto update prompt position after window resize
			autoPositionUpdate: false,
	
			InvalidFields: [],
			onFieldSuccess: false,
			onFieldFailure: false,
			onSuccess: false,
			onFailure: false,
			validateAttribute: "class",
			addSuccessCssClassToField: "",
			addFailureCssClassToField: "",
			
			// Auto-hide prompt
			autoHidePrompt: false,
			// Delay before auto-hide
			autoHideDelay: 10000,
			// Fade out duration while hiding the validations
			fadeDuration: 0.3,
		 // Use Prettify select library
		 prettySelect: false,
		 // Add css class on prompt
		 addPromptClass : "",
		 // Custom ID uses prefix
		 usePrefix: "",
		 // Custom ID uses suffix
		 useSuffix: "",
		 // Only show one message per error prompt
		 showOneMessage: false
		}};
		$(function(){$.validationEngine.defaults.promptPosition = methods.isRTL()?'topLeft':"topRight"});
	})(jQuery);
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 54 */
13,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./en/validationengine.lang.js": 56,
		"./zh_CN/validationengine.lang.js": 57
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 55;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {(function ($) {
	  $.validationEngineLanguage = {
	    en: {
	      "queryReport": {
	        "regex": "none",
	        "alertText": "* 'Status trap interval' must be an integer multiple of 'Query Interval'"
	      },
	      "giveName": {
	        "regex": /^[a-zA-Z0-9_\-\u4e00-\u9fa5]+$/i,
	        "alertText": "* Invalid name"
	      },
	      "alias": {
	        "regex": /^[a-zA-Z0-9_\-\u4e00-\u9fa5]+$/i,
	        "alertText": "*Invalid alias"
	      },
	      "username": {
	        "regex": /^[A-Za-z0-9_\-]+$/,
	        "alertText": "*Invalid username"
	      },
	      "required": { // Add your regex rules here, you can take telephone as an example
	        "regex": "none",
	        "alertText": "* This field is required",
	        "alertTextCheckboxMultiple": "* Please select an option",
	        "alertTextCheckboxe": "* This checkbox is required",
	        "alertTextDateRange": "* Both date range fields are required"
	      },
	      "requiredInFunction": {
	        "func": function (field, rules, i, options) {
	          return (field.val() == "test") ? true : false;
	        },
	        "alertText": "* Field must equal \'test\' "
	      },
	      "dateRange": {
	        "regex": "none",
	        "alertText": "* Invalid ",
	        "alertText2": "Date range"
	      },
	      "dateTimeRange": {
	        "regex": "none",
	        "alertText": "* Invalid ",
	        "alertText2": "Date time range"
	      },
	      "minSize": {
	        "regex": "none",
	        "alertText": "* Minimum ",
	        "alertText2": " characters allowed"
	      },
	      "maxSize": {
	        "regex": "none",
	        "alertText": "* Maximum ",
	        "alertText2": " characters allowed"
	      },
	      "groupRequired": {
	        "regex": "none",
	        "alertText": "* You must fill one of the following fields"
	      },
	      "min": {
	        "regex": "none",
	        "alertText": "* Minimum value is "
	      },
	      "max": {
	        "regex": "none",
	        "alertText": "* Maximum value is "
	      },
	      "past": {
	        "regex": "none",
	        "alertText": "* Date prior to "
	      },
	      "future": {
	        "regex": "none",
	        "alertText": "* Date past "
	      },
	      "maxCheckbox": {
	        "regex": "none",
	        "alertText": "* Maximum ",
	        "alertText2": " options allowed"
	      },
	      "minCheckbox": {
	        "regex": "none",
	        "alertText": "* Please select ",
	        "alertText2": " options"
	      },
	      "password": {
	//                	"regex": /^[A-Za-z0-9_\!\@\#\$\%\^\&\*\.]+$/,
	        "regex": /^[A-Za-z0-9_\!\@\#\$\%\^\&\*\.\+\=\-\~\,\[\]\(\)]+$/,
	        "alertText": "* Contains illegal characters"
	      },
	      "equals": {
	        "regex": "none",
	        "alertText": "* Fields do not match"
	      },
	      "creditCard": {
	        "regex": "none",
	        "alertText": "* Invalid credit card number"
	      },
	      "serialNumber2": {
	        "regex": /^[a-zA-Z]{2}[0-9]{13}$/,
	        "alertText": "* Please input the 15 letter serial number of the gateway"
	      },
	      "serialNumber": {
	        "regex": /^[a-zA-Z0-9]+$/,
	        "alertText": "* Only numbers and letters are allowed"
	      },
	      "phone": {
	        // credit: jquery.h5validate.js / orefalo
	        "regex": /^([\+][0-9]{1,3}[\ \.\-])?([\(]{1}[0-9]{2,6}[\)])?([0-9\ \.\-\/]{3,20})((x|ext|extension)[\ ]?[0-9]{1,4})?$/,
	        "alertText": "* Invalid fax number"
	      },
	      "phone1": {
	        // credit: jquery.h5validate.js / orefalo
	        "regex": /^(\+?[0-9]{2,4}\-?\s?)?([0-9]{3,4}\-?\s?)?([0-9]{7,8})(\-[0-9]+)?$/,
	//                	"regex": /^(\+[0-9]{2,4}\-?\s?)?([0-9]{3,4}\-?\s?)?([0-9]{7,8})(\-[0-9]+)?$/,
	        "alertText": "* Invalid phone number"
	      },
	      "mobile": {
	        "regex": /^1[3|4|5|8][0-9]\d{8,8}$/,
	        "alertText": "* Invalid mobile number"
	      },
	      "email": {
	        // HTML5 compatible email regex ( http://www.whatwg.org/specs/web-apps/current-work/multipage/states-of-the-type-attribute.html#    e-mail-state-%28type=email%29 )
	        "regex": /^admin$|^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	        "alertText": "* Invalid email address"
	      },
	      "integer": {
	        "regex": /^[\-\+]?\d+$/,
	        "alertText": "* Not a valid integer"
	      },
	      "number": {
	        // Number, including positive, negative, and floating decimal. credit: orefalo
	        "regex": /^[\-\+]?((([0-9]{1,3})([,][0-9]{3})*)|([0-9]+))?([\.]([0-9]+))?$/,
	        "alertText": "* Invalid number: it must be a positive or negative decimal"
	      },
	      "date": {
	        //	Check if date is valid by leap year
	        "func": function (field) {
	          var pattern = new RegExp(/^(\d{4})[\/\-\.](0?[1-9]|1[012])[\/\-\.](0?[1-9]|[12][0-9]|3[01])$/);
	          var match = pattern.exec(field.val());
	          if (match == null)
	            return false;
	
	          var year = match[1];
	          var month = match[2] * 1;
	          var day = match[3] * 1;
	          var date = new Date(year, month - 1, day); // because months starts from 0.
	
	          return (date.getFullYear() == year && date.getMonth() == (month - 1) && date.getDate() == day);
	        },
	        "alertText": "* Invalid date: must be in YYYY-MM-DD format"
	      },
	      "ipv4": {
	        "regex": /^((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]\d)|\d)(\.((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]\d)|\d)){3}$|^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}$/,
	        "alertText": "* Invalid IP address"
	      },
	      "url": {
	        "regex": /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
	        "alertText": "* Invalid URL"
	      },
	      "url1": {
	        "regex": /^((https?|ftp):\/\/)?(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
	        "alertText": "* Invalid URL"
	      },
	      "onlyNumberSp": {
	        "regex": /^[0-9\ ]+$/,
	        "alertText": "* Numbers only"
	      },
	      "onlyFiveNumber": {
	        "regex": /^(\d\d\d\d\d)$/,
	        "alertText": "* Five numbers only"
	      },
	      "onlyLetterSp": {
	        "regex": /^[a-zA-Z\ \']+$/,
	        "alertText": "* Letters only"
	      },
	      "onlyLetterNumber": {
	        "regex": /^[0-9a-zA-Z]+$/,
	        "alertText": "* No special characters allowed"
	      },
	      // --- CUSTOM RULES -- Those are specific to the demos, they can be removed or changed to your likings
	      "ajaxUserCall": {
	        "url": "ajaxValidateFieldUser",
	        // you may want to pass extra data on the ajax call
	        "extraData": "name=eric",
	        "alertText": "* This user name is already taken",
	        "alertTextLoad": "* Validating, please wait"
	      },
	      "ajaxUserCallPhp": {
	        "url": "phpajax/ajaxValidateFieldUser.php",
	        // you may want to pass extra data on the ajax call
	        "extraData": "name=eric",
	        // if you provide an "alertTextOk", it will show as a green prompt when the field validates
	        "alertTextOk": "* This user name is available",
	        "alertText": "* This user name is already taken",
	        "alertTextLoad": "* Validating, please wait"
	      },
	      "ajaxNameCall": {
	        // remote json service location
	        "url": "ajaxValidateFieldName",
	        // error
	        "alertText": "* This name is already taken",
	        // if you provide an "alertTextOk", it will show as a green prompt when the field validates
	        "alertTextOk": "* This name is available",
	        // speaks by itself
	        "alertTextLoad": "* Validating, please wait"
	      },
	      "ajaxNameCallPhp": {
	        // remote json service location
	        "url": "phpajax/ajaxValidateFieldName.php",
	        // error
	        "alertText": "* This user name is already taken",
	        // speaks by itself
	        "alertTextLoad": "* Validating, please wait"
	      },
	      "validate2fields": {
	        "alertText": "* Please input: \'HELLO\'"
	      },
	      //tls warning:homegrown not fielded
	      "dateFormat": {
	        "regex": /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$|^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(?:(?:0?[1-9]|1[0-2])(\/|-)(?:0?[1-9]|1\d|2[0-8]))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(0?2(\/|-)29)(\/|-)(?:(?:0[48]00|[13579][26]00|[2468][048]00)|(?:\d\d)?(?:0[48]|[2468][048]|[13579][26]))$/,
	        "alertText": "* Invalid date"
	      },
	      //tls warning:homegrown not fielded
	      "dateTimeFormat": {
	        "regex": /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])\s+(1[012]|0?[1-9]){1}:(0?[1-5]|[0-6][0-9]){1}:(0?[0-6]|[0-6][0-9]){1}\s+(am|pm|AM|PM){1}$|^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^((1[012]|0?[1-9]){1}\/(0?[1-9]|[12][0-9]|3[01]){1}\/\d{2,4}\s+(1[012]|0?[1-9]){1}:(0?[1-5]|[0-6][0-9]){1}:(0?[0-6]|[0-6][0-9]){1}\s+(am|pm|AM|PM){1})$/,
	        "alertText": "* Invalid date or date format",
	        "alertText2": "Expected format: ",
	        "alertText3": "mm/dd/yyyy hh:mm:ss AM|PM or ",
	        "alertText4": "yyyy-mm-dd hh:mm:ss AM|PM"
	      },
	      "systemAuthcode": {
	        "regex": /^[0-9,a-z,A-Z]{5}$/,
	        "alertText": "* Invalid captcha code"
	      },
	      "smsCode": {
	        "regex": /^[0-9]{6}$/,
	        "alertText": "* Invalid SMS code"
	      },
	      "nohtml": {
	        "alertText": "* Contains illegal characters"
	      },
	      "ip": {
	        "regex": /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/,
	        "alertText": "* Invalid IP address"
	      },
	      "baudRate": {
	        "func": function (field, rules, i, options) {
	          var value = field.val();
	          var baudRates = ["110", "300", "600", "1200", "2400", "4800", "9600", "19200", "38400", "57600", "115200"];
	          if (baudRates.indexOf(value) != -1) {
	            return true;
	          } else {
	            return false;
	          }
	        },
	        "alertText": "* Invalid baud rate"
	      },
	      "parity": {
	        "func": function (field, rules, i, options) {
	          var value = field.val();
	          var baudRates = ["N", "O", "E"];
	          if (baudRates.indexOf(value) != -1) {
	            return true;
	          } else {
	            return false;
	          }
	        },
	        "alertText": "* Invalid parity"
	      }
	    }
	  };
	
	})(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {(function ($) {
	  $.validationEngineLanguage = {
	    zh_CN: {
	      "queryReport": {
	        "regex": "none",
	        "alertText": "*'状态上报周期'必须是'查询机器周期'的整数倍"
	      },
	      "giveName": {
	        "regex": /^[a-zA-Z0-9_\-\u4e00-\u9fa5]+$/i,
	        "alertText": "*命名无效"
	      },
	      "alias": {
	        "regex": /^[a-zA-Z0-9_\-\u4e00-\u9fa5]+$/i,
	        "alertText": "*无效的别名"
	      },
	      "username": {
	        "regex": /^[A-Za-z0-9_\-]+$/,
	        "alertText": "*无效用户名"
	      },
	      "required": { // Add your regex rules here, you can take telephone as an example
	        "regex": "none",
	        "alertText": "* 此处不可空白",
	        "alertTextCheckboxMultiple": "* 请选择一个项目",
	        "alertTextCheckboxe": "* 您必须钩选此栏",
	        "alertTextDateRange": "* 日期范围不可空白"
	      },
	      "requiredInFunction": {
	        "func": function (field, rules, i, options) {
	          return (field.val() == "test") ? true : false;
	        },
	        "alertText": "* Field must equal test"
	      },
	      "dateRange": {
	        "regex": "none",
	        "alertText": "* 无效的 ",
	        "alertText2": " 日期范围"
	      },
	      "dateTimeRange": {
	        "regex": "none",
	        "alertText": "* 无效的 ",
	        "alertText2": " 时间范围"
	      },
	      "minSize": {
	        "regex": "none",
	        "alertText": "* 最少 ",
	        "alertText2": " 个字符"
	      },
	      "maxSize": {
	        "regex": "none",
	        "alertText": "* 最多 ",
	        "alertText2": " 个字符"
	      },
	      "groupRequired": {
	        "regex": "none",
	        "alertText": "* 你必需选填其中一个栏位"
	      },
	      "min": {
	        "regex": "none",
	        "alertText": "* 最小值為 "
	      },
	      "max": {
	        "regex": "none",
	        "alertText": "* 最大值为 "
	      },
	      "past": {
	        "regex": "none",
	        "alertText": "* 日期必需早于 "
	      },
	      "future": {
	        "regex": "none",
	        "alertText": "* 日期必需晚于 "
	      },
	      "maxCheckbox": {
	        "regex": "none",
	        "alertText": "* 最多选取 ",
	        "alertText2": " 个项目"
	      },
	      "minCheckbox": {
	        "regex": "none",
	        "alertText": "* 请选择 ",
	        "alertText2": " 个项目"
	      },
	      "password": {
	//                	"regex": /^[A-Za-z0-9_\!\@\#\$\%\^\&\*\.]+$/,
	        "regex": /^[A-Za-z0-9_\!\@\#\$\%\^\&\*\.\+\=\-\~\,\[\]\(\)]+$/,
	        "alertText": "* 包含非法字符"
	      },
	      "equals": {
	        "regex": "none",
	        "alertText": "* 请输入与上面相同的密码"
	      },
	      "creditCard": {
	        "regex": "none",
	        "alertText": "* 无效的信用卡号码"
	      },
	      "serialNumber2": {
	        "regex": /^[a-zA-Z]{2}[0-9]{13}$/,
	        "alertText": "* 请输入15位网关序列号"
	      },
	      "serialNumber": {
	        "regex": /^[a-zA-Z0-9]+$/,
	        "alertText": "* 只能输入字母和数字"
	      },
	      "phone": {
	        // credit: jquery.h5validate.js / orefalo
	        "regex": /^([\+][0-9]{1,3}[ \.\-])?([\(]{1}[0-9]{2,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
	        "alertText": "* 无效的传真号码"
	      },
	      "phone1": {
	        // credit: jquery.h5validate.js / orefalo
	        "regex": /^(\+?[0-9]{2,4}\-?\s?)?([0-9]{3,4}\-?\s?)?([0-9]{7,8})(\-[0-9]+)?$/,
	//                	"regex": /^(\+[0-9]+\-?\s?)?([0-9]+\-?\s?)?([0-9]+)(\-[0-9]+)?$/,
	//                	"regex": /^((\+?[0-9]{2,4}\-[0-9]{3,4}\-)|([0-9]{3,4}\-))?([0-9]{7,8})(\-[0-9]+)?$/,
	        "alertText": "* 无效的电话号码"
	      },
	      "mobile": {
	        "regex": /^1[3|4|5|8][0-9]\d{8,8}$/,
	        "alertText": "* 无效的手机号码"
	      },
	      "email": {
	        // Shamelessly lifted from Scott Gonzalez via the Bassistance Validation plugin http://projects.scottsplayground.com/email_address_validation/
	        "regex": /^admin$|^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i,
	        "alertText": "* 邮件地址无效"
	      },
	      "emailExist": {
	        "alertText": "* 邮件地址不存在"
	      },
	      "integer": {
	        "regex": /^[\-\+]?\d+$/,
	        "alertText": "* 不是有效的整数"
	      },
	      "number": {
	        // Number, including positive, negative, and floating decimal. credit: orefalo
	        "regex": /^[\-\+]?((([0-9]{1,3})([,][0-9]{3})*)|([0-9]+))?([\.]([0-9]+))?$/,
	        "alertText": "* 无效的数字"
	      },
	      "date": {
	        "regex": /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/,
	        "alertText": "* 无效的日期，格式必需为 YYYY-MM-DD"
	      },
	      "ipv4": {
	        "regex": /^((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]\d)|\d)(\.((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]\d)|\d)){3}$|^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}$/,
	        "alertText": "* 无效的 IP 地址"
	      },
	      "url": {
	        "regex": /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
	        "alertText": "* 无效的 URL"
	      },
	      "url1": {
	        "regex": /^((https?|ftp):\/\/)?(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
	        "alertText": "* 无效的 URL"
	      },
	      "onlyNumberSp": {
	        "regex": /^[0-9]+$/,
	        "alertText": "* 只能填数字"
	      },
	      "onlyFiveNumber": {
	        "regex": /^(\d\d\d\d\d)$/,
	        "alertText": "* 只能填5位数字"
	      },
	      "onlyLetterSp": {
	        "regex": /^[a-zA-Z\ \']+$/,
	        "alertText": "* 只接受英文字母大小写"
	      },
	      "onlyLetterNumber": {
	        "regex": /^[0-9a-zA-Z]+$/,
	        "alertText": "* 不接受特殊字符"
	      },
	      // --- CUSTOM RULES -- Those are specific to the demos, they can be removed or changed to your likings
	      "ajaxUserCall": {
	        "url": "ajaxValidateFieldUser",
	        // you may want to pass extra data on the ajax call
	        "extraData": "name=eric",
	        "alertText": "* 此名称已被其他人使用",
	        "alertTextLoad": "* 正在确认名称是否有其他人使用，请稍等。"
	      },
	      "ajaxUserCallPhp": {
	        "url": "phpajax/ajaxValidateFieldUser.php",
	        // you may want to pass extra data on the ajax call
	        "extraData": "name=eric",
	        // if you provide an "alertTextOk", it will show as a green prompt when the field validates
	        "alertTextOk": "* 此帐号名称可以使用",
	        "alertText": "* 此名称已被其他人使用",
	        "alertTextLoad": "* 正在确认帐号名称是否有其他人使用，请稍等。"
	      },
	      "ajaxNameCall": {
	        // remote json service location
	        "url": "ajaxValidateFieldName",
	        // error
	        "alertText": "* 此名称可以使用",
	        // if you provide an "alertTextOk", it will show as a green prompt when the field validates
	        "alertTextOk": "* 此名称已被其他人使用",
	        // speaks by itself
	        "alertTextLoad": "* 正在确认名称是否有其他人使用，请稍等。"
	      },
	      "ajaxNameCallPhp": {
	        // remote json service location
	        "url": "phpajax/ajaxValidateFieldName.php",
	        // error
	        "alertText": "* 此名称已被其他人使用",
	        // speaks by itself
	        "alertTextLoad": "* 正在确认名称是否有其他人使用，请稍等。"
	      },
	      "validate2fields": {
	        "alertText": "* 请输入 HELLO"
	      },
	      //tls warning:homegrown not fielded
	      "dateFormat": {
	        "regex": /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$|^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(?:(?:0?[1-9]|1[0-2])(\/|-)(?:0?[1-9]|1\d|2[0-8]))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(0?2(\/|-)29)(\/|-)(?:(?:0[48]00|[13579][26]00|[2468][048]00)|(?:\d\d)?(?:0[48]|[2468][048]|[13579][26]))$/,
	        "alertText": "* 无效的日期格式"
	      },
	      //tls warning:homegrown not fielded
	      "dateTimeFormat": {
	        "regex": /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])\s+(1[012]|0?[1-9]){1}:(0?[1-5]|[0-6][0-9]){1}:(0?[0-6]|[0-6][0-9]){1}\s+(am|pm|AM|PM){1}$|^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^((1[012]|0?[1-9]){1}\/(0?[1-9]|[12][0-9]|3[01]){1}\/\d{2,4}\s+(1[012]|0?[1-9]){1}:(0?[1-5]|[0-6][0-9]){1}:(0?[0-6]|[0-6][0-9]){1}\s+(am|pm|AM|PM){1})$/,
	        "alertText": "* 无效的日期或时间格式",
	        "alertText2": "可接受的格式： ",
	        "alertText3": "mm/dd/yyyy hh:mm:ss AM|PM 或 ",
	        "alertText4": "yyyy-mm-dd hh:mm:ss AM|PM"
	      },
	      "systemAuthcode": {
	        "regex": /^[0-9,a-z,A-Z]{5}$/,
	        "alertText": "* 无效的验证码"
	      },
	      "smsCode": {
	        "regex": /^[0-9]{6}$/,
	        "alertText": "* 无效的验证码"
	      },
	      "nohtml": {
	        "alertText": "* 包含非法字符 "
	      },
	      "ip": {
	        "regex": /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/,
	        "alertText": "* 无效的IP地址"
	      },
	      "baudRate": {
	        "func": function (field, rules, i, options) {
	          var value = field.val();
	          var baudRates = ["110", "300", "600", "1200", "2400", "4800", "9600", "19200", "38400", "57600", "115200"];
	          if (baudRates.indexOf(value) != -1) {
	            return true;
	          } else {
	            return false;
	          }
	        },
	        "alertText": "* 无效的波特率"
	      },
	      "parity": {
	        "func": function (field, rules, i, options) {
	          var value = field.val();
	          var baudRates = ["N", "O", "E"];
	          if (baudRates.indexOf(value) != -1) {
	            return true;
	          } else {
	            return false;
	          }
	        },
	        "alertText": "* 无效的校验位"
	      }
	    }
	  };
	
	})(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {/**
	 * @author PANJC
	 *
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	  var cloud = __webpack_require__(5);
	  var html = __webpack_require__(59);
	  var Footer = Class.create(cloud.Component, {
	    initialize: function ($super, options) {
	      $super(options);
	      this.contentElement = options.contentElement;
	      this._render();
	      var lang = localStorage.getItem("language");
	      if(lang == 'en'){
	        $(".fax").css("display","none");
	      }else{
	        $(".fax").css("display","block");
	      }
	    },
	
	    _render: function () {
	      this._renderHtml();
	//        	this._resizeHeight();
	//        	this._events();
	    },
	
	    _renderHtml: function () {
	      this.element.html(html);
	    },
	
	    _resizeHeight: function () {
	      var $this = this;
	      var bodyHeight = document.body.scrollHeight ? document.body.scrollHeight : document.body.offsetHeight;
	      var headerHeight = $("#home-header-box").height();
	      var navHeight = $("#home-nav-box").height();
	      var contentHeight = $($this.contentElement).height();
	      var footerHeight = bodyHeight - headerHeight - navHeight - contentHeight - 3;
	      $("#home-footer-box").height(footerHeight);
	    },
	
	    _events: function () {
	      var $this = this;
	      var once = null;
	      $(window).resize(function () {
	        function _resize() {
	          $this._resizeHeight();
	        }
	
	        once = once ? null : setTimeout(_resize, 0);
	      });
	    }
	
	  });
	
	  return Footer;
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div id=home-footer-box class=home-footer-box> <div id=home-footer class=\"home-footer center-block\"> <div class=row> <div class=col-xs-9> <h3 lang=text:about_us>关于我们</h3> <p class=content> </p><p> <span lang=text:address+: class=labels>地址:</span> <span lang=company_address>北京市朝阳区望京科技园启明国际大厦11层西侧</span> </p> <p> <span lang=text:tel+: class=labels>电话:</span> <span lang=tel_number>(8610) 8417 0010/6439 1099 - 8022</span> </p> <p class=fax> <span class=labels>传真:</span>(8610) 8417 0089 <br/> </p> <p> <span lang=text:website+: class=labels>网址:</span> <span lang=website_>www.inhand.com.cn</span> </p> <p> <span class=labels>E-mail:</span> <span lang=email_>info@www.inhand.com.cn</span> </p> <p></p> <p class=copyright lang=text:copyright_>版权 © 2017 映翰通网络 保留所有权利.</p> <div class=record-number> <a target=_blank href=http://www.beian.gov.cn class=public-security> <img src=" + __webpack_require__(60) + " class=public-security-icon width=18px /> <p class=public-security-code> 沪公网安备 31011502016102号 </p> </a> <a href=https://beian.miit.gov.cn target=_blank class=icp> <p class=record>沪ICP备11019805号</p> </a> </div> </div> <div class=col-xs-3> <div class=corner> <img src=" + __webpack_require__(61) + " width=130 alt=inhand> </div> </div> </div> </div> </div> ";

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources/record-icon-f29cf29e6e28ca60f1ba5777121bdf14.png";

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources/footer-qrcode-8940d17e7d503988b14ffe27242dc226.png";

/***/ }),
/* 62 */
13,
/* 63 */
13,
/* 64 */
13,
/* 65 */
13,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Completer v@VERSION
	 * https://github.com/fengyuanchen/completer
	 *
	 * Copyright (c) 2014-@YEAR Fengyuan Chen
	 * Released under the MIT license
	 *
	 * Date: @DATE
	 */
	
	(function (factory) {
	  if (true) {
	    // AMD. Register as anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node / CommonJS
	    factory(require('jquery'));
	  } else {
	    // Browser globals.
	    factory(jQuery);
	  }
	})(function ($) {
	
	  'use strict';
	
	  var $window = $(window);
	  var $document = $(document);
	  var NAMESPACE = 'completer';
	  var EVENT_RESIZE = 'resize';
	  var EVENT_MOUSE_DOWN = 'mousedown';
	
	  function Completer(element, options) {
	    this.$element = $(element);
	    this.options = $.extend({}, Completer.DEFAULTS, $.isPlainObject(options) && options);
	    this.init();
	  }
	
	  function espace(s) {
	    return s.replace(/([\.\$\^\{\[\(\|\)\*\+\?\\])/g, '\\$1');
	  }
	
	  function toRegexp(s) {
	    if (typeof s === 'string' && s !== '') {
	      s = espace(s);
	
	      return new RegExp(s + '+[^' + s + ']*$', 'i');
	    }
	
	    return null;
	  }
	
	  function toArray(s) {
	    if (typeof s === 'string') {
	      s = s.replace(/[\{\}\[\]"']+/g, '').split(/\s*,+\s*/);
	    }
	
	    s = $.map(s, function (n) {
	      return typeof n !== 'string' ? n.toString() : n;
	    });
	
	    return s;
	  }
	
	  Completer.prototype = {
	    constructor: Completer,
	
	    init: function () {
	      var options = this.options,
	        data = toArray(options.source);
	      if (data.length > 0) {
	        this.data = data;
	        this.regexp = toRegexp(options.separator);
	        this.$completer = $(options.template);
	        this.$completer.hide().appendTo('body');
	        this.place();
	        this.$element.attr('autocomplete', 'off').on({
	          focus: $.proxy(this.enable, this),
	          blur: $.proxy(this.disable, this)
	        });
	
	        if (this.$element.is(':focus')) {
	          this.enable();
	        }
	      }
	    },
	
	    enable: function () {
	      if (!this.active) {
	        this.active = true;
	        this.$element.on({
	          keydown: $.proxy(this.keydown, this),
	          keyup: $.proxy(this.keyup, this)
	        });
	        this.$completer.on({
	          mousedown: $.proxy(this.mousedown, this),
	          mouseover: $.proxy(this.mouseover, this)
	        });
	      }
	    },
	
	    disable: function () {
	      if (this.active) {
	        this.active = false;
	        this.$element.off({
	          keydown: this.keydown,
	          keyup: this.keyup
	        });
	        this.$completer.off({
	          mousedown: this.mousedown,
	          mouseover: this.mouseover
	        });
	      }
	    },
	
	    attach: function (val) {
	      var options = this.options;
	      var separator = options.separator;
	      var regexp = this.regexp;
	      var part = regexp ? val.match(regexp) : null;
	      var matched = [];
	      var all = [];
	      var that = this;
	      var reg;
	      var item;
	      var self = this;
	
	      if (part) {
	        part = part[0];
	        val = val.replace(regexp, '');
	        reg = new RegExp('^' + espace(part), 'i');
	      }
	
	      $.each(this.data, function (i, n) {
	        n = separator + n;
	        item = that.template(val + n);
	
	        if (reg && reg.test(n)) {
	          matched.push(item);
	        } else {
	          self.hide();
	          // all.push(item);
	        }
	      });
	
	      matched = matched.length ? matched : all;
	      if (options.position === 'top') {
	        matched = matched.reverse();
	      }
	
	      this.fill(matched.join(''));
	    },
	
	    suggest: function (val) {
	      var reg = new RegExp(espace(val), 'i');
	      var that = this;
	      var matched = [];
	
	      $.each(this.data, function (i, n) {
	        if (reg.test(n)) {
	          matched.push(n);
	        }
	      });
	
	      matched.sort(function (a, b) {
	        return a.indexOf(val) - b.indexOf(val);
	      });
	
	      $.each(matched, function (i, n) {
	        matched[i] = that.template(n);
	      });
	
	      this.fill(matched.join(''));
	    },
	
	    template: function (text) {
	      var tag = this.options.itemTag;
	
	      return ('<' + tag + '>' + text + '</' + tag + '>');
	    },
	
	    fill: function (html) {
	      var filter;
	
	      this.$completer.empty();
	
	      if (html) {
	        filter = this.options.position === 'top' ? ':last' : ':first';
	        this.$completer.html(html);
	        this.$completer.children(filter).addClass(this.options.selectedClass);
	        this.show();
	      } else {
	        this.hide();
	      }
	    },
	
	    complete: function () {
	      var options = this.options;
	      var val = options.filter(this.$element.val()).toString();
	
	      if (val === '') {
	        this.hide();
	        return;
	      } else if (val.indexOf('@') == -1) {
	        this.hide();
	        return;
	      }
	
	      if (options.suggest) {
	        this.suggest(val);
	      } else {
	        this.attach(val);
	      }
	    },
	
	    keydown: function (e) {
	      var keyCode = e.keyCode || e.which || e.charCode;
	
	      if (keyCode === 13) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	    },
	
	    keyup: function (e) {
	      var keyCode = e.keyCode || e.which || e.charCode;
	
	      if (keyCode === 13 || keyCode === 38 || keyCode === 40) {
	        this.toggle(keyCode);
	      } else {
	        this.complete();
	      }
	    },
	
	    mouseover: function (e) {
	      var options = this.options;
	      var selectedClass = options.selectedClass,
	        $target = $(e.target);
	
	      if ($target.is(options.itemTag)) {
	        $target.addClass(selectedClass).siblings().removeClass(selectedClass);
	      }
	    },
	
	    mousedown: function (e) {
	      e.stopPropagation();
	      e.preventDefault();
	      this.setValue($(e.target).text());
	    },
	
	    setValue: function (val) {
	      this.$element.val(val);
	      this.options.complete();
	      this.hide();
	    },
	
	    toggle: function (keyCode) {
	      var selectedClass = this.options.selectedClass;
	      var $selected = this.$completer.find('.' + selectedClass);
	
	      switch (keyCode) {
	
	        // Down
	        case 40:
	          $selected.removeClass(selectedClass);
	          $selected = $selected.next();
	          break;
	
	        // Up
	        case 38:
	          $selected.removeClass(selectedClass);
	          $selected = $selected.prev();
	          break;
	
	        // Enter
	        case 13:
	          this.setValue($selected.text());
	          break;
	
	        // No default
	      }
	
	      if ($selected.length === 0) {
	        $selected = this.$completer.children(keyCode === 40 ? ':first' : ':last');
	      }
	
	      $selected.addClass(selectedClass);
	    },
	
	    place: function () {
	      var $element = this.$element;
	      var offset = $element.offset();
	      var left = offset.left;
	      var top = offset.top;
	      var height = $element.outerHeight();
	      var width = $element.outerWidth();
	      var styles = {
	        minWidth: width,
	        zIndex: this.options.zIndex
	      };
	
	      switch (this.options.position) {
	        case 'right':
	          styles.left = left + width;
	          styles.top = top;
	          break;
	
	        case 'left':
	          styles.right = $window.innerWidth() - left;
	          styles.top = top;
	          break;
	
	        case 'top':
	          styles.left = left;
	          styles.bottom = $window.innerHeight() - top;
	          break;
	
	        // case 'bottom':
	        default:
	          styles.left = left;
	          styles.top = top + height;
	      }
	
	      this.$completer.css(styles);
	    },
	
	    show: function () {
	      this.$completer.show();
	      $window.on(EVENT_RESIZE, $.proxy(this.place, this));
	      $document.on(EVENT_MOUSE_DOWN, $.proxy(this.hide, this));
	    },
	
	    hide: function () {
	      this.$completer.hide();
	      $window.off(EVENT_RESIZE, this.place);
	      $document.off(EVENT_MOUSE_DOWN, this.hide);
	    },
	
	    destroy: function () {
	      var $this = this.$element;
	
	      this.hide();
	      this.disable();
	
	      $this.off({
	        focus: this.enable,
	        blur: this.disable
	      });
	
	      $this.removeData(NAMESPACE);
	    }
	  };
	
	  Completer.DEFAULTS = {
	    itemTag: 'li',
	    position: 'bottom', // or 'right'
	    source: [],
	    selectedClass: 'completer-selected',
	    separator: '',
	    suggest: false,
	    template: '<ul class="completer-container"></ul>',
	    zIndex: 1,
	    complete: $.noop,
	    filter: function (val) {
	      return val;
	    }
	  };
	
	  Completer.setDefaults = function (options) {
	    $.extend(Completer.DEFAULTS, options);
	  };
	
	  // Save the other completer
	  Completer.other = $.fn.completer;
	
	  // Register as jQuery plugin
	  $.fn.completer = function (option) {
	    var args = [].slice.call(arguments, 1);
	    var result;
	
	    this.each(function () {
	      var $this = $(this);
	      var data = $this.data(NAMESPACE);
	      var options;
	      var fn;
	
	      if (!data) {
	        if (/destroy/.test(option)) {
	          return;
	        }
	
	        options = $.extend({}, $this.data(), $.isPlainObject(option) && option);
	        $this.data(NAMESPACE, (data = new Completer(this, options)));
	      }
	
	      if (typeof option === 'string' && $.isFunction(fn = data[option])) {
	        result = fn.apply(data, args);
	      }
	    });
	
	    return typeof result !== 'undefined' ? result : this;
	  };
	
	  $.fn.completer.Constructor = Completer;
	  $.fn.completer.setDefaults = Completer.setDefaults;
	
	  // No conflict
	  $.fn.completer.noConflict = function () {
	    $.fn.completer = Completer.other;
	    return this;
	  };
	
	  $(function () {
	    $('[data-toggle="completer"]').completer();
	  });
	});


/***/ }),
/* 67 */
13,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div id=home-content class=home-content> <div class=home-content-top-box> <div id=home-content-top class=home-content-top> <div class=home-content-login-box> <div id=home-content-login class=home-content-login> <div class=home-content-login-title> <div class=home-content-login-title-wrapper> <a href=javascript:void(0) class=\"content-link-login cloud-btn-link active\" lang=sign_in></a> <a href=javascript:void(0) class=\"content-link-register cloud-btn-link\" lang=sign_up></a> <span class=login-title-slide-bar></span> </div> </div> <form id=register-form style=padding-top:16px;display:none;position:relative> <div class=form-group> <input type=text id=register-input-user name=username autofocus spellcheck=false lang=placeholder:email autocomplete=off class=\"validate[required,custom[email],funcCall[cloudInput]] form-control\" data-prompt-position=topLeft title=\"\"/> </div> <div class=form-group> <input type=text id=register-input-org-name spellcheck=false lang=placeholder:organization_name autocomplete=off class=\"validate[required,funcCall[cloudInput]] form-control\" data-prompt-position=topLeft title=\"\"/> </div> <div class=form-group> <input type=password lang=placeholder:password class=\"validate[required,funcCall[cloudInput]],minSize[6],maxSize[12] form-control\" data-prompt-position=topLeft id=register-input-pwd-password title=\"\"/> </div> <div class=\"form-group captcha\" style=display:none> <input type=text lang=placeholder:security_code style=display:inline-block;width:105px class=\"validate[required,custom[systemAuthcode],funcCall[cloudInput]] form-control\" id=register-input-ver-custom title=\"\"/> <div class=register-captcha style=float:right></div> </div> <div class=\"form-group phone\"> <input type=text lang=placeholder:sms_code class=\"validate[required,custom[smsCode],funcCall[cloudInput]] form-control\" style=display:inline-block;width:105px id=register-input-sms-code title=\"\"/> <button id=register-send-sms class=\"btn btn-info btn-sm\" type=button lang=text:send_sms_code style=width:83px;float:right></button> </div> <div class=form-group style=margin-top:16px> <button lang=sign_up type=submit value=\"\" class=\"btn btn-info btn-block\" id=register-input-submit></button> </div> <div style=font-size:11px> <span lang=agree_terms></span><a href=javascript:void(0) id=home-link-terms lang=service_terms></a> </div> </form> <form id=login-form style=height:100%;padding-top:16px> <div class=\"form-group password\"> <input type=text id=home-input-user name=username autofocus spellcheck=false lang=placeholder:email_or_phone autocomplete=off class=\"validate[required,funcCall[cloudInput]] form-control\" title=\"\"/> </div> <div class=\"form-group phone\" style=display:none> <div class=control> <div class=input_prepend> <div class=to-choose-areacode id=to-choose-areacode> <div class=select-country-mobile-wrap> <input class=mobile-code type=text value=+86 data-type-select=code> <div class=mobile-box data-type-select=trigon-box> <span class=\"mobile-trigon mobile-trigon-dowm\" data-type-select=trigon name=trigon-down></span> </div> <ul id=js-select-country class=\"select-country-box clearfix\" data-type-select=country-ul> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=china_mainland></span><span class=\"fr li-code\" data-type-select=country-code>+86</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=china_macau></span><span class=\"fr li-code\" data-type-select=country-code>+853</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=china_hong_kong></span><span class=\"fr li-code\" data-type-select=country-code>+852</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=taiwan></span><span class=\"fr li-code\" data-type-select=country-code>+886</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=albania></span><span class=\"fr li-code\" data-type-select=country-code>+355</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=algeria></span><span class=\"fr li-code\" data-type-select=country-code>+213</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=afghanistan></span><span class=\"fr li-code\" data-type-select=country-code>+93</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=argentina></span><span class=\"fr li-code\" data-type-select=country-code>+54</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=united_arab_emirates></span><span class=\"fr li-code\" data-type-select=country-code>+971</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=aruba></span><span class=\"fr li-code\" data-type-select=country-code>+297</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=oman></span><span class=\"fr li-code\" data-type-select=country-code>+968</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=azerbaijan></span><span class=\"fr li-code\" data-type-select=country-code>+994</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=ascension></span><span class=\"fr li-code\" data-type-select=country-code>+247</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=egypt></span><span class=\"fr li-code\" data-type-select=country-code>+20</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=ethiopia></span><span class=\"fr li-code\" data-type-select=country-code>+251</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=ireland></span><span class=\"fr li-code\" data-type-select=country-code>+353</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=estonia></span><span class=\"fr li-code\" data-type-select=country-code>+372</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=andorra></span><span class=\"fr li-code\" data-type-select=country-code>+376</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=angola></span><span class=\"fr li-code\" data-type-select=country-code>+244</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=anguilla></span><span class=\"fr li-code\" data-type-select=country-code>+1264</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=antigua_and_barbuda></span><span class=\"fr li-code\" data-type-select=country-code>+1268</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=austria></span><span class=\"fr li-code\" data-type-select=country-code>+43</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=australia></span><span class=\"fr li-code\" data-type-select=country-code>+61</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=barbados></span><span class=\"fr li-code\" data-type-select=country-code>+1246</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=papua_new_guinea></span><span class=\"fr li-code\" data-type-select=country-code>+675</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=bahamas></span><span class=\"fr li-code\" data-type-select=country-code>+1242</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=pakistan></span><span class=\"fr li-code\" data-type-select=country-code>+92</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=paraguay></span><span class=\"fr li-code\" data-type-select=country-code>+595</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=palestine></span><span class=\"fr li-code\" data-type-select=country-code>+970</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=bahrain></span><span class=\"fr li-code\" data-type-select=country-code>+973</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=panama></span><span class=\"fr li-code\" data-type-select=country-code>+507</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=brazil></span><span class=\"fr li-code\" data-type-select=country-code>+55</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=belarus></span><span class=\"fr li-code\" data-type-select=country-code>+375</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=bermuda></span><span class=\"fr li-code\" data-type-select=country-code>+1441</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=bulgaria></span><span class=\"fr li-code\" data-type-select=country-code>+359</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=northern_mariana_islands></span><span class=\"fr li-code\" data-type-select=country-code>+1670</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=benin></span><span class=\"fr li-code\" data-type-select=country-code>+229</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=belgium></span><span class=\"fr li-code\" data-type-select=country-code>+32</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=iceland></span><span class=\"fr li-code\" data-type-select=country-code>+354</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=puerto_rico></span><span class=\"fr li-code\" data-type-select=country-code>+1787</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=bosnia_and_herzegovina></span><span class=\"fr li-code\" data-type-select=country-code>+387</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=poland></span><span class=\"fr li-code\" data-type-select=country-code>+48</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=bolivia></span><span class=\"fr li-code\" data-type-select=country-code>+591</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=belize></span><span class=\"fr li-code\" data-type-select=country-code>+501</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=botswana></span><span class=\"fr li-code\" data-type-select=country-code>+267</span></li> <li class=\"select-country-li the-longest\" data-type-select=country-li><span class=\"fl li-country\" lang=bonaire_saint_eustatius_and_saba></span><span class=\"fr li-code\" data-type-select=country-code>+599</span> </li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=bhutan></span><span class=\"fr li-code\" data-type-select=country-code>+975</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=burkina_faso></span><span class=\"fr li-code\" data-type-select=country-code>+226</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=burundi></span><span class=\"fr li-code\" data-type-select=country-code>+257</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=korea></span><span class=\"fr li-code\" data-type-select=country-code>+850</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=equatorial_guinea></span><span class=\"fr li-code\" data-type-select=country-code>+240</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=denmark></span><span class=\"fr li-code\" data-type-select=country-code>+45</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=germany></span><span class=\"fr li-code\" data-type-select=country-code>+49</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=diego_garcia></span><span class=\"fr li-code\" data-type-select=country-code>+246</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=east_timor></span><span class=\"fr li-code\" data-type-select=country-code>+670</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=togo></span><span class=\"fr li-code\" data-type-select=country-code>+228</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=dominican_republic></span><span class=\"fr li-code\" data-type-select=country-code>+1767</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=dominican_republic1></span><span class=\"fr li-code\" data-type-select=country-code>+1809</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=russia></span><span class=\"fr li-code\" data-type-select=country-code>+7</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=ecuador></span><span class=\"fr li-code\" data-type-select=country-code>+593</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=eritrea></span><span class=\"fr li-code\" data-type-select=country-code>+291</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=france></span><span class=\"fr li-code\" data-type-select=country-code>+33</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=the_faroe_islands></span><span class=\"fr li-code\" data-type-select=country-code>+298</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=french_polynesia></span><span class=\"fr li-code\" data-type-select=country-code>+689</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=french_guiana></span><span class=\"fr li-code\" data-type-select=country-code>+594</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=the_vatican></span><span class=\"fr li-code\" data-type-select=country-code>+379</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=philippines></span><span class=\"fr li-code\" data-type-select=country-code>+63</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=fiji></span><span class=\"fr li-code\" data-type-select=country-code>+679</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=finland></span><span class=\"fr li-code\" data-type-select=country-code>+358</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=cape_verde></span><span class=\"fr li-code\" data-type-select=country-code>+238</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=the_falkland_islands></span><span class=\"fr li-code\" data-type-select=country-code>+500</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=gambia></span><span class=\"fr li-code\" data-type-select=country-code>+220</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=congo></span><span class=\"fr li-code\" data-type-select=country-code>+242</span></li> <li class=\"select-country-li the-longest the-long\" data-type-select=country-li><span class=\"fl li-country\" lang=democratic_republic_of_the_congo></span><span class=\"fr li-code\" data-type-select=country-code>+243</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=colombia></span><span class=\"fr li-code\" data-type-select=country-code>+57</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=costa_rica></span><span class=\"fr li-code\" data-type-select=country-code>+506</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=grenada></span><span class=\"fr li-code\" data-type-select=country-code>+1473</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=greenland></span><span class=\"fr li-code\" data-type-select=country-code>+299</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=georgia></span><span class=\"fr li-code\" data-type-select=country-code>+995</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=cuba></span><span class=\"fr li-code\" data-type-select=country-code>+53</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=guadeloupe></span><span class=\"fr li-code\" data-type-select=country-code>+590</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=guam></span><span class=\"fr li-code\" data-type-select=country-code>+1671</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=guyana></span><span class=\"fr li-code\" data-type-select=country-code>+592</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=kazakhstan></span><span class=\"fr li-code\" data-type-select=country-code>+7</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=haiti></span><span class=\"fr li-code\" data-type-select=country-code>+509</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=korea1></span><span class=\"fr li-code\" data-type-select=country-code>+82</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=netherlands></span><span class=\"fr li-code\" data-type-select=country-code>+31</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=netherlands_st_martin></span><span class=\"fr li-code\" data-type-select=country-code>+1721</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=montenegro></span><span class=\"fr li-code\" data-type-select=country-code>+382</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=honduras></span><span class=\"fr li-code\" data-type-select=country-code>+504</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=kiribati></span><span class=\"fr li-code\" data-type-select=country-code>+686</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=djibouti></span><span class=\"fr li-code\" data-type-select=country-code>+253</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=kyrgyzstan></span><span class=\"fr li-code\" data-type-select=country-code>+996</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=guinea></span><span class=\"fr li-code\" data-type-select=country-code>+224</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=guinea_bissau></span><span class=\"fr li-code\" data-type-select=country-code>+245</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=canada></span><span class=\"fr li-code\" data-type-select=country-code>+1</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=ghana></span><span class=\"fr li-code\" data-type-select=country-code>+233</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=gabon></span><span class=\"fr li-code\" data-type-select=country-code>+241</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=cambodia></span><span class=\"fr li-code\" data-type-select=country-code>+855</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=czech_republic></span><span class=\"fr li-code\" data-type-select=country-code>+420</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=zimbabwe></span><span class=\"fr li-code\" data-type-select=country-code>+263</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=cameroon></span><span class=\"fr li-code\" data-type-select=country-code>+237</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=qatar></span><span class=\"fr li-code\" data-type-select=country-code>+974</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=cayman_islands></span><span class=\"fr li-code\" data-type-select=country-code>+1345</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=comoros_and_mayotte></span><span class=\"fr li-code\" data-type-select=country-code>+269</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=côte_d_ivoire></span><span class=\"fr li-code\" data-type-select=country-code>+225</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=kuwait></span><span class=\"fr li-code\" data-type-select=country-code>+965</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=croatia></span><span class=\"fr li-code\" data-type-select=country-code>+385</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=kenya></span><span class=\"fr li-code\" data-type-select=country-code>+254</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=cook_islands></span><span class=\"fr li-code\" data-type-select=country-code>+682</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=curacao></span><span class=\"fr li-code\" data-type-select=country-code>+599</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=latvia></span><span class=\"fr li-code\" data-type-select=country-code>+371</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=lesotho></span><span class=\"fr li-code\" data-type-select=country-code>+266</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=laos></span><span class=\"fr li-code\" data-type-select=country-code>+856</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=lebanon></span><span class=\"fr li-code\" data-type-select=country-code>+961</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=lithuania></span><span class=\"fr li-code\" data-type-select=country-code>+370</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=liberia></span><span class=\"fr li-code\" data-type-select=country-code>+231</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=libya></span><span class=\"fr li-code\" data-type-select=country-code>+218</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=liechtenstein></span><span class=\"fr li-code\" data-type-select=country-code>+423</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=reunion_island></span><span class=\"fr li-code\" data-type-select=country-code>+262</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=luxembourg></span><span class=\"fr li-code\" data-type-select=country-code>+352</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=rwanda></span><span class=\"fr li-code\" data-type-select=country-code>+250</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=romania></span><span class=\"fr li-code\" data-type-select=country-code>+40</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=madagascar></span><span class=\"fr li-code\" data-type-select=country-code>+261</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=maldives></span><span class=\"fr li-code\" data-type-select=country-code>+960</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=malta></span><span class=\"fr li-code\" data-type-select=country-code>+356</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=malawi></span><span class=\"fr li-code\" data-type-select=country-code>+265</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=malaysia></span><span class=\"fr li-code\" data-type-select=country-code>+60</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=mali></span><span class=\"fr li-code\" data-type-select=country-code>+223</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=macedonia></span><span class=\"fr li-code\" data-type-select=country-code>+389</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=marshall_islands></span><span class=\"fr li-code\" data-type-select=country-code>+692</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=martinique></span><span class=\"fr li-code\" data-type-select=country-code>+596</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=mauritius></span><span class=\"fr li-code\" data-type-select=country-code>+230</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=mauritania></span><span class=\"fr li-code\" data-type-select=country-code>+222</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=united_states></span><span class=\"fr li-code\" data-type-select=country-code>+1</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=american_samoa></span><span class=\"fr li-code\" data-type-select=country-code>+1684</span></li> <li class=\"select-country-li the-longest the-long\" data-type-select=country-li><span class=\"fl li-country\" lang=united_states_virgin_islands></span><span class=\"fr li-code\" data-type-select=country-code>+1340</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=mongolia></span><span class=\"fr li-code\" data-type-select=country-code>+976</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=montserrat></span><span class=\"fr li-code\" data-type-select=country-code>+1664</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=bangladesh></span><span class=\"fr li-code\" data-type-select=country-code>+880</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=peru></span><span class=\"fr li-code\" data-type-select=country-code>+51</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=micronesia></span><span class=\"fr li-code\" data-type-select=country-code>+691</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=myanmar></span><span class=\"fr li-code\" data-type-select=country-code>+95</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=moldova></span><span class=\"fr li-code\" data-type-select=country-code>+373</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=morocco></span><span class=\"fr li-code\" data-type-select=country-code>+212</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=monaco></span><span class=\"fr li-code\" data-type-select=country-code>+377</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=mozambique></span><span class=\"fr li-code\" data-type-select=country-code>+258</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=mexico></span><span class=\"fr li-code\" data-type-select=country-code>+52</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=namibia></span><span class=\"fr li-code\" data-type-select=country-code>+264</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=south_africa></span><span class=\"fr li-code\" data-type-select=country-code>+27</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=south_sudan></span><span class=\"fr li-code\" data-type-select=country-code>+211</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=nauru></span><span class=\"fr li-code\" data-type-select=country-code>+674</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=nicaragua></span><span class=\"fr li-code\" data-type-select=country-code>+505</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=nepal></span><span class=\"fr li-code\" data-type-select=country-code>+977</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=niger></span><span class=\"fr li-code\" data-type-select=country-code>+227</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=nigeria></span><span class=\"fr li-code\" data-type-select=country-code>+234</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=niue></span><span class=\"fr li-code\" data-type-select=country-code>+683</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=norway></span><span class=\"fr li-code\" data-type-select=country-code>+47</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=norfolk_island></span><span class=\"fr li-code\" data-type-select=country-code>+6723</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=palau></span><span class=\"fr li-code\" data-type-select=country-code>+680</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=portugal></span><span class=\"fr li-code\" data-type-select=country-code>+351</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=japan></span><span class=\"fr li-code\" data-type-select=country-code>+81</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=sweden></span><span class=\"fr li-code\" data-type-select=country-code>+46</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=switzerland></span><span class=\"fr li-code\" data-type-select=country-code>+41</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=el_salvador></span><span class=\"fr li-code\" data-type-select=country-code>+503</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=samoa></span><span class=\"fr li-code\" data-type-select=country-code>+685</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=serbia></span><span class=\"fr li-code\" data-type-select=country-code>+381</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=sierra_leone></span><span class=\"fr li-code\" data-type-select=country-code>+232</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=senegal></span><span class=\"fr li-code\" data-type-select=country-code>+221</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=cyprus></span><span class=\"fr li-code\" data-type-select=country-code>+357</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=seychelles></span><span class=\"fr li-code\" data-type-select=country-code>+248</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=saudi_arabia></span><span class=\"fr li-code\" data-type-select=country-code>+966</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=st_barthelemy></span><span class=\"fr li-code\" data-type-select=country-code>+590</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=sao_tome_and_principe></span><span class=\"fr li-code\" data-type-select=country-code>+239</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=st_helena></span><span class=\"fr li-code\" data-type-select=country-code>+290</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=saint_kitts_and_nevis></span><span class=\"fr li-code\" data-type-select=country-code>+1869</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=saint_lucia></span><span class=\"fr li-code\" data-type-select=country-code>+1758</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=st_martin></span><span class=\"fr li-code\" data-type-select=country-code>+590</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=san_marino></span><span class=\"fr li-code\" data-type-select=country-code>+378</span></li> <li class=\"select-country-li the-longest the-long\" data-type-select=country-li><span class=\"fl li-country\" lang=saint_pierre_and_miquelon></span><span class=\"fr li-code\" data-type-select=country-code>+508</span></li> <li class=\"select-country-li the-longest the-long\" data-type-select=country-li><span class=\"fl li-country\" lang=saint_vincent_and_the_grenadines></span><span class=\"fr li-code\" data-type-select=country-code>+1784</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=sri_lanka></span><span class=\"fr li-code\" data-type-select=country-code>+94</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=slovakia></span><span class=\"fr li-code\" data-type-select=country-code>+421</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=slovenia></span><span class=\"fr li-code\" data-type-select=country-code>+386</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=swaziland></span><span class=\"fr li-code\" data-type-select=country-code>+268</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=sudan></span><span class=\"fr li-code\" data-type-select=country-code>+249</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=suriname></span><span class=\"fr li-code\" data-type-select=country-code>+597</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=solomon_islands></span><span class=\"fr li-code\" data-type-select=country-code>+677</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=somalia></span><span class=\"fr li-code\" data-type-select=country-code>+252</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=tajikistan></span><span class=\"fr li-code\" data-type-select=country-code>+992</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=thailand></span><span class=\"fr li-code\" data-type-select=country-code>+66</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=tanzania></span><span class=\"fr li-code\" data-type-select=country-code>+255</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=tonga></span><span class=\"fr li-code\" data-type-select=country-code>+676</span></li> <li class=\"select-country-li the-longest the-long\" data-type-select=country-li><span class=\"fl li-country\" lang=the_turks_and_caicos_islands></span><span class=\"fr li-code\" data-type-select=country-code>+1649</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=trinidad_and_tobago></span><span class=\"fr li-code\" data-type-select=country-code>+1868</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=tunisia></span><span class=\"fr li-code\" data-type-select=country-code>+216</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=tuvalu></span><span class=\"fr li-code\" data-type-select=country-code>+688</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=turkey></span><span class=\"fr li-code\" data-type-select=country-code>+90</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=turkmenistan></span><span class=\"fr li-code\" data-type-select=country-code>+993</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=tokelau></span><span class=\"fr li-code\" data-type-select=country-code>+690</span></li> <li class=\"select-country-li the-longest the-long\" data-type-select=country-li><span class=\"fl li-country\" lang=wallis_and_futuna_islands></span><span class=\"fr li-code\" data-type-select=country-code>+681</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=vanuatu></span><span class=\"fr li-code\" data-type-select=country-code>+678</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=guatemala></span><span class=\"fr li-code\" data-type-select=country-code>+502</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=venezuela></span><span class=\"fr li-code\" data-type-select=country-code>+58</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=brunei></span><span class=\"fr li-code\" data-type-select=country-code>+673</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=uganda></span><span class=\"fr li-code\" data-type-select=country-code>+256</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=ukrainian></span><span class=\"fr li-code\" data-type-select=country-code>+380</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=uruguay></span><span class=\"fr li-code\" data-type-select=country-code>+598</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=uzbekistan></span><span class=\"fr li-code\" data-type-select=country-code>+998</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=greece></span><span class=\"fr li-code\" data-type-select=country-code>+30</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=spain></span><span class=\"fr li-code\" data-type-select=country-code>+34</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=singapore></span><span class=\"fr li-code\" data-type-select=country-code>+65</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=new_caledonia></span><span class=\"fr li-code\" data-type-select=country-code>+687</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=new_zealand></span><span class=\"fr li-code\" data-type-select=country-code>+64</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=hungary></span><span class=\"fr li-code\" data-type-select=country-code>+36</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=syria></span><span class=\"fr li-code\" data-type-select=country-code>+963</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=jamaica></span><span class=\"fr li-code\" data-type-select=country-code>+1876</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=armenia></span><span class=\"fr li-code\" data-type-select=country-code>+374</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=yemen></span><span class=\"fr li-code\" data-type-select=country-code>+967</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=iraq></span><span class=\"fr li-code\" data-type-select=country-code>+964</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=iran></span><span class=\"fr li-code\" data-type-select=country-code>+98</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=israel></span><span class=\"fr li-code\" data-type-select=country-code>+972</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=italy></span><span class=\"fr li-code\" data-type-select=country-code>+39</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=india></span><span class=\"fr li-code\" data-type-select=country-code>+91</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=indonesia></span><span class=\"fr li-code\" data-type-select=country-code>+62</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=united_kingdom></span><span class=\"fr li-code\" data-type-select=country-code>+44</span></li> <li class=\"select-country-li the-longest the-long\" data-type-select=country-li><span class=\"fl li-country\" lang=the_british_virgin_islands></span><span class=\"fr li-code\" data-type-select=country-code>+1284</span> </li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=jordan></span><span class=\"fr li-code\" data-type-select=country-code>+962</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=vietnam></span><span class=\"fr li-code\" data-type-select=country-code>+84</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=zambia></span><span class=\"fr li-code\" data-type-select=country-code>+260</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=chad></span><span class=\"fr li-code\" data-type-select=country-code>+235</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=gibraltar></span><span class=\"fr li-code\" data-type-select=country-code>+350</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=chile></span><span class=\"fr li-code\" data-type-select=country-code>+56</span></li> <li class=select-country-li data-type-select=country-li><span class=\"fl li-country\" lang=central_african_republic></span><span class=\"fr li-code\" data-type-select=country-code>+236</span></li> </ul> </div> </div> <input id=home-input-phone class=\"validate[required,funcCall[cloudInput]] form-control form_control input-phonenum\" type=text name=phone lang=placeholder:phone_number autofocus autocomplete=off data-type-cp=newPhone-code> </div> </div> </div> <div class=\"form-group password\"> <input type=text lang=placeholder:password class=\"validate[required,funcCall[cloudInput]] form-control\" id=home-input-pwd-password title=\"\"/> </div> <div class=form-group> <div class=home-content-login-ver> <input type=text lang=placeholder:security_code class=\"validate[required,custom[systemAuthcode],funcCall[cloudInput]] form-control\" id=home-input-ver-custom title=\"\"/> <div class=login-captcha style=float:right></div> </div> </div> <div class=\"form-group phone\" style=display:none> <div class=home-content-login-ver> <input type=text lang=placeholder:sms_code class=\"validate[required,custom[smsCode],funcCall[cloudInput]] form-control\" id=home-input-sms-code title=\"\"/> <button id=send-sms class=\"btn btn-info btn-sm\" type=button lang=text:send_sms_code style=width:83px;float:right></button> </div> </div> <div class=form-group style=margin-top:16px> <button lang={text:sign_in,title:sign_in} type=submit value=\"\" class=\"btn btn-info btn-block\" id=home-input-submit></button> </div> <div style=font-size:12px> <a href=javascript:void(0) class=\"a-label password\" id=switch-to-code lang=text:phone_login></a> <a href=javascript:void(0) class=\"a-label phone\" style=display:none id=switch-to-password lang=text:password_login></a> <a href=javascript:void(0) id=home-login-forget class=\"home-login-forget a-label\" style=color:#000> <span lang=forgot_pwd></span>? </a> </div> </form> <div class=bottom-liner></div> <div class=bottom-liner></div> <div class=bottom-liner></div> <div class=bottom-liner></div> </div> </div> </div> </div> <div id=home-content-bottom-div> <div class=home-content-bottom-wrapper> <div class=col-xs-8> <div id=home-content-bottom-div-top> <div id=home-content-bottom-div-top-text>&gt;&gt; <span lang=text:inhand_provides></span></div> </div> <div id=home-content-bottom-div-center style=position:relative class=col-xs-11> <div class=\"home-content-bottom-div-center-item col-xs-5\"> <div class=home-content-logo style=float:right> <div class=\"home-content-bottom-div-center-item-image image-dm\"> </div> <div class=home-content-bottom-div-center-item-text> <div class=home-content-bottom-div-center-text-top> DeviceManager </div> <div class=home-content-bottom-div-center-text-center lang=text:manage_network></div> </div> </div> </div> <div class=\"home-content-bottom-div-center-item col-xs-4\"> <div class=home-content-logo style=float:left> <div class=\"home-content-bottom-div-center-item-image image-dt\"></div> <div class=home-content-bottom-div-center-item-text> <div class=home-content-bottom-div-center-text-top> DeviceTouch </div> <div class=home-content-bottom-div-center-text-center lang=text:maintain_devices></div> </div> </div> </div> <div class=clearfix></div> </div> </div> <div class=\"col-xs-4 aboutDownload\"> <div> <div id=aboutDownload>&gt;&gt; <span lang=text:related_download></span></div> </div> <div class=col-xs-8> <div class=download> <a href=#device-touch> <div class=cloud-download> </div> <div class=\"\"> <div lang=text:devicetouch></div> <div>Download</div> </div> </a> </div> </div> </div> </div> </div> <div id=device-manager class=\"home-detail dm\"> <div class=home-content-oblique> <div class=splite> <div class=\"glyphicon glyphicon-menu-down\"></div> </div> <img src=" + __webpack_require__(69) + "> </div> <div class=home-intro-wrapper> <div class=\"home-intro-top home-wrapper\"> <div class=row> <div class=\"col-xs-6 image\"></div> <div class=col-xs-6 style=padding-bottom:60px> <img src=" + __webpack_require__(70) + " width=300px> <div style=font-size:34px lang=text:device_manager_name>远程网管软件</div> <p style=margin-top:60px lang=text:device_manager_introduction> Device Manager是InHand Device Network系统软件中的网管单元， 作为该系统软件的基础软件，用于管理映翰通网络产品。 在使用映翰通网络产品进行大规模联网的应用中， Device Manager帮助用户远程管理联网设备。 </p> <p lang=text:device_manager_function>该软件可管理映翰通的InDTU、3G路由器、2.5G/3G智能网关等系列产品。</p> </div> </div> </div> <div class=home-intro-middle> <div class=home-wrapper> <div class=row style=\"\"> <div class=\"col-xs-4 home-feature\"> <div class=\"logo logo-3\"></div> <div class=title lang=text:device_manager_device_network_management>联网设备接入管理</div> <div class=\"content text-left\"> <ul> <li lang=text:device_manager_device_network_management1>统一接入管理联网产品</li> <li lang=text:device_manager_device_network_management2>对设备进行批量升级操作</li> <li lang=text:device_manager_device_network_management3>对设备进行批量配置操作</li> </ul> </div> </div> <div class=\"col-xs-4 home-feature home-feature-middle\"> <div class=\"logo logo-2\"></div> <div class=title lang=text:device_manager_site_info_management>现场信息管理</div> <div class=\"content text-left\"> <ul> <li lang=text:device_manager_site_info_management1>地理信息</li> <li lang=text:device_manager_site_info_management2>联网设备信息</li> <li lang=text:device_manager_site_info_management3>客户信息</li> </ul> </div> </div> <div class=\"col-xs-4 home-feature\"> <div class=\"logo logo-5\"></div> <div class=title lang=text:device_manager_statistics>统计</div> <div class=\"content text-left\" style=margin-left:66px> <ul> <li lang=text:device_manager_statistics1>连接状态及质量</li> <li lang=text:device_manager_statistics2>在线历史及趋势</li> <li lang=text:device_manager_statistics3>流量累计</li> <li lang=text:device_manager_statistics4>流量趋势及阀值设定</li> </ul> </div> </div> </div> </div> </div> <div class=\"home-intro-bottom home-wrapper\" style=margin-top:50px> <div class=\"home-wrapper feature-block\"> <div class=row> <div class=col-xs-6> <div class=panel> <div class=panel-body> <div class=\"pull-left icon\"> <img src=" + __webpack_require__(71) + " alt=\"\"> </div> <div class=content> <h3 lang=text:device_manager_network_management_software>系统级别的网管软件</h3> <ul> <li lang=text:device_manager_network_management_software1>多用户系统，多级权限控制</li> <li lang=text:device_manager_network_management_software2>友好的人际界面</li> <li lang=text:device_manager_network_management_software3>B/S架构，无需安装客户端软件</li> </ul> </div> </div> </div> </div> <div class=col-xs-6> <div class=panel> <div class=panel-body> <div class=\"icon icon-2 pull-left\"> <img src=" + __webpack_require__(72) + " alt=\"\"> </div> <div class=content> <h3 lang=text:device_manager_advantage_scalability>高性能的接入能力</h3> <ul> <li lang=text:device_manager_advantage_scalability1>支持上万级别的联网设备接入</li> <li lang=text:device_manager_advantage_scalability2>权限控制机制保证合法访问设备</li> </ul> </div> </div> </div> </div> </div> <div class=row> <div class=col-xs-6> <div class=panel style=height:176px> <div class=panel-body> <div class=\"icon icon-3 pull-left\"> <img src=" + __webpack_require__(73) + " alt=\"\"> </div> <div class=content> <h3 lang=text:device_manager_advantage_batch_process>批量处理机制</h3> <ul> <li lang=text:device_manager_advantage_batch_process1>降低管理难度</li> <li lang=text:device_manager_advantage_batch_process2>提高管理效率</li> </ul> </div> </div> </div> </div> <div class=col-xs-6> <div class=panel style=height:176px> <div class=panel-body> <div class=\"icon icon-4 pull-left\"> <img src=" + __webpack_require__(74) + " alt=\"\"> </div> <div class=content> <h3 lang=text:device_manager_advantage_cellular_communication>移动通信特点的网管系统</h3> <ul> <li lang=text:device_manager_advantage_cellular_communication1>全面支持网络</li> <li lang=text:device_manager_advantage_cellular_communication2>使用低宽带、高延迟、丢包率较高的网络环境</li> <li lang=text:device_manager_advantage_cellular_communication3>支持被管理端获得的静态或动态IP</li> </ul> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div id=device-touch class=\"home-detail dt\"> <div class=home-content-oblique> <div class=splite> <div class=\"glyphicon glyphicon-menu-down\"></div> </div> <img src=" + __webpack_require__(75) + "> </div> <div class=home-intro-wrapper> <div class=\"home-intro-top home-wrapper\"> <div class=row> <div class=col-xs-6 style=padding-bottom:60px> <img src=" + __webpack_require__(76) + " width=300px> <div style=font-size:34px lang=text:device_touch_name>远程维护软件</div> <p style=margin-top:60px lang=text:device_touch_introduction> InHand Device Touch软件通过映翰通无线通讯产品快速便捷安全的建立远程维护隧道， 使维护工程师通过安全维护隧道实现远程对现场设备进行维护。依靠Device Touch 建立的按需接入隧道， 工程师可以在生产现场以外的任何有网络的地方，使用编程软件对设备进行编程操作、设备诊断远程调试、 变量监控等工作。 </p> <p lang=text:device_touch_function>该软件与映翰通的2.5G/3G无线路由器和智能网关等系列产品组成远程维护方案。</p> <div class=device-touch-download> <a target=_blank id=download-dt-client href=# lang=title:download> <div class=\"device-touch-download-icon col-xs-3\"></div> <div class=\"\"> <div class=device-touch-text lang=text:devicetouch></div> <div>Download</div> </div> </a> </div> </div> <div class=\"col-xs-6 image\"></div> </div> </div> <div class=home-intro-middle> <div class=home-wrapper> <div class=row style=\"\"> <div class=\"col-xs-4 home-feature\"> <div class=\"logo logo-plc\"></div> <div class=title lang=text:device_touch_support_device>支持主流的PLC<br/>及HMI等设备</div> <div class=\"content text-left\"> <ul> <li lang=text:device_touch_support_device1>可支持以太网、RS232/RS485接口的设备</li> <li lang=text:device_touch_support_device2>支持西门子、罗克韦尔、施耐德、欧姆龙、三菱等主要品牌PLC专用客户端软件</li> <li lang=text:device_touch_support_device3>用于接入到InHand Device Touch系统及现场设备</li> </ul> </div> </div> <div class=\"col-xs-4 home-feature home-feature-middle\"> <div class=\"logo logo-connect\"></div> <div class=title lang=text:device_touch_accessibility>接入能力</div> <div class=\"content text-left\"> <ul> <li lang=text:device_touch_accessibility1>支持>10000点管理维护通道接入管理</li> <li lang=text:device_touch_accessibility2>根据权限识别客户端是否能连接现场设备按需连接现场PLC机制</li> <li lang=text:device_touch_accessibility3>账户、密码及证书认证机制</li> <li lang=text:device_touch_accessibility4>Device Touch软件根据工程师需要连接指定PLC现场现场信息管理</li> <li lang=text:device_touch_accessibility5>设备配置信息,包含IP地址、PLC站地址、通信参数</li> </ul> </div> </div> <div class=\"col-xs-4 home-feature\"> <div class=\"logo logo-log\"></div> <div class=title lang=text:device_touch_log_management>日志管理</div> <div class=\"content text-left\" style=margin-left:66px> <ul> <li lang=text:device_touch_log_management1>客户端连接日志</li> <li lang=text:device_touch_log_management2>工程师维护日志</li> </ul> </div> </div> </div> </div> </div> <div class=\"home-intro-bottom home-wrapper\" style=margin-top:50px> <div class=\"home-wrapper feature-block\"> <div class=row> <div class=col-xs-6> <div class=panel> <div class=panel-body> <div class=\"pull-left icon\"> <img src=" + __webpack_require__(77) + " alt=\"\"> </div> <div class=content> <h3 lang=text:device_touch_advantage_easy>简单、快捷部署</h3> <ul> <li lang=text:device_touch_advantage_easy1>不改变原有现场通信结构</li> <li lang=text:device_touch_advantage_easy2>有效降低实施难度及复杂度</li> </ul> </div> </div> </div> </div> <div class=col-xs-6> <div class=panel> <div class=panel-body> <div class=\"icon icon-2 pull-left\"> <img src=" + __webpack_require__(78) + " alt=\"\"> </div> <div class=content> <h3 lang=text:device_touch_advantage_secure>安全可信的系统</h3> <ul> <li lang=text:device_touch_advantage_secure1>客户端身份认证机制</li> <li lang=text:device_touch_advantage_secure2>权限控制机制保证合法访问设备</li> </ul> </div> </div> </div> </div> </div> <div class=row> <div class=col-xs-6> <div class=panel> <div class=panel-body> <div class=\"icon icon-3 pull-left\"> <img src=" + __webpack_require__(79) + " alt=\"\"> </div> <div class=content> <h3 lang=text:device_touch_advantage_innovation>创新的连接机制</h3> <ul> <li lang=text:device_touch_advantage_innovation1>按需连接机制</li> <li lang=text:device_touch_advantage_innovation2>有效降低中心网络设备投入成本</li> </ul> </div> </div> </div> </div> <div class=col-xs-6> <div class=panel> <div class=panel-body> <div class=\"icon icon-4 pull-left\"> <img src=" + __webpack_require__(80) + " alt=\"\"> </div> <div class=content> <h3 lang=text:device_touch_advantage_upgrade>改进后的设备维修方式</h3> <ul> <li lang=text:device_touch_advantage_upgrade1>由传统的响应式维修进化为远程及时维修模式</li> </ul> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div id=returnTop> <img src=" + __webpack_require__(81) + " alt=\"\" class=arrow> </div> ";

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources/triangle-3abbac9b397afe95ac44bd82290937f0.svg";

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources/DeviceManager-bd6fc2a9f71242ce626d7a5e143f2591.png";

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources/feature-icon-6-c30a0eee5a0fb373b617698d235d059d.png";

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources/feature-icon-8-a46f298568f006ee12854ae7141b5d6d.png";

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources/feature-icon-7-c73da5a08afd81410392152dbfb0ee2c.png";

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources/feature-icon-9-90e28755aefef3304d6a96147e0e54ad.png";

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources/triangle-2-efa848ed878b6c3e1552fddb057ca784.svg";

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources/DeviceTouch-329551f99123a8e6ca19768c9894b13a.png";

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources/feature-icon-1-844f3c05174dc8c9d078a2a384877b99.png";

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources/feature-icon-2-7f651c0a0f8025f3f2f2082138cc7649.png";

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources/feature-icon-3-e7b08eb3fdefcca7e2d321af57e1b959.png";

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources/feature-icon-4-bc171d8e3aadfe543b3bf490e7489ca4.png";

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources/arrow-up-6a99a60ed6424e811cd228c6965f9dce.png";

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	//---------------------------------------------------------------------
	//
	// QR Code Generator for JavaScript
	//
	// Copyright (c) 2009 Kazuhiko Arase
	//
	// URL: http://www.d-project.com/
	//
	// Licensed under the MIT license:
	//	http://www.opensource.org/licenses/mit-license.php
	//
	// The word 'QR Code' is registered trademark of
	// DENSO WAVE INCORPORATED
	//	http://www.denso-wave.com/qrcode/faqpatent-e.html
	//
	//---------------------------------------------------------------------
	
	exports.qrcode = function() {
	
		//---------------------------------------------------------------------
		// qrcode
		//---------------------------------------------------------------------
	
		/**
		 * qrcode
		 * @param typeNumber 1 to 10
		 * @param errorCorrectLevel 'L','M','Q','H'
		 */
		var qrcode = function(typeNumber, errorCorrectLevel) {
	
			var PAD0 = 0xEC;
			var PAD1 = 0x11;
	
			var _typeNumber = typeNumber;
			var _errorCorrectLevel = QRErrorCorrectLevel[errorCorrectLevel];
			var _modules = null;
			var _moduleCount = 0;
			var _dataCache = null;
			var _dataList = new Array();
	
			var _this = {};
	
			var makeImpl = function(test, maskPattern) {
	
				_moduleCount = _typeNumber * 4 + 17;
				_modules = function(moduleCount) {
					var modules = new Array(moduleCount);
					for (var row = 0; row < moduleCount; row += 1) {
						modules[row] = new Array(moduleCount);
						for (var col = 0; col < moduleCount; col += 1) {
							modules[row][col] = null;
						}
					}
					return modules;
				}(_moduleCount);
	
				setupPositionProbePattern(0, 0);
				setupPositionProbePattern(_moduleCount - 7, 0);
				setupPositionProbePattern(0, _moduleCount - 7);
				setupPositionAdjustPattern();
				setupTimingPattern();
				setupTypeInfo(test, maskPattern);
	
				if (_typeNumber >= 7) {
					setupTypeNumber(test);
				}
	
				if (_dataCache == null) {
					_dataCache = createData(_typeNumber, _errorCorrectLevel, _dataList);
				}
	
				mapData(_dataCache, maskPattern);
			};
	
			var setupPositionProbePattern = function(row, col) {
	
				for (var r = -1; r <= 7; r += 1) {
	
					if (row + r <= -1 || _moduleCount <= row + r) continue;
	
					for (var c = -1; c <= 7; c += 1) {
	
						if (col + c <= -1 || _moduleCount <= col + c) continue;
	
						if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
								|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
								|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
							_modules[row + r][col + c] = true;
						} else {
							_modules[row + r][col + c] = false;
						}
					}
				}
			};
	
			var getBestMaskPattern = function() {
	
				var minLostPoint = 0;
				var pattern = 0;
	
				for (var i = 0; i < 8; i += 1) {
	
					makeImpl(true, i);
	
					var lostPoint = QRUtil.getLostPoint(_this);
	
					if (i == 0 || minLostPoint > lostPoint) {
						minLostPoint = lostPoint;
						pattern = i;
					}
				}
	
				return pattern;
			};
	
			var setupTimingPattern = function() {
	
				for (var r = 8; r < _moduleCount - 8; r += 1) {
					if (_modules[r][6] != null) {
						continue;
					}
					_modules[r][6] = (r % 2 == 0);
				}
	
				for (var c = 8; c < _moduleCount - 8; c += 1) {
					if (_modules[6][c] != null) {
						continue;
					}
					_modules[6][c] = (c % 2 == 0);
				}
			};
	
			var setupPositionAdjustPattern = function() {
	
				var pos = QRUtil.getPatternPosition(_typeNumber);
	
				for (var i = 0; i < pos.length; i += 1) {
	
					for (var j = 0; j < pos.length; j += 1) {
	
						var row = pos[i];
						var col = pos[j];
	
						if (_modules[row][col] != null) {
							continue;
						}
	
						for (var r = -2; r <= 2; r += 1) {
	
							for (var c = -2; c <= 2; c += 1) {
	
								if (r == -2 || r == 2 || c == -2 || c == 2
										|| (r == 0 && c == 0) ) {
									_modules[row + r][col + c] = true;
								} else {
									_modules[row + r][col + c] = false;
								}
							}
						}
					}
				}
			};
	
			var setupTypeNumber = function(test) {
	
				var bits = QRUtil.getBCHTypeNumber(_typeNumber);
	
				for (var i = 0; i < 18; i += 1) {
					var mod = (!test && ( (bits >> i) & 1) == 1);
					_modules[Math.floor(i / 3)][i % 3 + _moduleCount - 8 - 3] = mod;
				}
	
				for (var i = 0; i < 18; i += 1) {
					var mod = (!test && ( (bits >> i) & 1) == 1);
					_modules[i % 3 + _moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
				}
			};
	
			var setupTypeInfo = function(test, maskPattern) {
	
				var data = (_errorCorrectLevel << 3) | maskPattern;
				var bits = QRUtil.getBCHTypeInfo(data);
	
				// vertical
				for (var i = 0; i < 15; i += 1) {
	
					var mod = (!test && ( (bits >> i) & 1) == 1);
	
					if (i < 6) {
						_modules[i][8] = mod;
					} else if (i < 8) {
						_modules[i + 1][8] = mod;
					} else {
						_modules[_moduleCount - 15 + i][8] = mod;
					}
				}
	
				// horizontal
				for (var i = 0; i < 15; i += 1) {
	
					var mod = (!test && ( (bits >> i) & 1) == 1);
	
					if (i < 8) {
						_modules[8][_moduleCount - i - 1] = mod;
					} else if (i < 9) {
						_modules[8][15 - i - 1 + 1] = mod;
					} else {
						_modules[8][15 - i - 1] = mod;
					}
				}
	
				// fixed module
				_modules[_moduleCount - 8][8] = (!test);
			};
	
			var mapData = function(data, maskPattern) {
	
				var inc = -1;
				var row = _moduleCount - 1;
				var bitIndex = 7;
				var byteIndex = 0;
				var maskFunc = QRUtil.getMaskFunction(maskPattern);
	
				for (var col = _moduleCount - 1; col > 0; col -= 2) {
	
					if (col == 6) col -= 1;
	
					while (true) {
	
						for (var c = 0; c < 2; c += 1) {
	
							if (_modules[row][col - c] == null) {
	
								var dark = false;
	
								if (byteIndex < data.length) {
									dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
								}
	
								var mask = maskFunc(row, col - c);
	
								if (mask) {
									dark = !dark;
								}
	
								_modules[row][col - c] = dark;
								bitIndex -= 1;
	
								if (bitIndex == -1) {
									byteIndex += 1;
									bitIndex = 7;
								}
							}
						}
	
						row += inc;
	
						if (row < 0 || _moduleCount <= row) {
							row -= inc;
							inc = -inc;
							break;
						}
					}
				}
			};
	
			var createBytes = function(buffer, rsBlocks) {
	
				var offset = 0;
	
				var maxDcCount = 0;
				var maxEcCount = 0;
	
				var dcdata = new Array(rsBlocks.length);
				var ecdata = new Array(rsBlocks.length);
	
				for (var r = 0; r < rsBlocks.length; r += 1) {
	
					var dcCount = rsBlocks[r].dataCount;
					var ecCount = rsBlocks[r].totalCount - dcCount;
	
					maxDcCount = Math.max(maxDcCount, dcCount);
					maxEcCount = Math.max(maxEcCount, ecCount);
	
					dcdata[r] = new Array(dcCount);
	
					for (var i = 0; i < dcdata[r].length; i += 1) {
						dcdata[r][i] = 0xff & buffer.getBuffer()[i + offset];
					}
					offset += dcCount;
	
					var rsPoly = QRUtil.getErrorCorrectPolynomial(ecCount);
					var rawPoly = qrPolynomial(dcdata[r], rsPoly.getLength() - 1);
	
					var modPoly = rawPoly.mod(rsPoly);
					ecdata[r] = new Array(rsPoly.getLength() - 1);
					for (var i = 0; i < ecdata[r].length; i += 1) {
						var modIndex = i + modPoly.getLength() - ecdata[r].length;
						ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
					}
				}
	
				var totalCodeCount = 0;
				for (var i = 0; i < rsBlocks.length; i += 1) {
					totalCodeCount += rsBlocks[i].totalCount;
				}
	
				var data = new Array(totalCodeCount);
				var index = 0;
	
				for (var i = 0; i < maxDcCount; i += 1) {
					for (var r = 0; r < rsBlocks.length; r += 1) {
						if (i < dcdata[r].length) {
							data[index] = dcdata[r][i];
							index += 1;
						}
					}
				}
	
				for (var i = 0; i < maxEcCount; i += 1) {
					for (var r = 0; r < rsBlocks.length; r += 1) {
						if (i < ecdata[r].length) {
							data[index] = ecdata[r][i];
							index += 1;
						}
					}
				}
	
				return data;
			};
	
			var createData = function(typeNumber, errorCorrectLevel, dataList) {
	
				var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	
				var buffer = qrBitBuffer();
	
				for (var i = 0; i < dataList.length; i += 1) {
					var data = dataList[i];
					buffer.put(data.getMode(), 4);
					buffer.put(data.getLength(), QRUtil.getLengthInBits(data.getMode(), typeNumber) );
					data.write(buffer);
				}
	
				// calc num max data.
				var totalDataCount = 0;
				for (var i = 0; i < rsBlocks.length; i += 1) {
					totalDataCount += rsBlocks[i].dataCount;
				}
	
				if (buffer.getLengthInBits() > totalDataCount * 8) {
					throw new Error('code length overflow. ('
						+ buffer.getLengthInBits()
						+ '>'
						+ totalDataCount * 8
						+ ')');
				}
	
				// end code
				if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
					buffer.put(0, 4);
				}
	
				// padding
				while (buffer.getLengthInBits() % 8 != 0) {
					buffer.putBit(false);
				}
	
				// padding
				while (true) {
	
					if (buffer.getLengthInBits() >= totalDataCount * 8) {
						break;
					}
					buffer.put(PAD0, 8);
	
					if (buffer.getLengthInBits() >= totalDataCount * 8) {
						break;
					}
					buffer.put(PAD1, 8);
				}
	
				return createBytes(buffer, rsBlocks);
			};
	
			_this.addData = function(data) {
				var newData = qr8BitByte(data);
				_dataList.push(newData);
				_dataCache = null;
			};
	
			_this.isDark = function(row, col) {
				if (row < 0 || _moduleCount <= row || col < 0 || _moduleCount <= col) {
					throw new Error(row + ',' + col);
				}
				return _modules[row][col];
			};
	
			_this.getModuleCount = function() {
				return _moduleCount;
			};
	
			_this.make = function() {
				makeImpl(false, getBestMaskPattern() );
			};
	
			_this.createTableTag = function(cellSize, margin) {
	
				cellSize = cellSize || 2;
				margin = (typeof margin == 'undefined')? cellSize * 4 : margin;
	
				var qrHtml = '';
	
				qrHtml += '<table style="';
				qrHtml += ' border-width: 0px; border-style: none;';
				qrHtml += ' border-collapse: collapse;';
				qrHtml += ' padding: 0px; margin: ' + margin + 'px;';
				qrHtml += '">';
				qrHtml += '<tbody>';
	
				for (var r = 0; r < _this.getModuleCount(); r += 1) {
	
					qrHtml += '<tr>';
	
					for (var c = 0; c < _this.getModuleCount(); c += 1) {
						qrHtml += '<td style="';
						qrHtml += ' border-width: 0px; border-style: none;';
						qrHtml += ' border-collapse: collapse;';
						qrHtml += ' padding: 0px; margin: 0px;';
						qrHtml += ' width: ' + cellSize + 'px;';
						qrHtml += ' height: ' + cellSize + 'px;';
						qrHtml += ' background-color: ';
						qrHtml += _this.isDark(r, c)? '#000000' : '#ffffff';
						qrHtml += ';';
						qrHtml += '"/>';
					}
	
					qrHtml += '</tr>';
				}
	
				qrHtml += '</tbody>';
				qrHtml += '</table>';
	
				return qrHtml;
			};
	
			_this.createImgTag = function(cellSize, margin) {
	
				cellSize = cellSize || 2;
				margin = (typeof margin == 'undefined')? cellSize * 4 : margin;
	
				var size = _this.getModuleCount() * cellSize + margin * 2;
				var min = margin;
				var max = size - margin;
	
				return createImgTag(size, size, function(x, y) {
					if (min <= x && x < max && min <= y && y < max) {
						var c = Math.floor( (x - min) / cellSize);
						var r = Math.floor( (y - min) / cellSize);
						return _this.isDark(r, c)? 0 : 1;
					} else {
						return 1;
					}
				} );
			};
	
			return _this;
		};
	
		//---------------------------------------------------------------------
		// qrcode.stringToBytes
		//---------------------------------------------------------------------
	
		qrcode.stringToBytes = function(s) {
			var bytes = new Array();
			for (var i = 0; i < s.length; i += 1) {
				var c = s.charCodeAt(i);
				bytes.push(c & 0xff);
			}
			return bytes;
		};
	
		//---------------------------------------------------------------------
		// qrcode.createStringToBytes
		//---------------------------------------------------------------------
	
		/**
		 * @param unicodeData base64 string of byte array.
		 * [16bit Unicode],[16bit Bytes], ...
		 * @param numChars
		 */
		qrcode.createStringToBytes = function(unicodeData, numChars) {
	
			// create conversion map.
	
			var unicodeMap = function() {
	
				var bin = base64DecodeInputStream(unicodeData);
				var read = function() {
					var b = bin.read();
					if (b == -1) throw new Error();
					return b;
				};
	
				var count = 0;
				var unicodeMap = {};
				while (true) {
					var b0 = bin.read();
					if (b0 == -1) break;
					var b1 = read();
					var b2 = read();
					var b3 = read();
					var k = String.fromCharCode( (b0 << 8) | b1);
					var v = (b2 << 8) | b3;
					unicodeMap[k] = v;
					count += 1;
				}
				if (count != numChars) {
					throw new Error(count + ' != ' + numChars);
				}
	
				return unicodeMap;
			}();
	
			var unknownChar = '?'.charCodeAt(0);
	
			return function(s) {
				var bytes = new Array();
				for (var i = 0; i < s.length; i += 1) {
					var c = s.charCodeAt(i);
					if (c < 128) {
						bytes.push(c);
					} else {
						var b = unicodeMap[s.charAt(i)];
						if (typeof b == 'number') {
							if ( (b & 0xff) == b) {
								// 1byte
								bytes.push(b);
							} else {
								// 2bytes
								bytes.push(b >>> 8);
								bytes.push(b & 0xff);
							}
						} else {
							bytes.push(unknownChar);
						}
					}
				}
				return bytes;
			};
		};
	
		//---------------------------------------------------------------------
		// QRMode
		//---------------------------------------------------------------------
	
		var QRMode = {
			MODE_NUMBER :		1 << 0,
			MODE_ALPHA_NUM : 	1 << 1,
			MODE_8BIT_BYTE : 	1 << 2,
			MODE_KANJI :		1 << 3
		};
	
		//---------------------------------------------------------------------
		// QRErrorCorrectLevel
		//---------------------------------------------------------------------
	
		var QRErrorCorrectLevel = {
			L : 1,
			M : 0,
			Q : 3,
			H : 2
		};
	
		//---------------------------------------------------------------------
		// QRMaskPattern
		//---------------------------------------------------------------------
	
		var QRMaskPattern = {
			PATTERN000 : 0,
			PATTERN001 : 1,
			PATTERN010 : 2,
			PATTERN011 : 3,
			PATTERN100 : 4,
			PATTERN101 : 5,
			PATTERN110 : 6,
			PATTERN111 : 7
		};
	
		//---------------------------------------------------------------------
		// QRUtil
		//---------------------------------------------------------------------
	
		var QRUtil = function() {
	
			var PATTERN_POSITION_TABLE = [
				[],
				[6, 18],
				[6, 22],
				[6, 26],
				[6, 30],
				[6, 34],
				[6, 22, 38],
				[6, 24, 42],
				[6, 26, 46],
				[6, 28, 50],
				[6, 30, 54],
				[6, 32, 58],
				[6, 34, 62],
				[6, 26, 46, 66],
				[6, 26, 48, 70],
				[6, 26, 50, 74],
				[6, 30, 54, 78],
				[6, 30, 56, 82],
				[6, 30, 58, 86],
				[6, 34, 62, 90],
				[6, 28, 50, 72, 94],
				[6, 26, 50, 74, 98],
				[6, 30, 54, 78, 102],
				[6, 28, 54, 80, 106],
				[6, 32, 58, 84, 110],
				[6, 30, 58, 86, 114],
				[6, 34, 62, 90, 118],
				[6, 26, 50, 74, 98, 122],
				[6, 30, 54, 78, 102, 126],
				[6, 26, 52, 78, 104, 130],
				[6, 30, 56, 82, 108, 134],
				[6, 34, 60, 86, 112, 138],
				[6, 30, 58, 86, 114, 142],
				[6, 34, 62, 90, 118, 146],
				[6, 30, 54, 78, 102, 126, 150],
				[6, 24, 50, 76, 102, 128, 154],
				[6, 28, 54, 80, 106, 132, 158],
				[6, 32, 58, 84, 110, 136, 162],
				[6, 26, 54, 82, 110, 138, 166],
				[6, 30, 58, 86, 114, 142, 170]
			];
			var G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0);
			var G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0);
			var G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1);
	
			var _this = {};
	
			var getBCHDigit = function(data) {
				var digit = 0;
				while (data != 0) {
					digit += 1;
					data >>>= 1;
				}
				return digit;
			};
	
			_this.getBCHTypeInfo = function(data) {
				var d = data << 10;
				while (getBCHDigit(d) - getBCHDigit(G15) >= 0) {
					d ^= (G15 << (getBCHDigit(d) - getBCHDigit(G15) ) );
				}
				return ( (data << 10) | d) ^ G15_MASK;
			};
	
			_this.getBCHTypeNumber = function(data) {
				var d = data << 12;
				while (getBCHDigit(d) - getBCHDigit(G18) >= 0) {
					d ^= (G18 << (getBCHDigit(d) - getBCHDigit(G18) ) );
				}
				return (data << 12) | d;
			};
	
			_this.getPatternPosition = function(typeNumber) {
				return PATTERN_POSITION_TABLE[typeNumber - 1];
			};
	
			_this.getMaskFunction = function(maskPattern) {
	
				switch (maskPattern) {
	
				case QRMaskPattern.PATTERN000 :
					return function(i, j) { return (i + j) % 2 == 0; };
				case QRMaskPattern.PATTERN001 :
					return function(i, j) { return i % 2 == 0; };
				case QRMaskPattern.PATTERN010 :
					return function(i, j) { return j % 3 == 0; };
				case QRMaskPattern.PATTERN011 :
					return function(i, j) { return (i + j) % 3 == 0; };
				case QRMaskPattern.PATTERN100 :
					return function(i, j) { return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0; };
				case QRMaskPattern.PATTERN101 :
					return function(i, j) { return (i * j) % 2 + (i * j) % 3 == 0; };
				case QRMaskPattern.PATTERN110 :
					return function(i, j) { return ( (i * j) % 2 + (i * j) % 3) % 2 == 0; };
				case QRMaskPattern.PATTERN111 :
					return function(i, j) { return ( (i * j) % 3 + (i + j) % 2) % 2 == 0; };
	
				default :
					throw new Error('bad maskPattern:' + maskPattern);
				}
			};
	
			_this.getErrorCorrectPolynomial = function(errorCorrectLength) {
				var a = qrPolynomial([1], 0);
				for (var i = 0; i < errorCorrectLength; i += 1) {
					a = a.multiply(qrPolynomial([1, QRMath.gexp(i)], 0) );
				}
				return a;
			};
	
			_this.getLengthInBits = function(mode, type) {
	
				if (1 <= type && type < 10) {
	
					// 1 - 9
	
					switch(mode) {
					case QRMode.MODE_NUMBER 	: return 10;
					case QRMode.MODE_ALPHA_NUM 	: return 9;
					case QRMode.MODE_8BIT_BYTE	: return 8;
					case QRMode.MODE_KANJI		: return 8;
					default :
						throw new Error('mode:' + mode);
					}
	
				} else if (type < 27) {
	
					// 10 - 26
	
					switch(mode) {
					case QRMode.MODE_NUMBER 	: return 12;
					case QRMode.MODE_ALPHA_NUM 	: return 11;
					case QRMode.MODE_8BIT_BYTE	: return 16;
					case QRMode.MODE_KANJI		: return 10;
					default :
						throw new Error('mode:' + mode);
					}
	
				} else if (type < 41) {
	
					// 27 - 40
	
					switch(mode) {
					case QRMode.MODE_NUMBER 	: return 14;
					case QRMode.MODE_ALPHA_NUM	: return 13;
					case QRMode.MODE_8BIT_BYTE	: return 16;
					case QRMode.MODE_KANJI		: return 12;
					default :
						throw new Error('mode:' + mode);
					}
	
				} else {
					throw new Error('type:' + type);
				}
			};
	
			_this.getLostPoint = function(qrcode) {
	
				var moduleCount = qrcode.getModuleCount();
	
				var lostPoint = 0;
	
				// LEVEL1
	
				for (var row = 0; row < moduleCount; row += 1) {
					for (var col = 0; col < moduleCount; col += 1) {
	
						var sameCount = 0;
						var dark = qrcode.isDark(row, col);
	
						for (var r = -1; r <= 1; r += 1) {
	
							if (row + r < 0 || moduleCount <= row + r) {
								continue;
							}
	
							for (var c = -1; c <= 1; c += 1) {
	
								if (col + c < 0 || moduleCount <= col + c) {
									continue;
								}
	
								if (r == 0 && c == 0) {
									continue;
								}
	
								if (dark == qrcode.isDark(row + r, col + c) ) {
									sameCount += 1;
								}
							}
						}
	
						if (sameCount > 5) {
							lostPoint += (3 + sameCount - 5);
						}
					}
				};
	
				// LEVEL2
	
				for (var row = 0; row < moduleCount - 1; row += 1) {
					for (var col = 0; col < moduleCount - 1; col += 1) {
						var count = 0;
						if (qrcode.isDark(row, col) ) count += 1;
						if (qrcode.isDark(row + 1, col) ) count += 1;
						if (qrcode.isDark(row, col + 1) ) count += 1;
						if (qrcode.isDark(row + 1, col + 1) ) count += 1;
						if (count == 0 || count == 4) {
							lostPoint += 3;
						}
					}
				}
	
				// LEVEL3
	
				for (var row = 0; row < moduleCount; row += 1) {
					for (var col = 0; col < moduleCount - 6; col += 1) {
						if (qrcode.isDark(row, col)
								&& !qrcode.isDark(row, col + 1)
								&&  qrcode.isDark(row, col + 2)
								&&  qrcode.isDark(row, col + 3)
								&&  qrcode.isDark(row, col + 4)
								&& !qrcode.isDark(row, col + 5)
								&&  qrcode.isDark(row, col + 6) ) {
							lostPoint += 40;
						}
					}
				}
	
				for (var col = 0; col < moduleCount; col += 1) {
					for (var row = 0; row < moduleCount - 6; row += 1) {
						if (qrcode.isDark(row, col)
								&& !qrcode.isDark(row + 1, col)
								&&  qrcode.isDark(row + 2, col)
								&&  qrcode.isDark(row + 3, col)
								&&  qrcode.isDark(row + 4, col)
								&& !qrcode.isDark(row + 5, col)
								&&  qrcode.isDark(row + 6, col) ) {
							lostPoint += 40;
						}
					}
				}
	
				// LEVEL4
	
				var darkCount = 0;
	
				for (var col = 0; col < moduleCount; col += 1) {
					for (var row = 0; row < moduleCount; row += 1) {
						if (qrcode.isDark(row, col) ) {
							darkCount += 1;
						}
					}
				}
	
				var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
				lostPoint += ratio * 10;
	
				return lostPoint;
			};
	
			return _this;
		}();
	
		//---------------------------------------------------------------------
		// QRMath
		//---------------------------------------------------------------------
	
		var QRMath = function() {
	
			var EXP_TABLE = new Array(256);
			var LOG_TABLE = new Array(256);
	
			// initialize tables
			for (var i = 0; i < 8; i += 1) {
				EXP_TABLE[i] = 1 << i;
			}
			for (var i = 8; i < 256; i += 1) {
				EXP_TABLE[i] = EXP_TABLE[i - 4]
					^ EXP_TABLE[i - 5]
					^ EXP_TABLE[i - 6]
					^ EXP_TABLE[i - 8];
			}
			for (var i = 0; i < 255; i += 1) {
				LOG_TABLE[EXP_TABLE[i] ] = i;
			}
	
			var _this = {};
	
			_this.glog = function(n) {
	
				if (n < 1) {
					throw new Error('glog(' + n + ')');
				}
	
				return LOG_TABLE[n];
			};
	
			_this.gexp = function(n) {
	
				while (n < 0) {
					n += 255;
				}
	
				while (n >= 256) {
					n -= 255;
				}
	
				return EXP_TABLE[n];
			};
	
			return _this;
		}();
	
		//---------------------------------------------------------------------
		// qrPolynomial
		//---------------------------------------------------------------------
	
		function qrPolynomial(num, shift) {
	
			if (typeof num.length == 'undefined') {
				throw new Error(num.length + '/' + shift);
			}
	
			var _num = function() {
				var offset = 0;
				while (offset < num.length && num[offset] == 0) {
					offset += 1;
				}
				var _num = new Array(num.length - offset + shift);
				for (var i = 0; i < num.length - offset; i += 1) {
					_num[i] = num[i + offset];
				}
				return _num;
			}();
	
			var _this = {};
	
			_this.get = function(index) {
				return _num[index];
			};
	
			_this.getLength = function() {
				return _num.length;
			};
	
			_this.multiply = function(e) {
	
				var num = new Array(_this.getLength() + e.getLength() - 1);
	
				for (var i = 0; i < _this.getLength(); i += 1) {
					for (var j = 0; j < e.getLength(); j += 1) {
						num[i + j] ^= QRMath.gexp(QRMath.glog(_this.get(i) ) + QRMath.glog(e.get(j) ) );
					}
				}
	
				return qrPolynomial(num, 0);
			};
	
			_this.mod = function(e) {
	
				if (_this.getLength() - e.getLength() < 0) {
					return _this;
				}
	
				var ratio = QRMath.glog(_this.get(0) ) - QRMath.glog(e.get(0) );
	
				var num = new Array(_this.getLength() );
				for (var i = 0; i < _this.getLength(); i += 1) {
					num[i] = _this.get(i);
				}
	
				for (var i = 0; i < e.getLength(); i += 1) {
					num[i] ^= QRMath.gexp(QRMath.glog(e.get(i) ) + ratio);
				}
	
				// recursive call
				return qrPolynomial(num, 0).mod(e);
			};
	
			return _this;
		};
	
		//---------------------------------------------------------------------
		// QRRSBlock
		//---------------------------------------------------------------------
	
		var QRRSBlock = function() {
	
			var RS_BLOCK_TABLE = [
	
				// L
				// M
				// Q
				// H
	
				// 1
				[1, 26, 19],
				[1, 26, 16],
				[1, 26, 13],
				[1, 26, 9],
	
				// 2
				[1, 44, 34],
				[1, 44, 28],
				[1, 44, 22],
				[1, 44, 16],
	
				// 3
				[1, 70, 55],
				[1, 70, 44],
				[2, 35, 17],
				[2, 35, 13],
	
				// 4
				[1, 100, 80],
				[2, 50, 32],
				[2, 50, 24],
				[4, 25, 9],
	
				// 5
				[1, 134, 108],
				[2, 67, 43],
				[2, 33, 15, 2, 34, 16],
				[2, 33, 11, 2, 34, 12],
	
				// 6
				[2, 86, 68],
				[4, 43, 27],
				[4, 43, 19],
				[4, 43, 15],
	
				// 7
				[2, 98, 78],
				[4, 49, 31],
				[2, 32, 14, 4, 33, 15],
				[4, 39, 13, 1, 40, 14],
	
				// 8
				[2, 121, 97],
				[2, 60, 38, 2, 61, 39],
				[4, 40, 18, 2, 41, 19],
				[4, 40, 14, 2, 41, 15],
	
				// 9
				[2, 146, 116],
				[3, 58, 36, 2, 59, 37],
				[4, 36, 16, 4, 37, 17],
				[4, 36, 12, 4, 37, 13],
	
				// 10
				[2, 86, 68, 2, 87, 69],
				[4, 69, 43, 1, 70, 44],
				[6, 43, 19, 2, 44, 20],
				[6, 43, 15, 2, 44, 16]
			];
	
			var qrRSBlock = function(totalCount, dataCount) {
				var _this = {};
				_this.totalCount = totalCount;
				_this.dataCount = dataCount;
				return _this;
			};
	
			var _this = {};
	
			var getRsBlockTable = function(typeNumber, errorCorrectLevel) {
	
				switch(errorCorrectLevel) {
				case QRErrorCorrectLevel.L :
					return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
				case QRErrorCorrectLevel.M :
					return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
				case QRErrorCorrectLevel.Q :
					return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
				case QRErrorCorrectLevel.H :
					return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
				default :
					return undefined;
				}
			};
	
			_this.getRSBlocks = function(typeNumber, errorCorrectLevel) {
	
				var rsBlock = getRsBlockTable(typeNumber, errorCorrectLevel);
	
				if (typeof rsBlock == 'undefined') {
					throw new Error('bad rs block @ typeNumber:' + typeNumber +
							'/errorCorrectLevel:' + errorCorrectLevel);
				}
	
				var length = rsBlock.length / 3;
	
				var list = new Array();
	
				for (var i = 0; i < length; i += 1) {
	
					var count = rsBlock[i * 3 + 0];
					var totalCount = rsBlock[i * 3 + 1];
					var dataCount = rsBlock[i * 3 + 2];
	
					for (var j = 0; j < count; j += 1) {
						list.push(qrRSBlock(totalCount, dataCount) );
					}
				}
	
				return list;
			};
	
			return _this;
		}();
	
		//---------------------------------------------------------------------
		// qrBitBuffer
		//---------------------------------------------------------------------
	
		var qrBitBuffer = function() {
	
			var _buffer = new Array();
			var _length = 0;
	
			var _this = {};
	
			_this.getBuffer = function() {
				return _buffer;
			};
	
			_this.get = function(index) {
				var bufIndex = Math.floor(index / 8);
				return ( (_buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
			};
	
			_this.put = function(num, length) {
				for (var i = 0; i < length; i += 1) {
					_this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
				}
			};
	
			_this.getLengthInBits = function() {
				return _length;
			};
	
			_this.putBit = function(bit) {
	
				var bufIndex = Math.floor(_length / 8);
				if (_buffer.length <= bufIndex) {
					_buffer.push(0);
				}
	
				if (bit) {
					_buffer[bufIndex] |= (0x80 >>> (_length % 8) );
				}
	
				_length += 1;
			};
	
			return _this;
		};
	
		//---------------------------------------------------------------------
		// qr8BitByte
		//---------------------------------------------------------------------
	
		var qr8BitByte = function(data) {
	
			var _mode = QRMode.MODE_8BIT_BYTE;
			var _data = data;
			var _bytes = qrcode.stringToBytes(data);
	
			var _this = {};
	
			_this.getMode = function() {
				return _mode;
			};
	
			_this.getLength = function(buffer) {
				return _bytes.length;
			};
	
			_this.write = function(buffer) {
				for (var i = 0; i < _bytes.length; i += 1) {
					buffer.put(_bytes[i], 8);
				}
			};
	
			return _this;
		};
	
		//=====================================================================
		// GIF Support etc.
		//
	
		//---------------------------------------------------------------------
		// byteArrayOutputStream
		//---------------------------------------------------------------------
	
		var byteArrayOutputStream = function() {
	
			var _bytes = new Array();
	
			var _this = {};
	
			_this.writeByte = function(b) {
				_bytes.push(b & 0xff);
			};
	
			_this.writeShort = function(i) {
				_this.writeByte(i);
				_this.writeByte(i >>> 8);
			};
	
			_this.writeBytes = function(b, off, len) {
				off = off || 0;
				len = len || b.length;
				for (var i = 0; i < len; i += 1) {
					_this.writeByte(b[i + off]);
				}
			};
	
			_this.writeString = function(s) {
				for (var i = 0; i < s.length; i += 1) {
					_this.writeByte(s.charCodeAt(i) );
				}
			};
	
			_this.toByteArray = function() {
				return _bytes;
			};
	
			_this.toString = function() {
				var s = '';
				s += '[';
				for (var i = 0; i < _bytes.length; i += 1) {
					if (i > 0) {
						s += ',';
					}
					s += _bytes[i];
				}
				s += ']';
				return s;
			};
	
			return _this;
		};
	
		//---------------------------------------------------------------------
		// base64EncodeOutputStream
		//---------------------------------------------------------------------
	
		var base64EncodeOutputStream = function() {
	
			var _buffer = 0;
			var _buflen = 0;
			var _length = 0;
			var _base64 = '';
	
			var _this = {};
	
			var writeEncoded = function(b) {
				_base64 += String.fromCharCode(encode(b & 0x3f) );
			};
	
			var encode = function(n) {
				if (n < 0) {
					// error.
				} else if (n < 26) {
					return 0x41 + n;
				} else if (n < 52) {
					return 0x61 + (n - 26);
				} else if (n < 62) {
					return 0x30 + (n - 52);
				} else if (n == 62) {
					return 0x2b;
				} else if (n == 63) {
					return 0x2f;
				}
				throw new Error('n:' + n);
			};
	
			_this.writeByte = function(n) {
	
				_buffer = (_buffer << 8) | (n & 0xff);
				_buflen += 8;
				_length += 1;
	
				while (_buflen >= 6) {
					writeEncoded(_buffer >>> (_buflen - 6) );
					_buflen -= 6;
				}
			};
	
			_this.flush = function() {
	
				if (_buflen > 0) {
					writeEncoded(_buffer << (6 - _buflen) );
					_buffer = 0;
					_buflen = 0;
				}
	
				if (_length % 3 != 0) {
					// padding
					var padlen = 3 - _length % 3;
					for (var i = 0; i < padlen; i += 1) {
						_base64 += '=';
					}
				}
			};
	
			_this.toString = function() {
				return _base64;
			};
	
			return _this;
		};
	
		//---------------------------------------------------------------------
		// base64DecodeInputStream
		//---------------------------------------------------------------------
	
		var base64DecodeInputStream = function(str) {
	
			var _str = str;
			var _pos = 0;
			var _buffer = 0;
			var _buflen = 0;
	
			var _this = {};
	
			_this.read = function() {
	
				while (_buflen < 8) {
	
					if (_pos >= _str.length) {
						if (_buflen == 0) {
							return -1;
						}
						throw new Error('unexpected end of file./' + _buflen);
					}
	
					var c = _str.charAt(_pos);
					_pos += 1;
	
					if (c == '=') {
						_buflen = 0;
						return -1;
					} else if (c.match(/^\s$/) ) {
						// ignore if whitespace.
						continue;
					}
	
					_buffer = (_buffer << 6) | decode(c.charCodeAt(0) );
					_buflen += 6;
				}
	
				var n = (_buffer >>> (_buflen - 8) ) & 0xff;
				_buflen -= 8;
				return n;
			};
	
			var decode = function(c) {
				if (0x41 <= c && c <= 0x5a) {
					return c - 0x41;
				} else if (0x61 <= c && c <= 0x7a) {
					return c - 0x61 + 26;
				} else if (0x30 <= c && c <= 0x39) {
					return c - 0x30 + 52;
				} else if (c == 0x2b) {
					return 62;
				} else if (c == 0x2f) {
					return 63;
				} else {
					throw new Error('c:' + c);
				}
			};
	
			return _this;
		};
	
		//---------------------------------------------------------------------
		// gifImage (B/W)
		//---------------------------------------------------------------------
	
		var gifImage = function(width, height) {
	
			var _width = width;
			var _height = height;
			var _data = new Array(width * height);
	
			var _this = {};
	
			_this.setPixel = function(x, y, pixel) {
				_data[y * _width + x] = pixel;
			};
	
			_this.write = function(out) {
	
				//---------------------------------
				// GIF Signature
	
				out.writeString('GIF87a');
	
				//---------------------------------
				// Screen Descriptor
	
				out.writeShort(_width);
				out.writeShort(_height);
	
				out.writeByte(0x80); // 2bit
				out.writeByte(0);
				out.writeByte(0);
	
				//---------------------------------
				// Global Color Map
	
				// black
				out.writeByte(0x00);
				out.writeByte(0x00);
				out.writeByte(0x00);
	
				// white
				out.writeByte(0xff);
				out.writeByte(0xff);
				out.writeByte(0xff);
	
				//---------------------------------
				// Image Descriptor
	
				out.writeString(',');
				out.writeShort(0);
				out.writeShort(0);
				out.writeShort(_width);
				out.writeShort(_height);
				out.writeByte(0);
	
				//---------------------------------
				// Local Color Map
	
				//---------------------------------
				// Raster Data
	
				var lzwMinCodeSize = 2;
				var raster = getLZWRaster(lzwMinCodeSize);
	
				out.writeByte(lzwMinCodeSize);
	
				var offset = 0;
	
				while (raster.length - offset > 255) {
					out.writeByte(255);
					out.writeBytes(raster, offset, 255);
					offset += 255;
				}
	
				out.writeByte(raster.length - offset);
				out.writeBytes(raster, offset, raster.length - offset);
				out.writeByte(0x00);
	
				//---------------------------------
				// GIF Terminator
				out.writeString(';');
			};
	
			var bitOutputStream = function(out) {
	
				var _out = out;
				var _bitLength = 0;
				var _bitBuffer = 0;
	
				var _this = {};
	
				_this.write = function(data, length) {
	
					if ( (data >>> length) != 0) {
						throw new Error('length over');
					}
	
					while (_bitLength + length >= 8) {
						_out.writeByte(0xff & ( (data << _bitLength) | _bitBuffer) );
						length -= (8 - _bitLength);
						data >>>= (8 - _bitLength);
						_bitBuffer = 0;
						_bitLength = 0;
					}
	
					_bitBuffer = (data << _bitLength) | _bitBuffer;
					_bitLength = _bitLength + length;
				};
	
				_this.flush = function() {
					if (_bitLength > 0) {
						_out.writeByte(_bitBuffer);
					}
				};
	
				return _this;
			};
	
			var getLZWRaster = function(lzwMinCodeSize) {
	
				var clearCode = 1 << lzwMinCodeSize;
				var endCode = (1 << lzwMinCodeSize) + 1;
				var bitLength = lzwMinCodeSize + 1;
	
				// Setup LZWTable
				var table = lzwTable();
	
				for (var i = 0; i < clearCode; i += 1) {
					table.add(String.fromCharCode(i) );
				}
				table.add(String.fromCharCode(clearCode) );
				table.add(String.fromCharCode(endCode) );
	
				var byteOut = byteArrayOutputStream();
				var bitOut = bitOutputStream(byteOut);
	
				// clear code
				bitOut.write(clearCode, bitLength);
	
				var dataIndex = 0;
	
				var s = String.fromCharCode(_data[dataIndex]);
				dataIndex += 1;
	
				while (dataIndex < _data.length) {
	
					var c = String.fromCharCode(_data[dataIndex]);
					dataIndex += 1;
	
					if (table.contains(s + c) ) {
	
						s = s + c;
	
					} else {
	
						bitOut.write(table.indexOf(s), bitLength);
	
						if (table.size() < 0xfff) {
	
							if (table.size() == (1 << bitLength) ) {
								bitLength += 1;
							}
	
							table.add(s + c);
						}
	
						s = c;
					}
				}
	
				bitOut.write(table.indexOf(s), bitLength);
	
				// end code
				bitOut.write(endCode, bitLength);
	
				bitOut.flush();
	
				return byteOut.toByteArray();
			};
	
			var lzwTable = function() {
	
				var _map = {};
				var _size = 0;
	
				var _this = {};
	
				_this.add = function(key) {
					if (_this.contains(key) ) {
						throw new Error('dup key:' + key);
					}
					_map[key] = _size;
					_size += 1;
				};
	
				_this.size = function() {
					return _size;
				};
	
				_this.indexOf = function(key) {
					return _map[key];
				};
	
				_this.contains = function(key) {
					return typeof _map[key] != 'undefined';
				};
	
				return _this;
			};
	
			return _this;
		};
	
		var createImgTag = function(width, height, getPixel, alt) {
	
			var gif = gifImage(width, height);
			for (var y = 0; y < height; y += 1) {
				for (var x = 0; x < width; x += 1) {
					gif.setPixel(x, y, getPixel(x, y) );
				}
			}
	
			var b = byteArrayOutputStream();
			gif.write(b);
	
			var base64 = base64EncodeOutputStream();
			var bytes = b.toByteArray();
			for (var i = 0; i < bytes.length; i += 1) {
				base64.writeByte(bytes[i]);
			}
			base64.flush();
	
			var img = '';
			img += '<img';
			img += '\u0020src="';
			img += 'data:image/gif;base64,';
			img += base64;
			img += '"';
			img += '\u0020width="';
			img += width;
			img += '"';
			img += '\u0020height="';
			img += height;
			img += '"';
			if (alt) {
				img += '\u0020alt="';
				img += alt;
				img += '"';
			}
			img += '/>';
	
			return img;
		};
	
		//---------------------------------------------------------------------
		// returns qrcode function.
	
		return qrcode;
	}();


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	  var cloud = __webpack_require__(5);
	  var locale = __webpack_require__(18);
	  __webpack_require__(84);
	
	  return Class.create(cloud.Component, {
	
	    initialize: function ($super, options) {
	      cloud.util.defaults(options, {
	        moduleName: "captcha",
	      });
	      $super(options);
	      this.render();
	    },
	
	    render: function () {
	      this.img = $("<img lang='title:click_to_change'>")
	        .attr("title", locale.get('click_to_change'))
	        .click(this.refresh.bind(this));
	
	      this.element.append(this.img).addClass("cloud-captcha");
	      this.refresh();
	    },
	
	    refresh: function () {
	      if (this.timer) {
	        clearTimeout(this.timer);
	      }
	      window.Model.captchas({
	        method: "get",
	        token: false,
	        success: function (data) {
	          var imgUrl = "/api/captchas/" + data._id + "?r=" + Math.random();
	          this.pictureId = data.pictureId;
	          this.img.attr("src", imgUrl).attr("picid", data.pictureId);
	          this.timer = setTimeout(this.refresh.bind(this), 300000);
	        }.bind(this)
	      })
	    },
	
	    getPicId: function () {
	      return this.pictureId;
	    }
	
	
	  });
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 84 */
13,
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources/DeviceTouch.rar";

/***/ })
]);


// WEBPACK FOOTER //
// index-1786d181c4cffea7e98b.js